/* HEIC-Fix 15.10.2026: iPhone-HEIC/HEIF im Browser nach JPG wandeln, sonst leere Kachel (Chrome kann HEIC nicht). */
window.apHeicFix = window.apHeicFix || function(file){
  var isH = /heic|heif/i.test(file.type||'') || /\.(heic|heif)$/i.test(file.name||'');
  if(!isH) return Promise.resolve(file);
  function lib(){
    if(window.heic2any) return Promise.resolve();
    return new Promise(function(res,rej){ var s=document.createElement('script');
      s.src='https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js'; s.onload=res; s.onerror=rej; document.head.appendChild(s); });
  }
  return lib().then(function(){ return window.heic2any({blob:file, toType:'image/jpeg', quality:0.92}); })
    .then(function(b){ if(Array.isArray(b)) b=b[0];
      return new File([b], (file.name||'foto').replace(/\.(heic|heif)$/i,'')+'.jpg', {type:'image/jpeg'}); })
    .catch(function(){
      var en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(en?'This photo is in HEIC format and could not be converted. Please share it from your gallery as JPG.':'Dieses Foto ist im HEIC-Format und konnte nicht umgewandelt werden. Bitte aus der Galerie als JPG teilen.');
      return null; });
};
(function(){

/* ═══ GLOBALES CRASH-NETZ ═══
   Faengt jeden unerwarteten JS-Fehler ab, damit ein einzelner Fehler NIE
   die ganze Kundenseite lahmlegt. Rein additiv — aendert keine Logik. */
(function(){
  var _apErrShown=false;
  function apGlobalError(msg, src){
    try{ console.error('[Arturell Crash-Netz]', msg, src||''); }catch(_){}
    if(_apErrShown) return;
    if(src && src.indexOf('arturell')===-1 && src.indexOf('dein-foto')===-1 && src!=='') return;
    _apErrShown=true;
  }
  window.addEventListener('error', function(e){
    apGlobalError(e && e.message, e && e.filename);
  });
  window.addEventListener('unhandledrejection', function(e){
    apGlobalError(e && e.reason && (e.reason.message||e.reason), 'promise');
  });
})();

/* ═══ UMBAU: Zentrale Stil-Liste (16 Stile) ═══ */
var AP_PH='data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 3"><rect width="4" height="3" fill="%23EFEAE3"/></svg>';
var AP_T = {
  de: {
    groessenvergleich:'Größenvergleich',
    sofa:'So groß sind die Formate an deiner Wand. Das Sofa ist 2 m breit.',
    noch:'Noch ', kostenlose:' kostenlose ', vorschau:'Vorschau', vorschauen:'Vorschauen',
    waehle:'Wähle dein Lieblingswerk zum Bestellen',
    vieleVorschauen:'Du hast viele Vorschauen erstellt. Wähle dein Lieblingswerk zum Bestellen ✨',
    inStilA:'✨ In ', inStilB:' verwandeln', deinStil:'deinen Stil',
    duSparst:'Du sparst ', generiere:'Generiere…',
    soWirdA:'So wird dein Foto: ', soWirdB:' Stile'
  },
  en: {
    groessenvergleich:'Size comparison',
    sofa:'See how each size looks on your wall. The sofa is about 7 feet wide.',
    noch:'', kostenlose:' free ', vorschau:'preview left', vorschauen:'previews left',
    waehle:'Choose your favorite to order',
    vieleVorschauen:"You've created lots of previews. Choose your favorite to order \u2728",
    inStilA:'\u2728 Transform into ', inStilB:'', deinStil:'your style',
    duSparst:'You save ', generiere:'Generating\u2026',
    soWirdA:"Here's your photo: ", soWirdB:' styles'
  }
};
var AP_L=(window.Shopify&&Shopify.locale?Shopify.locale.slice(0,2):'de');
var T = AP_T[AP_L] || AP_T.de;

var AP_FZ_ORIG={"oel-hell": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-oel-hell.png?v=1787078252&width=300", "oel-golden": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-oel-golden.png?v=1787078246&width=300", "aquarell": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-aquarell.png?v=1787078212&width=300", "impressionismus": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-impressionismus.png?v=1787078229&width=300", "emerald": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-emerald.png?v=1787078223&width=300", "chromaflare": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-chromaflare.png?v=1787078218&width=300", "aquarell-splash": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-aquarell-splash.png?v=1787078206&width=300", "van-gogh": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-van-gogh.png?v=1787078257&width=300", "klimt": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-klimt.png?v=1787078235&width=300", "lineart": "https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-wo9-lineart.png?v=1787078241&width=300"};
var AP_STILE_EN={'aquarell':'Watercolor','aquarell-splash':'Watercolor Splash','aquarell-hell':'Watercolor · Light','aquarell-hell-rand':'Watercolor · Border','aquarell-splash-rand':'Splash · Border','rustic-rand':'Rustic','gouache':'Gouache','oel-hell':'Oil · Light','oel-golden':'Oil · Golden','impressionismus':'Impressionism','van-gogh':'Van Gogh','klimt':'Klimt · Gold','emerald':'Emerald Muse','chromaflare':'Chromaflare','renaissance':'Renaissance','rembrandt':'Rembrandt','barock':'Baroque','royal':'King','koenigin':'Queen','ritter':'Knight','regenbogenbruecke':'Rainbow Bridge','sternenhimmel':'Starry Sky','engel':'Angel','gedenkkerze':'Memorial Candle','sonnenstrahlen':'Sunbeams','lineart':'Line Art','original':'Original · Photo Portrait'};
function apStilName(s){try{return (AP_L==='en'&&s&&AP_STILE_EN[s.id])?AP_STILE_EN[s.id]:(s?s.name:'');}catch(e){return s?s.name:'';}}
var AP_STILE = [
  {id:'aquarell',          name:'Aquarell',          img:'https://cdn.arturell.com/galerie/muttertag-geschenke--aquarell.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-aquarell.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-aquarell.png?v=1787078149&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-aquarell.jpg?v=1786367741&width=360'},
  {id:'aquarell-splash', name:'Aquarell-Splash', img:'https://cdn.arturell.com/galerie/geburtstagsgeschenke--aquarell-splash.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-aquarell-splash.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-aquarell-splash.png?v=1787078143&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-aquarell-splash.jpg?v=1786367739&width=360'},
  {id:'aquarell-hell-rand', name:'Aquarell · Rand', img:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fam26-aquarell-hell-rand.jpg?width=1080', cimg:'https://cdn.arturell.com/galerie/v19/p19-aquarell-hell-rand.jpg?v=1910d'},   /* 18.10. neu */
  {id:'aquarell-splash-rand', name:'Splash · Rand', img:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fam26-aquarell-splash-rand.jpg?width=1080', cimg:'https://cdn.arturell.com/galerie/v19/p19-aquarell-splash-rand.jpg?v=1910d'},   /* 18.10. neu */
  {id:'rustic-rand', name:'Rustic', img:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fam26-rustic-rand.jpg?width=1080', cimg:'https://cdn.arturell.com/galerie/v19/p19-rustic-rand.jpg?v=1910d'},   /* 18.10. neu */
  {id:'gouache', name:'Gouache', img:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fam26-gouache.jpg?width=1080', cimg:'https://cdn.arturell.com/galerie/v19/p19-gouache.jpg?v=1910d'},   /* 18.10. neu */
  {id:'oel-hell',          name:'Öl · Hell',         img:'https://cdn.arturell.com/galerie/hundeportrait--oel-hell.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-oel-hell.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-oel-hell.png?v=1787078193&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-oel-hell.jpg?v=1786367767&width=360'},
  {id:'impressionismus',   name:'Impressionismus',   img:'https://cdn.arturell.com/galerie/hochzeit-jahrestag--impressionismus.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-impressionismus.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-impressionismus.png?v=1787078169&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-impressionismus.jpg?v=1786367757&width=360'},
  {id:'oel-golden',        name:'Öl · Golden',       img:'https://cdn.arturell.com/galerie/geschenk-katzenliebhaber--oel-golden.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-oel-golden.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-oel-golden.png?v=1787078187&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-oel-golden.jpg?v=1786367764&width=360'},
  {id:'van-gogh', name:'Van Gogh', img:'https://cdn.arturell.com/galerie/geburtstagsgeschenke--van-gogh.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-van-gogh.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-van-gogh.png?v=1787078199&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-van-gogh.jpg?v=1786367788&width=360'},
  {id:'klimt', name:'Klimt · Gold', img:'https://cdn.arturell.com/galerie/katzenportrait--klimt.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-klimt.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-klimt.png?v=1787078175&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-klimt.jpg?v=1786367759&width=360'},
  {id:'emerald', name:'Emerald Muse', img:'https://cdn.arturell.com/galerie/katzenportrait--emerald.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-emerald.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-emerald.png?v=1787078163&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-emerald.jpg?v=1786367748&width=360'},
  {id:'chromaflare', name:'Chromaflare', img:'https://cdn.arturell.com/galerie/geschenk-katzenliebhaber--chromaflare.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-chromaflare.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-chromaflare.png?v=1787078156&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-chromaflare.jpg?v=1786367746&width=360'},
  {id:'royal',             name:'König',             img:'https://cdn.arturell.com/galerie/geschenk-hundebesitzer--royal.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-royal.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-royal.jpg?v=1786367780&width=360'},
  {id:'koenigin', name:'Königin', img:'https://cdn.arturell.com/galerie/geschenk-katzenliebhaber--koenigin.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-koenigin.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-koenigin.jpg?v=1786367762&width=360'},
  {id:'ritter', name:'Ritter', img:'https://cdn.arturell.com/galerie/geschenk-hundebesitzer--ritter.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-ritter.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-ritter.jpg?v=1786367778&width=360'},
  {id:'regenbogenbruecke', name:'Regenbogenbrücke', img:'https://cdn.arturell.com/galerie/in-gedenken--regenbogenbruecke.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-regenbogenbruecke.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-regenbogenbruecke.jpg?v=1786367770&width=360'},
  {id:'sternenhimmel', name:'Sternenhimmel', img:'https://cdn.arturell.com/galerie/in-gedenken--sternenhimmel.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-sternenhimmel.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-sternenhimmel.jpg?v=1786367785&width=360'},
  {id:'engel', name:'Engel', img:'https://cdn.arturell.com/galerie/in-gedenken--engel.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-engel.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-engel.jpg?v=1786367751&width=360'},
  {id:'gedenkkerze', name:'Gedenkkerze', img:'https://cdn.arturell.com/galerie/in-gedenken--gedenkkerze.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-gedenkkerze.jpg?v=1910d', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-gedenkkerze.jpg?v=1786367754&width=360'},
  {id:'sonnenstrahlen', name:'Sonnenstrahlen', img:'https://cdn.arturell.com/galerie/in-gedenken--sonnenstrahlen.jpg', cimg:'https://cdn.arturell.com/galerie/v19/p19-sonnenstrahlen.jpg?v=1910e', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/mix-sonnenstrahlen.jpg?v=1786367782&width=360'},
  {id:'lineart', name:'Line Art', img:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/kachel2-lineart.png?v=1786543716', cimg:'https://cdn.arturell.com/galerie/v19/p19-lineart.jpg?v=1910d', vimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-w9-lineart.png?v=1787078181&width=600', bimg:'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/kachel2-lineart.png?v=1786543716&width=360'},
];

/* ── STIL-KATEGORIEN (Filter-Chips) ── */
var AP_CAT = {
  'regenbogenbruecke':'andenken','sternenhimmel':'andenken','engel':'andenken','gedenkkerze':'andenken','sonnenstrahlen':'andenken',
  'royal':'royal','koenigin':'royal','prinz':'royal','prinzessin':'royal','ritter':'royal','admiral':'royal','herzog':'royal','viktorianisch':'royal','elisabethanisch':'royal',
  'aquarell':'kunst','aquarell-portrait':'kunst','oel-hell':'kunst','oel-golden':'kunst','impressionismus':'kunst','bleistift':'kunst','kohle':'kunst','pastell':'kunst','renaissance':'royal','barock':'royal','dark-academia':'kunst','emerald':'kunst','chromaflare':'kunst','aquarell-splash':'kunst','aquarell-hell':'kunst','aquarell-hell-rand':'kunst','aquarell-splash-rand':'kunst','rustic-rand':'kunst','gouache':'kunst','van-gogh':'kunst','klimt':'kunst','hokusai':'kunst','rembrandt':'kunst','lineart':'kunst',
  'ceo':'berufe','astronaut':'berufe','feuerwehr':'berufe','pilot':'berufe','koch':'berufe','boxer':'berufe','cowboy':'berufe','general':'berufe','gentleman':'berufe','superheld':'berufe',
  'rockstar':'berufe','musiker':'berufe','dj':'berufe','gamer':'berufe','fitness':'berufe','spa':'berufe','buecherwurm':'berufe','faulenzer':'berufe',
  'cartoon':'modern','anime':'modern','3d-animation':'modern','urban-comic':'modern','vintage-poster':'modern','kawaii':'modern','synthwave':'modern','comic-cover':'modern','strickfigur':'modern','action-figure':'modern',
  'weihnachten':'szenen','halloween':'szenen','ostern':'szenen','geburtstag':'szenen','berge':'szenen','strand':'szenen','blumenwiese':'szenen','herbstwald':'szenen','sonnenuntergang':'szenen','wiesn':'szenen'
};
var apActiveCat='alle';
/* ── DEEPLINK Schritt-2-Wizard: ?thema= zeigt nur passende Kategorie-Gruppe ── */
window.apFilterStep2ByThema=function(){
  try{
    var qs=new URLSearchParams(window.location.search);
    var p=(qs.get('thema')||qs.get('kategorie')||'').toLowerCase().trim();
    if(!p){ if(window.apAnlassGruppen)window.apAnlassGruppen(); return; }
    var ALIAS={'koeniglich':'royal','koenig':'royal','royal':'royal','adel':'royal','fun':'berufe',
      'kostueme':'berufe','kostuem':'berufe','rollen':'berufe','berufe':'berufe','helden':'berufe',
      'charakter':'berufe','hobby':'berufe',
      'kuenstlerisch':'kunst','kunst':'kunst','aquarell':'kunst','oel':'kunst','malerei':'kunst','gemaelde':'kunst',
      'andenken':'andenken','gedenken':'andenken','memorial':'andenken',
      'szenen':'szenen','anlaesse':'szenen','weihnachten':'szenen','modern':'modern','tiere':'','alle':'',
      'fahrzeuge':'kunst','fahrzeug':'kunst','auto':'kunst','autos':'kunst',
      'haeuser':'haeuser','haus':'haeuser','hauser':'haeuser','homes':'haeuser'};/* Fahrzeuge = Kunst-Stile (16.07.: Autos laufen durch bestehende Stile, kein eigener Block) */
    var target=ALIAS.hasOwnProperty(p)?ALIAS[p]:p;
    if(!target)return;
    /* Fahrzeug-Thema: Stil-Karten-Bilder auf Auto-Demos (vimg) tauschen */
    var pv=(qs.get('thema')||qs.get('kategorie')||'').toLowerCase().trim();
    if((pv==='fahrzeuge'||pv==='fahrzeug'||pv==='auto'||pv==='autos')&&typeof AP_STILE!=='undefined'){
      AP_STILE.forEach(function(st){
        if(!st.vimg)return;
        var b=document.querySelector('#ap .ap-stil-btn[data-stil="'+st.id+'"] img.ap-stil-card-img');
        if(b)b.src=st.vimg.replace('width=360','width=480');
      });
    }
    /* Fahrzeug-Thema: nur Stile mit Auto-Demobild zeigen (15.08.) */
    if((pv==='fahrzeuge'||pv==='fahrzeug'||pv==='auto'||pv==='autos')&&typeof AP_FAHRZEUG_STILE!=='undefined'){
      document.querySelectorAll('#ap .ap-stil-btn').forEach(function(k){
        var id=k.getAttribute('data-stil');
        if(AP_FAHRZEUG_STILE.indexOf(id)<0)k.style.display='none';
      });
    }
    var heads=document.querySelectorAll('#ap .ap-stil-cat-head');
    var firstShown=true;
    heads.forEach(function(h){
      var cg=h.getAttribute('data-cg');
      var grid=h.nextElementSibling;
      var show=(cg===target);
      h.style.display=show?'':'none';
      if(grid&&grid.classList.contains('ap-stile-grid'))grid.style.display=show?'':'none';
      if(show&&firstShown){h.style.marginTop='0';firstShown=false;}
    });
    /* Zusätzlich: passenden Farb-Chip auf der Bearbeitungsseite aktivieren */
    var CHIP={'royal':'royal','berufe':'berufe','kunst':'kunst','andenken':'andenken','szenen':'szenen','modern':'modern','fahrzeuge':'fahrzeuge','haeuser':'haeuser'};
    var chipCat=CHIP[target];
    if(chipCat){
      var chip=document.querySelector('#ap .ap-cat-chip[data-cat="'+chipCat+'"]');
      if(chip&&typeof apSetCat==='function')apSetCat(chip);
    }
    /* 15.08.: Bildtausch nachziehen - beim Deeplink stehen die Kacheln
       beim ersten Durchlauf noch nicht im DOM. */
    if(pv==='fahrzeuge'||pv==='fahrzeug'||pv==='auto'||pv==='autos'){
      [80,300,900].forEach(function(ms){
        setTimeout(function(){
          if(typeof window.apSwapStilBilder==='function')window.apSwapStilBilder('fahrzeuge');
        },ms);
      });
    }
  }catch(e){}
};

/* ── HAEUSER-KATEGORIE (12.08.2026) ──────────────────────────────
   Fuenf Stile mit eigenen Haus-Demobildern. Wie bei Fahrzeugen werden
   nur die Kachelbilder getauscht; zusaetzlich wird auf diese fuenf
   gefiltert, damit keine Tiermotive in der Haus-Kategorie stehen. */
var AP_HAUS_STILE = ['lineart','aquarell','van-gogh','aquarell-splash','chromaflare'];
var AP_HAUS_IMG = {
  'lineart':         'https://cdn.arturell.com/galerie/hausportrait--lineart.jpg',
  'aquarell':        'https://cdn.arturell.com/galerie/hausportrait--aquarell.jpg',
  'van-gogh':        'https://cdn.arturell.com/galerie/hausportrait--van-gogh.jpg',
  'aquarell-splash': 'https://cdn.arturell.com/galerie/hausportrait--aquarell-splash.jpg',
  'chromaflare':     'https://cdn.arturell.com/galerie/hausportrait--chromaflare.jpg'
};
function apIstHaus(cat){ return cat==='haeuser'||cat==='haus'||cat==='haeuser'; }

window.apSetCat=function(btn){
  apActiveCat=(btn&&btn.getAttribute('data-cat'))||'alle';
  var chips=document.querySelectorAll('#ap .ap-cat-chip');
  for(var i=0;i<chips.length;i++){ chips[i].classList.toggle('on', chips[i]===btn); }
  if(typeof apRenderStilGalerie==='function')apRenderStilGalerie();
  window.apSwapStilBilder(apActiveCat);
  try{ if(window.apAnlassKey&&window.apAnlassGruppen)window.apAnlassGruppen(); }catch(e){}
};
/* Stil-Kacheln je Kategorie: Fahrzeuge -> vimg, sonst zurueck auf cimg */
window.apSwapStilBilder=function(cat){
  try{
    if(typeof AP_STILE==='undefined')return;
    var v=(cat==='fahrzeuge'||cat==='fahrzeug'||cat==='auto'||cat==='autos');
    var h=apIstHaus(cat);
    AP_STILE.forEach(function(st){
      var b=document.querySelector('#ap .ap-stil-btn[data-stil="'+st.id+'"] img.ap-stil-card-img');
      if(b){
        var karte=document.querySelector('#ap .ap-stil-btn[data-stil="'+st.id+'"]');
        if(karte) karte.style.display = ((h && AP_HAUS_STILE.indexOf(st.id)<0) || (v && typeof AP_FAHRZEUG_STILE!=='undefined' && AP_FAHRZEUG_STILE.indexOf(st.id)<0)) ? 'none' : '';
        var z1=(h&&AP_HAUS_IMG[st.id])?AP_HAUS_IMG[st.id]:((v&&st.vimg)?st.vimg:(st.cimg||st.img));
        if(z1){ z1=z1.replace('width=360','width=480'); if(b.src!==z1)b.src=z1; }
        try{
          var ob=karte&&karte.querySelector('.ap-stil-orig img');
          if(ob){
            if(!ob.dataset.std) ob.dataset.std=ob.src;
            var zo=(v&&typeof AP_FZ_ORIG!=='undefined'&&AP_FZ_ORIG[st.id])?AP_FZ_ORIG[st.id]
                  :(h?'':ob.dataset.std);
            if(karte) karte.classList.toggle('fz', !!v);
            var wrap=karte.querySelector('.ap-stil-orig');
            if(h){ if(wrap)wrap.style.display='none'; }
            else { if(wrap)wrap.style.display=''; if(zo&&ob.src!==zo)ob.src=zo; }
          }
        }catch(e){}
      }
      /* Bearbeitungsseite: eigene Galerie mit .ap-sg-imgwrap, nutzt img statt cimg */
      var sg=document.querySelectorAll('#ap .ap-sg-tile[data-stil="'+st.id+'"] .ap-sg-img');
      var z2=(h&&AP_HAUS_IMG[st.id])?AP_HAUS_IMG[st.id]:((v&&st.vimg)?st.vimg:(st.cimg||st.img));
      if(z2){ z2=z2.replace('width=360','width=480');
        sg.forEach(function(e){ if(e.src!==z2)e.src=z2; }); }
    });
  }catch(e){}
};

/* GENERIERUNGS-LIMIT: Zum TESTEN auf 999, für LAUNCH auf 3 */
var MAX_GEN = 100; /* Notbremse - fuehrend ist AP_GEN_LIMIT/BONUS */
/* ── GALERIE 7-TAGE-SPEICHER (localStorage) ── */
var AP_WERKE_KEY='arturell_werke_v1';
var AP_WERKE_TTL=14*24*60*60*1000;
function apSaveWerke(){
  var payload={ts:Date.now(),genCount:st.genCount,foto:st.fotoSmall||'',items:st.artHistory};
  try{
    localStorage.setItem(AP_WERKE_KEY, JSON.stringify(payload));
    console.log('[Galerie] gespeichert: '+st.artHistory.length+' Werke'+(payload.foto?' + Foto':''));
  }catch(e){
    /* evtl. Quota — ohne Foto erneut versuchen, damit wenigstens die Werke bleiben */
    try{ payload.foto=''; localStorage.setItem(AP_WERKE_KEY, JSON.stringify(payload)); console.warn('[Galerie] Foto zu groß für Speicher, nur Werke gespeichert'); }
    catch(e2){ console.error('[Galerie] Speichern FEHLER:', e2); }
  }
}
/* Data-URL → File (zum Wiederherstellen des Foto-Objekts nach Reload, damit Re-Generierung geht) */
function apDataUrlToFile(dataUrl,name){
  try{
    var arr=dataUrl.split(','),mime=(arr[0].match(/:(.*?);/)||[])[1]||'image/jpeg';
    var bstr=atob(arr[1]),n=bstr.length,u8=new Uint8Array(n);
    while(n--){u8[n]=bstr.charCodeAt(n);}
    return new File([u8],name||'foto.jpg',{type:mime});
  }catch(e){ return null; }
}
function apLoadWerke(){
  try{
    var raw=localStorage.getItem(AP_WERKE_KEY);
    console.log('[Galerie] Laden: '+(raw?('gefunden, '+raw.length+' Zeichen'):'NICHTS gespeichert'));
    if(!raw)return;
    var data=JSON.parse(raw);
    if(!data||!data.items||!data.items.length)return;
    if(Date.now()-(data.ts||0)>AP_WERKE_TTL){localStorage.removeItem(AP_WERKE_KEY);return;}
    st.artHistory=data.items;
    st.genCount=(typeof data.genCount==='number')?data.genCount:data.items.length;
    /* Foto wiederherstellen: Thumbnail + File-Objekt (sonst broken Thumbnail + keine Re-Generierung möglich) */
    if(data.foto){ st.fotoDataUrl=data.foto; st.fotoSmall=data.foto; var _rf=apDataUrlToFile(data.foto,'foto.jpg'); if(_rf)st.foto=_rf; }
    console.log('[Galerie] wiederhergestellt: '+data.items.length+' Werke');
    if(window._apHandoffPending||/[?&](thema|kategorie)=/.test(location.search)){ return; } /* Handoff von Startseite: Daten geladen, aber Ansicht bleibt Schritt 2 (Stil wählen) */
    var ss=document.getElementById('apStileSection'); if(ss)ss.style.display='none';
    var hero=document.querySelector('#ap .ap-hero'); if(hero)hero.style.display='none';
    var rs=document.getElementById('apResultSection'); if(rs)rs.style.display='block';
    if(typeof apRenderWerke==='function'){try{apRenderWerke();}catch(e){console.error('[Galerie] Render FEHLER:',e);}}
    var last=data.items[data.items.length-1];
    /* AP-WERK-ZURUECK-2910 */ try{var _wq=new URLSearchParams(location.search).get('werk');if(_wq){for(var _wi=0;_wi<data.items.length;_wi++){if(data.items[_wi].url===_wq){last=data.items[_wi];break;}}}}catch(e){}
    try{ if(last&&last.format){var fb=document.querySelector('#ap .ap-fmt-btn[data-fmt="'+last.format+'"]');if(fb&&typeof apFmt==='function')apFmt(fb);} }catch(e){console.error('[Galerie] Format FEHLER:',e);}
    try{ if(last&&typeof apSelectWerk==='function')apSelectWerk(last.url,last.stilId,last.format); }catch(e){console.error('[Galerie] Select FEHLER:',e);}
    if(typeof apUpdateGenCounter==='function')apUpdateGenCounter();
    if(typeof aktualisierePreis==='function')aktualisierePreis();
  }catch(e){ console.error('[Galerie] Laden FEHLER:', e); }
}

/* Quer-Kategorie: Stile, die Fahrzeug-Motive koennen (Worker fahrzeug-Zweige) */
var AP_FAHRZEUG_STILE=['emerald','chromaflare','aquarell-splash','oel-hell','oel-golden','aquarell','impressionismus','van-gogh','klimt','lineart'];
/* Stil-Slider rendern */
function apRenderStilGalerie(){
  var g=document.getElementById('apStilGalerie');
  if(!g)return;
  g.innerHTML='';
  apUpdateFotoStrip();
  /* Cross-Verweis (19.07.) */
  try{
    var xb=document.getElementById('apCrossHint');
    if(!xb){
      xb=document.createElement('div');
      xb.id='apCrossHint';
      xb.style.cssText='display:flex;align-items:flex-start;gap:9px;max-width:680px;margin:18px auto 0;background:#FAF8F5;border:1px solid #E8DFD3;border-radius:12px;padding:12px 16px;font-size:13px;line-height:1.55;color:#6b625a';
      xb.innerHTML='<span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:#1A1714;color:#fff;font-family:Georgia,serif;font-size:12px;font-style:italic;font-weight:700;flex:none;margin-top:1px">i</span><span>'+((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Want several loved ones in one picture? Head to our <a href="/pages/familie" style="color:#1A1714;font-weight:700">Family page</a>.':'Mehrere Liebste in einem Bild vereinen? Das geht auf unserer <a href="/pages/familie" style="color:#1A1714;font-weight:700">Familienseite</a>.')+'</span>';
      var tb=document.getElementById('tabMaterial');var anch=tb?tb.parentElement:null;
      if(anch&&anch.parentNode){anch.parentNode.insertBefore(xb,anch.nextSibling);}else{g.parentNode.insertBefore(xb,g.nextSibling);}
    }
  }catch(e){}

  AP_STILE.forEach(function(s){
    if(apActiveCat==='fahrzeuge'){ if(AP_FAHRZEUG_STILE.indexOf(s.id)===-1)return; }
    else if(apIstHaus(apActiveCat)){ if(AP_HAUS_STILE.indexOf(s.id)<0)return; }
    else if(apActiveCat!=='alle' && (AP_CAT[s.id]||'')!==apActiveCat)return;
    if(apActiveCat==='alle' && window.apAnlassErlaubt && window.apAnlassErlaubt.indexOf(AP_CAT[s.id]||'')<0)return;   /* 19.10. */
    var w=null;
    for(var i=st.artHistory.length-1;i>=0;i--){if(st.artHistory[i].stilId===s.id){w=st.artHistory[i];break;}}
    var isGen=!!w;
    var isOn=isGen&&w.url===st.artUrl;
    var card=document.createElement('div');
    card.className='ap-sg-tile'+(isOn?' on':'');
    card.setAttribute('data-stil',s.id);
    if(isGen){card.onclick=function(){apNeuesFotoStil(s.id);};} /* FLOW v10: Klick -> Foto waehlen -> generieren */
    else{card.onclick=function(){apNeuesFotoStil(s.id);};card.style.cursor='pointer';}
    if(isGen){
      card.innerHTML=
        '<div class="ap-sg-imgwrap"><img class="ap-sg-img" crossorigin="anonymous" src="'+w.url+'" alt="'+s.name+'" loading="lazy"><span class="ap-sg-chk"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></span><span class="ap-sg-again" onclick="event.stopPropagation();if(window.apRegen)apRegen(\''+s.id+'\')" title="'+(AP_L==='en'?'Generate again':'Nochmal erzeugen')+'" style="position:absolute;right:6px;bottom:6px;width:32px;height:32px;border-radius:50%;background:#FFFFFF;color:#1A1714;border:1px solid rgba(26,23,20,.18);box-shadow:0 2px 8px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;font-size:18px;line-height:1;cursor:pointer;z-index:3">&#8635;</span></div>'+
        '<div class="ap-sg-name">'+apStilName(s)+'</div>';
    } else {
      card.innerHTML=
        '<div class="ap-sg-imgwrap"><img class="ap-sg-img" src="'+(((typeof apActiveCat!=='undefined'&&apActiveCat==='fahrzeuge')&&s.vimg)?s.vimg:(s.cimg||s.img))+'" alt="'+s.name+'" loading="lazy"><span class="ap-sg-badge">'+(AP_L==='en'?'Preview':'Vorschau')+'</span></div>'+
        '<div class="ap-sg-name">'+apStilName(s)+'</div>';
    }
    g.appendChild(card);
  });
}
function apRenderStilSlider(){apRenderStilGalerie();}
function apUpdateFotoStrip(){
  var th=document.getElementById('apFsThumb');
  var nm=document.getElementById('apFsStil');
  var src=st.fotoSmall||st.fotoDataUrl||'';
  if(th&&src){ th.onerror=function(){ if(st.fotoDataUrl&&th.src!==st.fotoDataUrl){th.onerror=null;th.src=st.fotoDataUrl;} }; th.src=src; }
  if(nm){nm.textContent=st.stilName||'';}
}
window.apToggleStile=function(){
  var w=document.getElementById('apWerkeWrap');
  var c=document.getElementById('apStileChevron');
  if(!w)return;
  var willShow=(w.style.display==='none');
  w.style.display=willShow?'block':'none';
  if(c)c.textContent=willShow?'▴':'▾';
};

/* Öffnet die 16-Stile-Galerie (statt Upload) und scrollt hin */
window.apOpenStile=function(){
  var w=document.getElementById('apWerkeWrap');
  var c=document.getElementById('apStileChevron');
  var t=document.getElementById('apStileToggle');
  if(w)w.style.display='block';
  if(c)c.textContent='▴';
  if(t&&t.scrollIntoView)t.scrollIntoView({behavior:'smooth',block:'start'});
};

/* Größenvergleich: zeigt die verfügbaren Größen maßstabsgetreu neben einer Person */
window.apSizeCompare=function(){
  var grid=document.querySelector('#ap .ap-size-grid');
  if(!grid)return;
  var btns=grid.querySelectorAll('.ap-size-btn'),S=[],i;
  for(i=0;i<btns.length;i++){
    var b=btns[i];
    if(b.offsetParent===null)continue;
    var cmEl=b.querySelector('.sz-cm'),lblEl=b.querySelector('.sz-label');
    if(!cmEl)continue;
    var roh=cmEl.textContent.trim();
    var mm=roh.match(/([\d.]+)\s*[×x]\s*([\d.]+)/);
    if(!mm)continue;
    var zoll=/[""\u201d]|\bin\b/.test(roh) && !/cm/.test(roh);
    var bw=parseFloat(mm[1]), bh=parseFloat(mm[2]);
    S.push({w:bw,h:bh,wc:zoll?bw*2.54:bw,hc:zoll?bh*2.54:bh,txt:roh,
            name:lblEl?lblEl.textContent.trim():'',sel:b.classList.contains('on')});
  }
  if(!S.length)return;
  window.apSizeCompareClose();
  var sel=0;
  for(i=0;i<S.length;i++){ if(S[i].sel) sel=i; }

  var ov=document.createElement('div');
  ov.id='apCmpOv';
  ov.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;background:rgba(20,17,14,.55);display:flex;align-items:center;justify-content:center;padding:16px';
  ov.onclick=function(e){ if(e.target===ov) window.apSizeCompareClose(); };

  var card=document.createElement('div');
  card.style.cssText='background:#fff;border-radius:16px;width:660px;max-width:100%;padding:18px 20px;position:relative;font-family:inherit;box-sizing:border-box';

  var x=document.createElement('button');
  x.type='button'; x.innerHTML='&times;';
  x.style.cssText='position:absolute;top:10px;right:10px;width:30px;height:30px;border:0;border-radius:50%;background:#F3F0EA;color:#1A1714;font-size:18px;line-height:1;cursor:pointer';
  x.onclick=function(){ window.apSizeCompareClose(); };

  var t=document.createElement('div');
  t.textContent=T.groessenvergleich;
  t.style.cssText='font-size:17px;font-weight:700;color:#1A1714;margin-bottom:2px';

  var u=document.createElement('div');
  u.textContent=T.sofa;
  u.style.cssText='font-size:12.5px;color:#8A857E;margin-bottom:12px;padding-right:26px';

  var stage=document.createElement('div');
  stage.style.cssText='background:#EFEAE3;border-radius:12px;overflow:hidden;line-height:0';

  var row=document.createElement('div');
  row.style.cssText='display:flex;gap:7px;margin-top:12px';

  card.appendChild(x); card.appendChild(t); card.appendChild(u);
  card.appendChild(stage); card.appendChild(row);
  ov.appendChild(card); document.body.appendChild(ov);

  function zeichne(){
    /* Raumfoto 2000x1152. Sofa-Aussenkanten x 385..1680 = 220 cm breit,
       Oberkante Rueckenlehne y 601.  ->  5.886 px je cm. */
    var IMG='https://cdn.arturell.com/galerie/raum-sofa.jpg';
    var SL=385, SR=1680, LEHNE_B=601, PXCM=(SR-SL)/220, MITTE=(SL+SR)/2, k;
    var maxHc=0; for(k=0;k<S.length;k++){ if(S[k].hc>maxHc) maxHc=S[k].hc; }
    /* Wand nach oben verlaengern, bis das groesste Format Platz hat */
    var noetig=(maxHc+18)*PXCM+46;
    var TOP=Math.max(0, Math.ceil(noetig-LEHNE_B));
    var VH=1152+TOP, LEHNE=LEHNE_B+TOP, UNTEN=LEHNE-18*PXCM;

    var g='<svg viewBox="0 0 2000 '+VH+'" style="display:block;width:100%;height:auto">';
    if(TOP>0){
      var F=(TOP+6)/90;
      g+='<defs><clipPath id="apCmpTop"><rect x="0" y="0" width="2000" height="'+(TOP+6)+'"/></clipPath></defs>';
      g+='<image href="'+IMG+'" x="0" y="'+(TOP-90*F)+'" width="2000" height="'+(1152*F)+'" preserveAspectRatio="none" clip-path="url(#apCmpTop)"/>';
    }
    g+='<image href="'+IMG+'" x="0" y="'+TOP+'" width="2000" height="1152"/>';

    /* gross nach klein, damit die kleinen vorne liegen */
    var idx=[]; for(k=0;k<S.length;k++) idx.push(k);
    idx.sort(function(a,b){ return (S[b].wc*S[b].hc)-(S[a].wc*S[a].hc); });
    for(k=0;k<idx.length;k++){
      var z=S[idx[k]], on=(idx[k]===sel);
      var w=z.wc*PXCM, h=z.hc*PXCM, px=MITTE-w/2, py=UNTEN-h;
      g+='<rect x="'+px+'" y="'+py+'" width="'+w+'" height="'+h+'" '+
         'fill="'+(on?'#A96153':'#FFFFFF')+'" fill-opacity="'+(on?0.90:0.30)+'" '+
         'stroke="'+(on?'#7E4237':'#1A1714')+'" stroke-width="'+(on?5:2.5)+'" stroke-opacity="0.8"/>';
      var innen=(w>190&&h>78);
      g+='<text x="'+MITTE+'" y="'+(innen?py+36:py-11)+'" text-anchor="middle" '+
         'font-size="'+(innen?28:24)+'" font-weight="600" '+
         'fill="'+(on?(innen?'#fff':'#7E4237'):'#1A1714')+'" fill-opacity="'+(on?1:0.7)+'" '+
         'font-family="-apple-system,Segoe UI,sans-serif">'+z.txt+'</text>';
    }
    g+='</svg>';
    stage.innerHTML=g;

    row.innerHTML='';
    for(k=0;k<S.length;k++){
      (function(j){
        var bt=document.createElement('button'), o=(j===sel), ROSE='#A96153';
        bt.type='button';
        bt.style.cssText='flex:1;padding:8px 2px;border-radius:10px;border:'+(o?'2px solid '+ROSE:'1px solid #E2DACE')+';background:'+(o?'#FBF3F0':'#fff')+';cursor:pointer;font-family:inherit;text-align:center';
        bt.innerHTML='<span style="display:block;font-size:13px;font-weight:700;color:'+(o?ROSE:'#1A1714')+'">'+S[j].name+'</span><span style="display:block;font-size:11px;color:'+(o?ROSE:'#8A857E')+'">'+S[j].txt+'</span>';
        bt.onclick=function(){ sel=j; zeichne(); };
        row.appendChild(bt);
      })(k);
    }
  }
  zeichne();
};

/* ── FOTO-GUIDE (16.08.) ─────────────────────────────────────────
   Gute und schlechte Beispielfotos. Bilder liegen auf R2. */
window.apFotoGuide=function(){
  window.apFotoGuideClose();
  var EN=(AP_L==='en');
  var B='https://cdn.arturell.com/galerie/fg-';
  var GUT=[['gut-portrait',EN?'Close up, face sharp':'Nah dran, Gesicht scharf'],
           ['gut-hund',EN?'Calm background':'Ruhiger Hintergrund'],
           ['gut-paar',EN?'Soft daylight':'Weiches Tageslicht']];
  var SCHLECHT=[['schlecht-weit',EN?'Too far away':'Zu weit weg'],
                ['schlecht-unscharf',EN?'Blurry or dark':'Verwackelt oder dunkel'],
                ['schlecht-gruppe',EN?'Faces too small':'Gesichter zu klein']];

  var ov=document.createElement('div');
  ov.id='apFgOv';
  ov.style.cssText='position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483000;background:rgba(20,17,14,.55);display:flex;align-items:center;justify-content:center;padding:16px;overflow-y:auto';
  ov.onclick=function(e){ if(e.target===ov) window.apFotoGuideClose(); };

  function reihe(liste,farbe,titel,text){
    var h='<div style="margin-bottom:16px"><div style="display:flex;align-items:center;gap:8px;margin-bottom:7px">'+
      '<span style="display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background:'+farbe+';color:#fff;font-size:13px;font-weight:700;flex:none">'+(farbe==='#2E7D5B'?'\u2713':'\u2715')+'</span>'+
      '<span style="font-size:14.5px;font-weight:700;color:#1A1714">'+titel+'</span></div>'+
      '<div style="font-size:12.5px;color:#8A857E;margin-bottom:9px;line-height:1.55">'+text+'</div>'+
      '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px">';
    liste.forEach(function(x){
      h+='<div><img src="'+B+x[0]+'.png?width=320" alt="'+x[1]+'" loading="lazy" '+
         'style="width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:9px;display:block;background:#F1EFEA">'+
         '<div style="font-size:11.5px;color:#6b625a;text-align:center;margin-top:5px">'+x[1]+'</div></div>';
    });
    return h+'</div></div>';
  }

  var card=document.createElement('div');
  card.style.cssText='background:#fff;border-radius:16px;width:620px;max-width:100%;padding:20px 22px;position:relative;font-family:inherit;box-sizing:border-box;margin:auto';
  card.innerHTML=
    '<button type="button" onclick="window.apFotoGuideClose()" style="position:absolute;top:11px;right:11px;width:30px;height:30px;border:0;border-radius:50%;background:#F3F0EA;color:#1A1714;font-size:18px;line-height:1;cursor:pointer">&times;</button>'+
    '<div style="font-size:17px;font-weight:700;color:#1A1714;margin-bottom:3px">'+(EN?'Photo guide':'Foto-Guide')+'</div>'+
    '<div style="font-size:12.5px;color:#8A857E;margin-bottom:15px;padding-right:26px">'+
      (EN?'The better the photo, the better your artwork.':'Je besser das Foto, desto besser dein Kunstwerk.')+'</div>'+
    reihe(GUT,'#2E7D5B',EN?'Works well':'Gut so',
      EN?'Close up, faces sharp and well lit. Calm background. Group photos welcome when every face is easy to see.'
        :'Nah dran, Gesichter scharf und gut ausgeleuchtet. Ruhiger Hintergrund. Gruppenfotos gern, wenn jedes Gesicht gut zu sehen ist.')+
    reihe(SCHLECHT,'#B4453A',EN?'Better avoid':'Lieber nicht',
      EN?'Taken from far away, blurry or dark. Tiny faces or sunglasses. Scans and photos of photos.'
        :'Zu weit weg, verwackelt oder dunkel. Winzige Gesichter oder Sonnenbrillen. Scans und abfotografierte Bilder.');

  ov.appendChild(card); document.body.appendChild(ov);
};
window.apFotoGuideClose=function(){
  var o=document.getElementById('apFgOv'); if(o&&o.parentNode) o.parentNode.removeChild(o);
};

window.apSizeCompareClose=function(){
  var o=document.getElementById('apCmpOv'); if(o&&o.parentNode) o.parentNode.removeChild(o);
  var m=document.getElementById('apSizeModal'); if(m) m.style.display='none';
};

/* Klick auf Stil im Slider → vorhandenes Werk anzeigen ODER neu generieren */
window.apStilSliderClick=function(stilId){
  if(st.busy)return;
  var existing=null;
  for(var i=0;i<st.artHistory.length;i++){
    if(st.artHistory[i].stilId===stilId){existing=st.artHistory[i];break;}
  }
  if(existing){apSelectWerk(existing.url,stilId,existing.format);return;}
  if(st.genCount>=MAX_GEN){apShowLimitHint();return;}
  var s=null;
  for(var j=0;j<AP_STILE.length;j++){if(AP_STILE[j].id===stilId){s=AP_STILE[j];break;}}
  if(!s)return;
  st.stil=s.id;st.stilName=apStilName(s);
  apRenderStilSlider();
  apGen();
};

/* Bereits generierten Stil NOCHMAL generieren (Variante) — überspringt die Auswahl-Logik */
window.apRegen=function(stilId){
  if(st.busy)return;
  if(st.genCount>=MAX_GEN){apShowLimitHint();return;}
  var s=null;
  for(var j=0;j<AP_STILE.length;j++){if(AP_STILE[j].id===stilId){s=AP_STILE[j];break;}}
  if(!s)return;
  st.stil=s.id;st.stilName=apStilName(s);
  apGen();
};

/* Neues Foto aus der Ergebnis-Galerie: merkt sich den Stil, oeffnet den Datei-Dialog.
   Nach Foto-Wahl + Format-Erkennung wird DIREKT generiert (kein Zurueckwerfen zur Upload-Ansicht). */
window.apNeuesFotoStil=function(stilId){
  st.pendingStil=stilId;
  var fi=document.getElementById('apFileInput');
  if(fi){ fi.value=''; fi.click(); }
};

/* Counter aktualisieren */
function apUpdateGenCounter(){
  var el=document.getElementById('apGenCounter');
  if(!el)return;
  var rest=MAX_GEN-st.genCount;
  if(rest>0){
    el.textContent=T.noch+rest+T.kostenlose+(rest===1?T.vorschau:T.vorschauen);
    el.classList.remove('is-bestellen');
  } else {
    el.textContent=T.waehle;
    el.classList.add('is-bestellen');
  }
}
function apShowLimitHint(){
  var t=document.getElementById('apLimitToast');
  if(!t){
    t=document.createElement('div');
    t.id='apLimitToast';
    t.style.cssText='position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1A1714;color:#fff;padding:13px 22px;border-radius:12px;font-size:13px;font-weight:600;z-index:99999;box-shadow:0 8px 32px rgba(0,0,0,.25);opacity:0;transition:opacity .3s;pointer-events:none;max-width:88vw;text-align:center;line-height:1.3';
    document.body.appendChild(t);
  }
  t.textContent=T.vieleVorschauen;
  requestAnimationFrame(function(){t.style.opacity='1';});
  clearTimeout(t._ht);
  t._ht=setTimeout(function(){t.style.opacity='0';},3500);
}

/* Deine Werke Galerie rendern */
function apRenderWerke(){apRenderStilGalerie();apRenderDeineWerke();}

/* ── DEINE WERKE: alle Generierungen des Kunden (neueste zuerst), 14 Tage ── */
function apRenderDeineWerke(){
  var wrap=document.getElementById('apDeineWerke');
  var row=document.getElementById('apDwRow');
  var cnt=document.getElementById('apDwCount');
  var strip=document.getElementById('apFotostrip');
  if(!wrap||!row)return;
  if(!st.artHistory)st.artHistory=[];
  if(strip)strip.style.display='none';
  wrap.style.display='block';
  if(cnt)cnt.textContent=st.artHistory.length?('('+st.artHistory.length+')'):'';
  if(!st.artHistory.length){row.innerHTML='';return;}
  var html='';
  for(var i=st.artHistory.length-1;i>=0;i--){
    var w=st.artHistory[i];
    var on=(w.url===st.artUrl)?' on':'';
    html+='<div class="ap-dw-item'+on+'" onclick="apSelectWerk(\''+w.url+'\',\''+w.stilId+'\',\''+(w.format||'')+'\')">'+
          '<div class="ap-dw-imgwrap"><img class="ap-dw-img" crossorigin="anonymous" src="'+w.url+'" alt="'+(AP_L==="en"&&AP_STILE_EN[w.stilId]?AP_STILE_EN[w.stilId]:(w.stil||""))+'" loading="lazy"></div>'+
          '<div class="ap-dw-name">'+(AP_L==="en"&&AP_STILE_EN[w.stilId]?AP_STILE_EN[w.stilId]:(w.stil||""))+'</div>'+
          '</div>';
  }
  row.innerHTML=html;
}

/* Werk aus Galerie auswählen → anzeigen, KEIN Versuch */
window.apSelectWerk=function(url,stilId,format){
  /* FIX 19.07.: Text ist globaler State und blieb beim Werk-Wechsel kleben —
     dadurch stand der Name eines Werks auf allen anderen. Beim Wechsel leeren. */
  try{
    if(st.pers){ st.pers.line1=''; st.pers.line2=''; }
    var _p1=document.getElementById('apPersLine1'); if(_p1)_p1.value='';
    var _p2=document.getElementById('apPersLine2'); if(_p2)_p2.value='';
  }catch(e){ console.error('[Text-Reset] FEHLER:', e); }
  st.artUrl=url;
  for(var i=0;i<AP_STILE.length;i++){
    if(AP_STILE[i].id===stilId){st.stil=AP_STILE[i].id;st.stilName=apStilName(AP_STILE[i]);break;}
  }
  /* FIX 11.07: Format des ausgewaehlten Werks uebernehmen — sonst bleibt "An der Wand"
     auf dem zuletzt genutzten Format haengen (z.B. quer vom Fahrzeug-Test), egal welches
     Werk als naechstes angeklickt wird. */
  if(format && st.format!==format){
    var fb=document.querySelector('#ap .ap-fmt-btn[data-fmt="'+format+'"]');
    /* PIPE v3: Format-Sync OHNE Tab-Sprung — der Auto-Sprung in apFmt ist nur fuer den manuellen Toggle gedacht */
    window._apSelecting=true;
    try{ if(fb && typeof apFmt==='function')apFmt(fb); }catch(e){}
    window._apSelecting=false;
  }
  var badge=document.getElementById('apStilBadge');
  if(badge)badge.textContent=st.stilName;
  var img=document.getElementById('apResultImg');
  img.crossOrigin='anonymous';
  function _apArtReadyClean(){
    st.artImg=img;
    _bgCache=null;_bgCacheKey='';_roomCache=null;_roomCacheKey='';
    renderCanvas();apDrawRoom();
    /* PIPE v2: Wand-Tab aktiv -> Mockup fuers frisch geladene Werk anfordern */
    var _pm=document.getElementById('paneMaterial');
    if(_pm&&_pm.classList.contains('on')&&typeof window.apDrawMockup==='function')window.apDrawMockup();
  }
  img.onload=_apArtReadyClean;
  img.onerror=function(){ st.artImg=img; };
  img.src=url;
  /* Cache-Fix (Mobile): Bild schon geladen -> onload feuert nicht -> st.artImg direkt setzen, OHNE Tab zu wechseln */
  if(img.complete && img.naturalWidth>0){
    st.artImg=img;
    _bgCache=null;_bgCacheKey='';_roomCache=null;_roomCacheKey='';
    if(typeof renderCanvas==='function')renderCanvas();
  }
  /* PIPE v1: EIN zentraler Refresh nach dem Layout-Umbau (Format/ap-quer ist gesetzt):
     Vorschau neu einpassen + falls Wand-Tab aktiv, Mockup fuers NEUE Werk anfordern.
     Behebt: (a) Erst-Klick rendert mit altem Layout, (b) Wand zeigt Vorgaenger-Werk. */
  try{
    requestAnimationFrame(function(){
      if(st.artImg&&typeof renderCanvas==='function')renderCanvas();
      var _pm=document.getElementById('paneMaterial');
      if(_pm&&_pm.classList.contains('on')&&typeof window.apDrawMockup==='function')window.apDrawMockup();
    });
  }catch(e){}
  apRenderStilSlider();
  apRenderWerke();
};
/* ═══ ENDE UMBAU JS-Logik ═══ */

var st=window.st={
  foto:null,fotoDataUrl:null,
  stil:'aquarell',stilName:'Aquarell',
  size:'m',price:74.95,was:119.95,
  format:'hoch',
  material:'canvas',farbe:'black',
  artUrl:null,artImg:null,
  busy:false,
  pers:{line1:'',line2:'',font:'',vorlage:'',pos:'auto',nameAn:false,datumAn:false,calc:null},
  persOpen:false,
  roomOrientation:'hoch',
  genCount:0,          /* Zählt generierte Kunstwerke */
  artHistory:[],       /* Speichert alle generierten URLs + Stil */
  fotoRatio:null       /* Seitenverhältnis des hochgeladenen Fotos */
};

/* ── PERFORMANCE CACHE ──
   Bild+Wasserzeichen werden EINMAL gerendert und gecacht.
   Beim Tippen wird nur der Cache kopiert + Text neu gezeichnet. */
var _bgCache=null;       /* Offscreen-Canvas: Bild+Wasserzeichen (Vorschau) */
var _bgCacheKey='';      /* Key: erkennt ob Neu-Render nötig (Bild/Größe geändert) */
var _roomCache=null;     /* Offscreen-Canvas: Room-Bild+Kunstwerk */
var _roomCacheKey='';
var _overlayCache=null;  /* Offscreen: Wand-Overlay-Bild (Glas/Rahmen-Schatten) */
var _overlayCacheUrl='';
var _rafPending=false;   /* requestAnimationFrame Throttle */

/* ── FONTS ── */
var FM={
  playfair:'"Playfair Display",Georgia,serif',
  dancing:'"Dancing Script",cursive',
  inter:'"Inter",sans-serif',
  cormorant:'"Cormorant Garamond",Georgia,serif',
  josefin:'"Josefin Sans",sans-serif',
  pacifico:'Pacifico,cursive',
  playwrite:'"Playwrite US Trad",cursive'
};

/* ── UPLOAD ── */
var fi=document.getElementById('apFileInput');
var uploadBox=document.getElementById('apUploadBox');

fi.addEventListener('change',function(e){
  var f=e.target.files[0];if(!f)return;
  st.foto=f;
  var r=new FileReader();
  r.onload=function(ev){
    /* ── apCropHook: erst Ausschnitt waehlen, dann normaler Flow ── */
    var _origResult = ev.target.result;
    var _preImg = new Image();
    _preImg.onload = function(){
      var _ratio = _preImg.width/_preImg.height;
      var _fmt = (_ratio >= 1.0) ? 'quer' : 'hoch';  /* Foto entscheidet: breiter-als-hoch -> quer */
      if (typeof window.apOpenCrop === 'function') {
        window.apOpenCrop(_origResult, _fmt, function(cropped){
          ev.target.result = cropped;
          /* Ausschnitt in ALLE Bildquellen -> Gemini bekommt den Crop, nicht das Original */
          st.fotoDataUrl = cropped;
          st.fotoSmall = cropped;
          try { var _cf = apDataUrlToFile(cropped, 'foto.jpg'); if(_cf) st.foto = _cf; } catch(e){}
          _apUploadProceed(ev);
        });
      } else {
        _apUploadProceed(ev);
      }
    };
    var _apDecTry=false;
    _preImg.onerror = function(){
      /* AP-UPLOAD-DECODE-2910: zweiter Versuch ueber Objekt-URL + Verkleinern, keine Meldung bei offenem Ausschnitt-Fenster */
      if(!_apDecTry && f){ _apDecTry=true; try{ var _u=URL.createObjectURL(f), _i2=new Image();
        _i2.onload=function(){ try{ var _k=Math.min(1,4000/Math.max(_i2.naturalWidth,_i2.naturalHeight)); var _c=document.createElement('canvas'); _c.width=Math.round(_i2.naturalWidth*_k); _c.height=Math.round(_i2.naturalHeight*_k); _c.getContext('2d').drawImage(_i2,0,0,_c.width,_c.height); URL.revokeObjectURL(_u); _origResult=_c.toDataURL('image/jpeg',0.92); _preImg.src=_origResult; }catch(_e){ URL.revokeObjectURL(_u); _preImg.onerror(); } };
        _i2.onerror=function(){ URL.revokeObjectURL(_u); _preImg.onerror(); };
        _i2.src=_u; return; }catch(_e){} }
      try{ var _cm=document.getElementById('apCropModal'); if(_cm && _cm.style.display==='flex') return; }catch(_e){}
      /* HEIC/defekte Datei: ohne Meldung ist der Upload ein stummer Toter —
         kein Crop, keine Stile, kein Hinweis (Fund 21.08.). */
      st.foto=null;
      var _en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(_en?'This image format is not supported (e.g. HEIC). Please choose a JPG or PNG photo.':'Dieses Bildformat wird nicht unterstützt (z. B. HEIC). Bitte wähle ein Foto als JPG oder PNG.');
    };
    _preImg.src = _origResult;
  };
  function _apUploadProceed(ev){
  // Room-Bild sofort preloaden (verhindert 1-Sek Delay nach Generation)
  (function(){
    try{
      var rooms=[
        'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/canvas_hoch_livingroom3.jpg',
        'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/canvas_quer_livingroom8.jpg'
      ];
      rooms.forEach(function(url){var i=new Image();i.src=url;});
    }catch(e){}
  })();
    st.fotoDataUrl=ev.target.result;
    /* Foto-Seitenverhältnis erkennen */
    var tmpImg=new Image();
    tmpImg.onload=function(){
      st.fotoRatio=tmpImg.width/tmpImg.height;
      /* kompaktes Foto (max 800px) für localStorage-Persistenz — Thumbnail + Re-Generierung nach Reload */
      try{
        var _M=800,_w=tmpImg.width,_h=tmpImg.height;
        if(_w>_M||_h>_M){ if(_w>_h){_h=Math.round(_h*_M/_w);_w=_M;} else {_w=Math.round(_w*_M/_h);_h=_M;} }
        var _sc=document.createElement('canvas');_sc.width=_w;_sc.height=_h;
        _sc.getContext('2d').drawImage(tmpImg,0,0,_w,_h);
        st.fotoSmall=_sc.toDataURL('image/jpeg',0.82);
      }catch(e){ st.fotoSmall=null; }
      /* ── FORMAT: DAS FOTO ENTSCHEIDET (kein Umschalten, wie Wettbewerb) ── */
      var btnHoch=document.querySelector('#ap .ap-fmt-btn[data-fmt="hoch"]');
      var btnQuer=document.querySelector('#ap .ap-fmt-btn[data-fmt="quer"]');
      if(btnHoch&&btnQuer){
        var fotoFmt = (st.fotoRatio>=1.0) ? 'quer' : 'hoch';  /* breiter-als-hoch -> quer */
        var fotoBtn = (fotoFmt==='quer') ? btnQuer : btnHoch;
        /* Anzeige: nur das passende Format sichtbar, das andere ausblenden */
        btnHoch.style.display=(fotoFmt==='hoch')?'':'none';
        btnQuer.style.display=(fotoFmt==='quer')?'':'none';
        if(st.format!==fotoFmt && typeof apFmt==='function') apFmt(fotoBtn);
      }
      /* Neues Foto aus Galerie im gewaehlten Stil → sofort generieren (Format ist jetzt gesetzt) */
      if(st.pendingStil){
        var _pid=st.pendingStil; st.pendingStil=null;
        setTimeout(function(){ if(typeof apRegen==='function') apRegen(_pid); }, 30);
      }
    };
    tmpImg.src=ev.target.result;

    /* ── MOTIV-ERKENNUNG beim Upload → Stile ausgrauen ── */
    (function(){
      try {
        var dataUrl = ev.target.result;
        fetch('https://arturell-preview.arturell.workers.dev', {
          method: 'POST',
          headers: {'Content-Type':'application/json'},
          body: JSON.stringify({image: dataUrl, stil: 'aquarell', format: 'hoch', motivOnly: true})
        })
        .then(function(r){return r.json();})
        .then(function(data){
          var motiv = data.motiv || 'person';
          st.motiv = motiv;
          /* ── MEHRTIER-FORMAT (v2): Zwang entfernt. Foto-Ausrichtung entscheidet.
             Beide Formate bleiben waehlbar; hochkant Foto -> hoch, quer Foto -> quer.
             Kunde kann jederzeit manuell wechseln. ── */
          /* (bewusst kein Format-Zwang mehr bei mehreren Tieren) */
          /* Inkompatible Stile pro Motiv */
          var NUR_LEBEWESEN = ['aquarell-portrait','royal','dark-academia','action-figure','ceo','strickfigur','regenbogenbruecke','feuerwehr','pilot','koch','rockstar','boxer','wiesn','cowboy','general','gentleman'];
          var inkompatibel = {
            'tier':     [],
            'person':   ['regenbogenbruecke'],
            'paar':     ['regenbogenbruecke'],
            'gruppe':   ['regenbogenbruecke','action-figure'],
            'baby':     ['regenbogenbruecke'],
            'fahrzeug': NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']),
            'ort':      NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel']),
            'gebaeude': NUR_LEBEWESEN.concat(['berge','strand','blumenwiese','weihnachten','sternenhimmel'])
          };
          var sperren = inkompatibel[motiv] || [];
          /* 19.07.: Regenbogenbruecke fuer alle Menschen-Motive freigegeben (Niklas) */
          sperren = sperren.filter(function(x){ return x!=='regenbogenbruecke'; });
          /* 19.07.: Regenbogenbruecke fuer alle Menschen-Motive freigegeben (Niklas) */
          sperren = sperren.filter(function(x){ return x!=='regenbogenbruecke'; });
          document.querySelectorAll('#ap .ap-stil-btn').forEach(function(btn){
            var stil = btn.getAttribute('data-stil');
            if(sperren.indexOf(stil) > -1){
              btn.classList.add('ap-stil-disabled');
              btn.style.opacity='0.35';
              btn.style.pointerEvents='none';
              btn.title='Nicht für dieses Motiv geeignet';
              /* Falls aktiv → auf Aquarell wechseln */
              if(btn.classList.contains('on')){
                btn.classList.remove('on');
                document.querySelector('#ap .ap-stil-btn[data-stil="aquarell"]').classList.add('on');
                st.stil='aquarell';
              }
            } else {
              btn.classList.remove('ap-stil-disabled');
              btn.style.opacity='';
              btn.style.pointerEvents='';
              btn.title='';
            }
          });
          /* Motiv-Badge anzeigen */
          var motivLabels = {
            'tier':'🐾 Tier erkannt','person':'👤 Person erkannt','paar':'👫 Paar erkannt',
            'baby':'👶 Baby erkannt','gruppe':'👥 Gruppe erkannt','fahrzeug':'🚗 Fahrzeug erkannt',
            'ort':((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'🏙 Location detected':'🏙 Ort erkannt'),'gebaeude':((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'🏠 Building detected':'🏠 Gebäude erkannt')
          };
          var badge = document.getElementById('apMotivBadge');
          if(badge) { badge.textContent = motivLabels[motiv]||''; badge.style.display='block'; }
        })
        .catch(function(){});
      } catch(e){}
    })();

    var prev=document.getElementById('apUploadPreview');
    prev.src=ev.target.result;
    prev.style.display='block';
    document.getElementById('apUploadPH').style.display='none';
    document.getElementById('apUploadChange').style.display='block';
    uploadBox.classList.add('has-file');
    if(!st.pendingStil){
      var ss=document.getElementById('apStileSection');
      ss.style.display='block';
      /* 18.07.: Hero nach Upload komplett weg, kompakte Foto-Leiste oben in der Stil-Sektion */
      window.apTopBarZeig = window.apTopBarZeig || function(src){
        var ss2=document.getElementById('apStileSection'); if(!ss2) return;
        var bar=document.getElementById('apTopBar');
        if(!bar){
          bar=document.createElement('div');
          bar.id='apTopBar';
          bar.style.cssText='display:flex;align-items:center;gap:12px;max-width:680px;margin:0 auto 18px;padding:10px 14px;background:#FAF8F5;border:1px solid #E8DFD3;border-radius:14px';
          bar.innerHTML='<img id="apTopBarImg" style="width:44px;height:44px;object-fit:cover;border-radius:10px;display:block" alt="">'
            +'<div style="font-size:13px;font-weight:700;color:#1A1714;flex:1">'+((AP_L==='en')?'Your photo is uploaded':'Dein Foto ist hochgeladen')+'</div>'
            +'<button type="button" id="apTopBarChange" style="border:1px solid #1A1714;background:transparent;color:#1A1714;font-size:12px;font-weight:700;padding:7px 14px;border-radius:20px;cursor:pointer;white-space:nowrap">'+((AP_L==='en')?'Choose another photo':'Anderes Foto w&auml;hlen')+'</button>';
          ss2.insertBefore(bar, ss2.firstChild);
          var b=document.getElementById('apTopBarChange');
          if(b)b.addEventListener('click',function(){ var fi=document.getElementById('apFileInput'); if(fi)fi.click(); });
        }
        var im=document.getElementById('apTopBarImg'); if(im&&src)im.src=src;
        bar.style.display='flex';
      };
      var heroWeg=document.querySelector('#ap .ap-hero'); if(heroWeg)heroWeg.style.display='none';
      window.apTopBarZeig(ev.target.result);
      if(window.apFilterStep2ByThema)apFilterStep2ByThema();
      setTimeout(function(){ss.scrollIntoView({behavior:'auto',block:'start'});},60);
    }
  };
  window.apHeicFix(f).then(function(f2){ if(!f2) return; f=f2; r.readAsDataURL(f2); });
});

uploadBox.addEventListener('dragover',function(e){e.preventDefault();uploadBox.style.borderColor='var(--blush)'});
uploadBox.addEventListener('dragleave',function(){uploadBox.style.borderColor=''});
uploadBox.addEventListener('drop',function(e){
  e.preventDefault();
  var f=e.dataTransfer.files[0];
  if(f&&f.type.startsWith('image/')){
    fi.files=e.dataTransfer.files;
    fi.dispatchEvent(new Event('change'));
  }
});

/* ── LADE-OVERLAY ── */
var _loadTimer=null;
var _loadStep=0;
var _loadSteps=(AP_L==='en')?[
    {emoji:'🎬',msg:'Your artwork is taking shape …',pct:4},
    {emoji:'📸',msg:'Analysing your photo ...',pct:8},
    {emoji:'🎨',msg:'AI is choosing the perfect style ...',pct:18},
    {emoji:'✏️',msg:'First brushstrokes ...',pct:30},
    {emoji:'🖌️',msg:'Working out the details ...',pct:44},
    {emoji:'✨',msg:'Optimising colours and contrast ...',pct:58},
    {emoji:'🖼️',msg:'Finalising your artwork ...',pct:72},
    {emoji:'🔍',msg:'Quality check in progress ...',pct:84},
    {emoji:'⏳',msg:'Almost there, just a moment ...',pct:92},
    {emoji:'🎉',msg:'Nearly done …',pct:97}
  ]:[
    {emoji:'🎬',msg:'Dein Werk entsteht …',pct:4},
    {emoji:'📸',msg:'Foto wird analysiert ...',pct:8},
    {emoji:'🎨',msg:'KI wählt den perfekten Stil ...',pct:18},
    {emoji:'✏️',msg:'Erste Pinselstriche ...',pct:30},
    {emoji:'🖌️',msg:'Details werden ausgearbeitet ...',pct:44},
    {emoji:'✨',msg:'Farben und Kontraste optimieren ...',pct:58},
    {emoji:'🖼️',msg:'Kunstwerk wird finalisiert ...',pct:72},
    {emoji:'🔍',msg:'Qualitätsprüfung läuft ...',pct:84},
    {emoji:'⏳',msg:'Fast fertig, noch einen Moment ...',pct:92},
    {emoji:'🎉',msg:'Gleich fertig …',pct:97}
  ];
var _loadSub=(AP_L==='en')?['Museum quality · lightfast & vivid','One of a kind · made just for you','Free preview · no sign-up','Ready to hang in '+(location.hostname.indexOf('us.')===0?'4 to 8':'4 to 7')+' business days','20+ styles · one signature']:['Galerie-Qualität · lichtecht & brillant','Ein Unikat · entsteht gerade nur für dich','Kostenlose Vorschau · keine Anmeldung','Fertig zum Aufhängen in 4 bis 7 Werktagen','Über 20 Stile · eine Handschrift'];
var _loadSubStep=0,_loadSubTimer=null;
function apLadeSubStep(){
  var el=document.getElementById('apLoadSub'); if(!el)return;
  el.style.opacity='0';
  setTimeout(function(){ var _sub=_loadSubAktiv||_loadSub; _loadSubStep=(_loadSubStep+1)%_sub.length; el.textContent=_sub[_loadSubStep]; el.style.opacity='1'; },500);
}
/* AP_MEMORIAL_LOAD: ruhige Lade-Variante fuer Andenken-Stile (Weiche nur Anzeige, keine Logik-AEnderung) */
var _memLoadSteps=(AP_L==='en')?[
    {emoji:'',msg:'Your picture is coming to life. We are taking our time.',pct:10},
    {emoji:'',msg:'Composition, light and brushwork are being built up.',pct:40},
    {emoji:'',msg:'The final details are emerging.',pct:75},
    {emoji:'',msg:'Almost ready.',pct:94}
  ]:[
    {emoji:'',msg:'Dein Bild entsteht, wir nehmen uns einen Moment Zeit.',pct:10},
    {emoji:'',msg:'Komposition, Licht und Pinselstruktur werden aufgebaut.',pct:40},
    {emoji:'',msg:'Die letzten Details entstehen.',pct:75},
    {emoji:'',msg:'Fast fertig.',pct:94}
  ];
var _memLoadSub=(AP_L==='en')?['A picture that stays.','Free preview \u00b7 take your time deciding']:['Ein Bild, das bleibt.','Kostenlose Vorschau \u00b7 du entscheidest in Ruhe'];
function apIstAndenken(){ try{ return (AP_CAT[st.stil]||'')==='andenken'; }catch(e){ return false; } }
function apLadeVideoWahl(){
  var v=document.getElementById('apLoadVideo'), src=document.getElementById('apLoadVideoSrc');
  if(!v||!src) return;
  var soll=apIstAndenken()? v.getAttribute('data-memorial') : v.getAttribute('data-default');
  if(src.getAttribute('src')!==soll){ src.setAttribute('src',soll); try{v.load();v.play().catch(function(){});}catch(e){} }
}
/* ── 25.10.2026 STUFE 1: Hinweis im Ladefenster + Zaehlstellen start/weg ──
   Bis der App-Wechsel-Fix (Job-Abholung) live ist, bricht ein App-Wechsel am
   Handy die Generierung ab. Darum klar sagen: Seite offen lassen.
   AP_LADE_DAUER nach der Stoppuhr-Messung anpassen. */
var AP_LADE_DAUER=(AP_L==='en')?'about a minute':'etwa eine Minute';   /* AP-LADEBALKEN-V2-2910: gemessen 29.10. 56,5 bis 59,4 s */
var AP_LADE_SEK=60;
function apLadeErwartet(){ return AP_LADE_SEK; }
function apLadeBalken(){ var bar=document.getElementById('apLoadBar'); if(!bar||!window.__apLadeT0) return; var t=(Date.now()-window.__apLadeT0)/1000, E=apLadeErwartet(), p=(t<E)? 92*t/E : 92+6*(1-Math.exp(-(t-E)/30)); bar.style.width=p.toFixed(1)+'%'; var pe=document.getElementById('apLbPct'); if(pe) pe.textContent=Math.floor(p); var ze=document.getElementById('apLbZeit'); if(ze){ var r=Math.ceil(E-t); ze.textContent=(r>3)? ((AP_L==='en')?'about '+r+' seconds left':'noch etwa '+r+' Sekunden') : ((AP_L==='en')?'Almost done, final details':'Gleich fertig, letzte Details'); } }
function apLadeHinweis(){
  try{
    var ov=document.getElementById('apLoadOverlay'); if(!ov) return;
    var h=document.getElementById('apLoadHinweis');
    if(!h){
      h=document.createElement('div'); h.id='apLoadHinweis';
      h.setAttribute('style','margin:16px auto 0;max-width:340px;font:600 14px/1.5 Inter,system-ui,sans-serif;color:#FAF7F2;text-align:center;text-shadow:0 1px 6px rgba(0,0,0,.55);background:rgba(0,0,0,.30);padding:10px 16px;border-radius:12px');
      (ov.querySelector('.ap-load-inner')||ov).appendChild(h);
    }
  var _d=AP_LADE_DAUER;
    h.setAttribute('data-dauer', _d);
    h.textContent=(AP_L==='en')
      ? 'Your artwork is being created. This takes '+_d+'. Please stay on this page until it\u2019s ready.'
      : 'Dein Kunstwerk entsteht. Das dauert '+_d+'. Bitte bleib so lange auf dieser Seite.';
    if(window.apZaehl && !window.__apOhneStart) window.apZaehl('start');
  }catch(e){}
}
if(!window.__apWegZaehler){ window.__apWegZaehler=true;
  document.addEventListener('visibilitychange', function(){
    try{
      if(document.visibilityState!=='hidden') return;
      var ov=document.getElementById('apLoadOverlay'), mo=document.getElementById('apfMergeOv');
      if((ov&&ov.classList.contains('on'))||(mo&&mo.style.display!=='none')){ if(window.apZaehl) window.apZaehl('weg'); }
    }catch(e){}
  });
}
function apLadeStart(){
  if(_loadTimer){clearInterval(_loadTimer);_loadTimer=null;}
  _loadStep=0;
  var _mem=apIstAndenken();
  _loadStepsAktiv=_mem? _memLoadSteps : _loadSteps;
  _loadSubAktiv=_mem? _memLoadSub : _loadSub;
  apLadeVideoWahl();
  var _lt=document.querySelector('#apLoadOverlay .ap-load-title');
  if(_lt) _lt.textContent=(AP_L==='en')?(_mem?'Your picture is coming to life':'Your masterpiece is coming to life'):(_mem?'Dein Bild entsteht':'Dein Meisterwerk entsteht');
  document.getElementById('apLoadOverlay').classList.add('on');
  apLadeHinweis();
  apLadeStep();
  window.__apLadeT0=Date.now(); if(window.__apBarT) clearInterval(window.__apBarT); window.__apBarT=setInterval(apLadeBalken,300); apLadeBalken();
  _loadTimer=setInterval(apLadeStep, Math.max(1800, Math.round(apLadeErwartet()*1000/((_loadStepsAktiv||_loadSteps).length))));
  _loadSubStep=0;
  if(_loadSubTimer){clearInterval(_loadSubTimer);}
  _loadSubTimer=setInterval(apLadeSubStep, 2600);
}
var _loadStepsAktiv=null,_loadSubAktiv=null;
function apLadeStep(){
  var _ls=_loadStepsAktiv||_loadSteps;
  var s=_ls[Math.min(_loadStep,_ls.length-1)];
  var msg=document.getElementById('apLoadMsg');
  var bar=document.getElementById('apLoadBar');
  var emoji=document.getElementById('apLoadEmoji');
  msg.style.opacity='0';
  setTimeout(function(){
    if(emoji)emoji.textContent=s.emoji;
    msg.textContent=s.msg;
    msg.style.opacity='1';
  },200);
  /* AP-LADEBALKEN-V2-2910: Balkenbreite kommt aus apLadeBalken (Zeit) */
  _loadStep++;
}
function apLadeStop(){
  if(window.__apBarT){clearInterval(window.__apBarT);window.__apBarT=null;} window.__apLadeT0=0; try{ var _pe=document.getElementById('apLbPct'); if(_pe) _pe.textContent='100'; }catch(e){}
  if(_loadTimer){clearInterval(_loadTimer);_loadTimer=null;}
  if(_loadSubTimer){clearInterval(_loadSubTimer);_loadSubTimer=null;}
  var bar=document.getElementById('apLoadBar');
  // Transition entfernen → sofort 100%
  if(bar){bar.style.transition='none';bar.style.width='100%';}
  setTimeout(function(){
    document.getElementById('apLoadOverlay').classList.remove('on');
    if(bar){bar.style.width='0%';bar.style.transition='';}
    _loadStep=0;
  },350);
}
window.apSyncGenBtn=function(){
  var t=document.getElementById('apGenTxt');
  if(t) t.textContent=T.inStilA+(st.stilName||T.deinStil)+T.inStilB;
};
window.apStil=function(btn){
  document.querySelectorAll('#ap .ap-stil-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  apStilSliderClick(btn.dataset.stil);
};

/* ── BUNDLE POPUP ── */
window.apBundlePick=function(){
  var a=((typeof st!=='undefined'&&st.artHistory)||[]).filter(function(w){ return w && w.stilId!=='original'; });
  return a.slice(-2).reverse();
};
function apBundleShow(){
  var h=apBundlePick();
  if(h.length<2)return;
  if(typeof apIsUS==='function' && apIsUS()) return; /* 23.10.: 2er-Rabatt gilt nicht fuer US-Produkte -> kein Popup auf us. */
  /* Preise berechnen: 2 Bilder gleiche Größe = 10% Rabatt (24.10.2026, vorher 20%) */
  var _abtn=document.querySelector('#ap .ap-size-btn.on');
  var _akt=_abtn?parseFloat(_abtn.dataset.price):NaN;
  var einzelPreis=isNaN(_akt)?(h[0].price+h[1].price):(_akt*2);
  var bundlePreis=Math.round(einzelPreis*0.90*100)/100;
  var ersparnis=Math.round((einzelPreis-bundlePreis)*100)/100;
  var bWas=document.getElementById('apBundleWas');if(bWas)bWas.textContent=einzelPreis.toFixed(2).replace('.',',')+'€';
  var bNow=document.getElementById('apBundleNow');if(bNow)bNow.textContent=bundlePreis.toFixed(2).replace('.',',')+'€';
  var bSave=document.getElementById('apBundleSave');if(bSave)bSave.textContent=T.duSparst+ersparnis.toFixed(2).replace('.',',')+'€';
  /* Vorschau-Bilder */
  var prev=document.getElementById('apBundlePreviews');
  prev.innerHTML='';
  h.slice(0,2).forEach(function(item){
    var img=document.createElement('img');
    img.crossOrigin='anonymous';
    img.src=item.url;
    img.className='ap-bundle-thumb';
    img.alt=item.stil;
    var wrap=document.createElement('div');
    wrap.style.cssText='text-align:center';
    var label=document.createElement('div');
    label.style.cssText='font-size:10px;color:var(--ink-soft);margin-top:4px;font-weight:600;letter-spacing:.05em;text-transform:uppercase';
    label.textContent=item.stil;
    wrap.appendChild(img);wrap.appendChild(label);
    prev.appendChild(wrap);
  });
  document.getElementById('apBundlePopup').classList.add('on');
  document.body.style.overflow='hidden';
}
window.apBundleClose=function(){
  document.getElementById('apBundlePopup').classList.remove('on');
  document.body.style.overflow='';
};
window.apBundleBuy=function(){
  apBundleClose();
  /* Beide in den Warenkorb — nacheinander */
  var h=apBundlePick();
  var _fmtVorher=st.format;
  var items=h.map(function(item,i){
    if(item.format) st.format=item.format;
    return {
      id:apVid(st.size),quantity:1,
      properties:{
        [AP_L==='en'?'Art style':'Kunststil']:item.stil,
        [AP_L==='en'?'Size':'Größe']:apSzName(st.size),
        '_artwork_url':item.url,
        '_bundle':(AP_L==='en'?'2-piece bundle':'2er Bundle')
      }
    };
  });
  st.format=_fmtVorher;
  fetch('/cart/add.js',{method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:items})})
  .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
  .then(function(){ window.location.href='/cart'; })
  .catch(function(){ alert('Die beiden Werke konnten nicht in den Warenkorb gelegt werden. Bitte versuche es noch einmal.'); });
};
var _miniPreviewTimer=null;
window.apUpdateMiniPreview=function(){
  if(window.innerWidth>680)return; /* Nur auf Mobile */
  var src=document.getElementById('apWmCanvas');
  if(!src||!src.width||!st.artImg)return;
  var preview=document.getElementById('apInlinePreview');
  var cv=document.getElementById('apInlineCanvas');
  if(!preview||!cv)return;
  preview.style.display='block';
  /* Debounce: max 1× pro 100ms */
  clearTimeout(_miniPreviewTimer);
  _miniPreviewTimer=setTimeout(function(){
    cv.width=src.width;
    cv.height=src.height;
    cv.getContext('2d').drawImage(src,0,0);
  },80);
};

/* ── ZOOM ── */
window.apZoomOpen=function(){
  var src=document.getElementById('apWmCanvas');
  if(!src||!src.width)return;
  var zimg=document.getElementById('apZoomImg');
  if(zimg)zimg.style.display='none';
  var overlay=document.getElementById('apZoomOverlay');
  var zc=document.getElementById('apZoomCanvas');
  zc.style.display='block';
  var scale=Math.min(window.innerWidth*0.95/src.width, window.innerHeight*0.9/src.height, 3);
  zc.width=src.width*scale;zc.height=src.height*scale;
  zc.getContext('2d').drawImage(src,0,0,zc.width,zc.height);
  overlay.classList.add('on');
  document.body.style.overflow='hidden';
};
/* Zoom für Stil-Vorschaubilder (und andere Bild-URLs) */
window.apZoomImage=function(url){
  var overlay=document.getElementById('apZoomOverlay');
  var zc=document.getElementById('apZoomCanvas');
  var zimg=document.getElementById('apZoomImg');
  if(zc)zc.style.display='none';
  zimg.crossOrigin='anonymous';
  zimg.src=url;
  zimg.style.display='block';
  overlay.classList.add('on');
  document.body.style.overflow='hidden';
};
window.apZoomClose=function(){
  document.getElementById('apZoomOverlay').classList.remove('on');
  document.body.style.overflow='';
};
/* Tap auf Hintergrund schließt Zoom */
document.getElementById('apZoomOverlay').addEventListener('click',function(e){
  if(e.target===this||e.target.classList.contains('ap-zoom-hint'))apZoomClose();
});

/* ── TOOLTIP (Desktop hover + Mobile ℹ tap) ── */
window.apTip=function(e,icon){
  e.stopPropagation();
  var btn=icon.closest('.ap-stil-btn');
  var tip=btn.querySelector('.ap-tip');
  if(!tip)return;
  var isOpen=tip.classList.contains('visible');
  document.querySelectorAll('#ap .ap-tip.visible').forEach(function(t){t.classList.remove('visible')});
  if(isOpen)return;
  tip.style.left='50%';tip.style.transform='translateX(-50%)';
  tip.classList.add('visible');
  requestAnimationFrame(function(){
    var r=tip.getBoundingClientRect();
    var pad=12;
    if(r.left<pad){tip.style.left='calc(50% + '+(pad-r.left)+'px)';}
    else if(r.right>window.innerWidth-pad){tip.style.left='calc(50% - '+(r.right-(window.innerWidth-pad))+'px)';}
  });
  setTimeout(function(){tip.classList.remove('visible');},4000);
};
document.addEventListener('click',function(e){
  if(!e.target.closest('.ap-stil-btn')){
    document.querySelectorAll('#ap .ap-tip.visible').forEach(function(t){t.classList.remove('visible')});
  }
});

/* ── FORMAT ── */
window.apFmt=function(btn){
  document.querySelectorAll('#ap .ap-fmt-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.format=btn.dataset.fmt;
  st.roomOrientation=btn.dataset.fmt;
  /* STAGE v7: Format-Klasse am Root — CSS kann hoch/quer getrennt dimensionieren */
  try{var _apRoot=document.getElementById('ap');if(_apRoot)_apRoot.classList.toggle('ap-quer',st.format==='quer');}catch(e){}
  /* Cache invalidieren damit Room Mockup neu gezeichnet wird */
  _roomCache=null;_roomCacheKey='';
  /* Maße in allen Größen-Buttons aktualisieren */
  var isQuer=st.format==='quer';
  var hint=document.getElementById('apFmtHint');
  if(hint)hint.textContent=isQuer?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Ideal for landscapes, cars & group photos':'Ideal für Landschaften, Autos & Gruppenfotos'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Ideal for portraits, pets & people':'Ideal für Porträts, Haustiere & Personen');
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(b){
    var cm=b.querySelector('.sz-cm');
    if(!cm)return;
    /* USA (11.08.): Zoll statt Zentimeter */
    if(typeof apIsUS==='function' && apIsUS()){
      var z=AP_ZOLL[b.dataset.size];
      if(z){ cm.textContent = isQuer ? z.quer : z.hoch; return; }
    }
    var hoch=b.dataset.fmtHoch;
    var quer=b.dataset.fmtQuer;
    if(isQuer&&quer)cm.textContent=quer+' cm';
    else if(hoch)cm.textContent=hoch+' cm';
  });
  /* PIPE v3: beim Werk-Wechsel KEIN Sprung/Doppel-Render — apSelectWerk refresht zentral.
     Sonst: Tab springt zur Wand, Wand rendert Vorgaenger, Vorschau rechnet mit Pane-Breite 0. */
  if(!window._apSelecting){
    /* Room Mockup neu zeichnen falls Tab aktiv */
    if(st.artImg)apDrawRoom();
    if(window.apDrawMockup && st.artImg)apDrawMockup();
    /* Format-Wechsel -> immer in "An der Wand" springen (wie Material) */
    if(st.artImg && typeof apWand==='function') apWand();
  }
};

/* ── E-MAIL-GATE NORMAL-MODUS (21.08.): 5 frei -> Code-Bestaetigung -> 5 weitere.
   Der Server zaehlt jetzt WIRKLICH mit (Durable Object; FREI_ANON/FREI_MAIL in
   der Worker-wrangler.toml muessen zu diesen Zahlen passen) — die Zaehlung hier
   ist nur noch Anzeige. ── */
var AP_GEN_LIMIT = 5, AP_GEN_BONUS = 5; /* 21.08. (Auftrag Artur): 5 frei + 5 nach Mail — muss zu FREI_ANON/FREI_MAIL im Worker-toml passen */
/* Geraete-ID: zufaellig, damit der Server je Geraet zaehlen kann. */
window.apDevId=function(){
  try{
    var d=localStorage.getItem('apDevId');
    if(!d){ d=(window.crypto&&crypto.randomUUID)?crypto.randomUUID():('d'+Date.now()+'-'+Math.random().toString(36).slice(2,10)); localStorage.setItem('apDevId',d); }
    return d;
  }catch(e){ return ''; }
};
/* Grant = signierter Nachweis der Mail-Bestaetigung (vom Worker /mailgate/verify) */
window.apGrant=function(){ try{ return localStorage.getItem('apMailGrant')||''; }catch(e){ return ''; } };
window.apQuotaState=function(){
  try{
    var heute=new Date().toISOString().slice(0,10);
    var raw=localStorage.getItem('apGenQuota');
    var s=raw?JSON.parse(raw):null;
    if(!s||s.date!==heute){ s={date:heute,used:0}; }
    return s;
  }catch(e){ return {date:'',used:0}; }
};
/* Bonus zeigt nur noch der ECHTE Grant an — der alte apfEmailBonus-Flag war per
   ?nl=1 in der URL faelschbar und dem Server ohnehin unbekannt. */
window.apHatBonus=function(){ try{ return !!localStorage.getItem('apMailGrant'); }catch(e){ return false; } };
window.apQuotaLimit=function(){ return window.apHatBonus()?(AP_GEN_LIMIT+AP_GEN_BONUS):AP_GEN_LIMIT; };
window.apQuotaLeft=function(){ return Math.max(0, window.apQuotaLimit()-window.apQuotaState().used); };
window.apQuotaUse=function(){
  try{ var s=window.apQuotaState(); s.used++; localStorage.setItem('apGenQuota', JSON.stringify(s)); }catch(e){}
};

/* ── APP-WECHSEL-FIX 25.10.2026: Generierung als Hintergrund-Job ──
   Das Theme schickt eine Job-ID mit. Neuer Worker: antwortet sofort "laeuft", das
   Ergebnis wird per GET /job abgeholt — auch wenn der Kunde zwischendurch die App
   wechselt oder die Seite neu laedt. Alter Worker: antwortet wie bisher direkt mit
   dem Ergebnis (rueckwaertskompatibel). fertig(d) bekommt IMMER die Antwort im
   bisherigen Format; d===null heisst Netzfehler. Steht identisch in
   arturell-product.js und arturell-family.js (die erste geladene gewinnt). */
(function(){
  if (window.apJobSenden) return;
  var WK='https://arturell-preview.arturell.workers.dev';
  var KEY='apJob', HALTEN=60*60*1000;
  function neueId(){
    try{ var a=new Uint8Array(16); crypto.getRandomValues(a); var s=''; for(var i=0;i<a.length;i++){ s+=('0'+a[i].toString(16)).slice(-2); } return s; }
    catch(e){ return (Date.now().toString(36)+Math.random().toString(36).slice(2)+Math.random().toString(36).slice(2)).replace(/[^a-z0-9]/g,'').slice(0,32); }
  }
  function merke(o){ try{ if(o) localStorage.setItem(KEY, JSON.stringify(o)); else localStorage.removeItem(KEY); }catch(e){} }
  window.apJobGemerkt=function(){
    try{ var o=JSON.parse(localStorage.getItem(KEY)||'null'); if(o && o.job && Date.now()-(o.t||0) < HALTEN) return o; if(o) localStorage.removeItem(KEY); }catch(e){}
    return null;
  };
  window.apJobWarten=function(job, fertig, opt){
    opt=opt||{};
    var erledigt=false, timer=null, unbekannt=0, t0=Date.now(), warWeg=(document.visibilityState==='hidden');
    function ende(d){
      if(erledigt) return; erledigt=true;
      if(timer){ clearTimeout(timer); timer=null; }
      document.removeEventListener('visibilitychange', sicht);
      window.removeEventListener('pageshow', sicht);
      window.removeEventListener('online', sicht);
      merke(null);
      try{ if(d && (warWeg || opt.rueckkehr) && window.apZaehl) window.apZaehl('rueckkehr'); }catch(e){}
      fertig(d);
    }
    function plane(ms){ if(erledigt) return; if(timer) clearTimeout(timer); timer=setTimeout(frage, ms); }
    function frage(){
      if(erledigt) return;
      if(timer){ clearTimeout(timer); timer=null; }
      if(Date.now()-t0 > 15*60*1000){ ende(null); return; }
      fetch(WK+'/job?id='+job, {cache:'no-store'})
        .then(function(r){ return r.json(); })
        .then(function(s){
          if(s && (s.status==='fertig' || s.status==='fehler')){ ende(s.antwort||{}); return; }
          if(s && s.status==='laeuft'){ unbekannt=0; plane(2500); return; }
          unbekannt++;
          if(unbekannt >= (opt.maxUnbekannt||4)){ ende(null); return; }
          plane(2500);
        })
        .catch(function(){ plane(document.visibilityState==='hidden'?6000:1500); });
    }
    function sicht(){ if(document.visibilityState==='hidden'){ warWeg=true; } else { frage(); } }
    document.addEventListener('visibilitychange', sicht);
    window.addEventListener('pageshow', sicht);
    window.addEventListener('online', sicht);
    plane(opt.ersteMs||3000);
  };
  window.apJobSenden=function(body, art, fertig, extra){
    var job=neueId(); body.job=job;
    var m={job:job, art:art, t:Date.now()}; if(extra){ for(var k in extra){ m[k]=extra[k]; } }
    merke(m);
    /* AP-UPLOAD-STABIL-2910: bei abgelehntem Sicherheits-Token einmal mit frischem Token nachsenden */
    function _apSende(){
      return (window.apTsToken?window.apTsToken():Promise.resolve('')).then(function(tk){
        body.tsToken=tk;
        return fetch(WK, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
      }).then(function(r){ return r.json(); });
    }
    _apSende()
    .then(function(d){ if(d && d.error==='bot'){ return new Promise(function(w){ setTimeout(w,1500); }).then(_apSende); } return d; })
    .then(function(d){
      if(d && d.job===job && d.status==='laeuft'){
        try{ if(window.apLadeHinweis2) window.apLadeHinweis2(); }catch(e){}
        window.apJobWarten(job, fertig); return;
      }
      merke(null);
      if(d && d.job===job && d.antwort){ fertig(d.antwort); return; }
      fertig(d);   /* alter Worker oder sofortige Antwort (Limit, Bot-Pruefung, Fehler) */
    })
    .catch(function(){
      /* Antwort verloren (App-Wechsel waehrend des Hochladens, Funkloch): der Job kann
         trotzdem angekommen sein -> nachfragen; "unbekannt" = wirklich nicht angekommen */
      window.apJobWarten(job, fertig, {ersteMs:1500, maxUnbekannt:4});
    });
    return job;
  };
})();
/* Stufe 2 des Ladehinweises — wird erst gesetzt, wenn der Worker "laeuft" bestaetigt hat */
window.apLadeHinweis2=function(){
  try{
    var en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
    var h=document.getElementById('apLoadHinweis');
    if(h && h.textContent){
      var d=h.getAttribute('data-dauer')||'';
      h.textContent=en
        ? 'Your artwork is being created. This takes '+d+'. Feel free to do something else: when you come back, it’ll be waiting for you here.'
        : 'Dein Kunstwerk entsteht. Das dauert '+d+'. Erledige ruhig deine Sachen: Wenn du zurückkommst, wartet dein Bild hier auf dich.';
    }
    var ms=document.getElementById('apfMergeSub');
    if(ms) ms.textContent=en
      ? 'This takes about a minute. Feel free to do something else: when you come back, your photo will be waiting here.'
      : 'Das dauert etwa eine Minute. Erledige ruhig deine Sachen: Wenn du zurückkommst, wartet dein Foto hier auf dich.';
  }catch(e){}
};
/* ── GENERIEREN ── */
window.apGen=function(){
  if(!st.foto){alert('Bitte zuerst ein Foto hochladen.');return;}
  if(st.busy)return;
  if(window.apQuotaLeft && window.apQuotaLeft()<=0){
    if(window.apNlOpen) window.apNlOpen(window.apHatBonus()?'end':'form');
    return;
  }
  st.busy=true;
  var btn=document.getElementById('apGenBtn');
  btn.disabled=true;
  document.getElementById('apSpin').style.display='block';
  document.getElementById('apGenTxt').textContent=T.generiere;
  apLadeStart();

  /* Foto komprimieren (max 800px) dann als Base64 an Worker */
  function komprimieren(file, callback){
    var reader=new FileReader();
    reader.onload=function(e){
      var img=new Image();
      img.onload=function(){
        var MAX=800;
        var w=img.width, h=img.height;
        if(w>MAX||h>MAX){
          if(w>h){h=Math.round(h*MAX/w);w=MAX;}
          else{w=Math.round(w*MAX/h);h=MAX;}
        }
        var cv=document.createElement('canvas');
        cv.width=w;cv.height=h;
        cv.getContext('2d').drawImage(img,0,0,w,h);
        callback(cv.toDataURL('image/jpeg',0.85));
      };
      /* Ohne onerror haengt das Lade-Overlay bei nicht dekodierbaren Dateien
         fuer immer — st.busy wird nie zurueckgesetzt (Fund 21.08.). */
      img.onerror=function(){callback(null);};
      img.src=e.target.result;
    };
    reader.onerror=function(){callback(null);};
    reader.readAsDataURL(file);
  }

  komprimieren(st.foto, function(base64){
    if(!base64){
      /* Foto nicht dekodierbar (HEIC/defekt): frueher lief das stumm in
         zeigResult(Rohfoto) — sah aus wie ein fertiges Werk, verbrannte einen
         genCount-Slot und schob eine data:-URL Richtung Warenkorb (Fund 21.08.). */
      st.busy=false;btn.disabled=false;
      apLadeStop();
      document.getElementById('apSpin').style.display='none';
      apSyncGenBtn();
      var _en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(_en?'This photo could not be read (e.g. HEIC). Please choose a JPG or PNG photo.':'Dieses Foto konnte nicht gelesen werden (z. B. HEIC). Bitte wähle ein Foto als JPG oder PNG.');
      return;
    }
    /* APP-WECHSEL-FIX 25.10.: Auftrag mit Job-ID, Ergebnis wird abgeholt (auch nach App-Wechsel) */
    window.apJobSenden({
        image:base64,
        stil:st.stil,
        format:st.format||'hoch',
        zeile1:st.pers.line1||'',
        dev:window.apDevId?window.apDevId():'',
        grant:window.apGrant?window.apGrant():''
      }, 'gen', function(d){
      if(d===null){ _apNetzfehler(); return; }
      function doStop(){
        st.busy=false;
        btn.disabled=false;
        apLadeStop();
        document.getElementById('apSpin').style.display='none';
        apSyncGenBtn();
      }
      console.log('Frontend d:', JSON.stringify({ok:d.ok, preview: d.preview ? d.preview.slice(0,80) : null}));
      if(d.ok&&d.preview){
        // Bild vollständig laden BEVOR Overlay verschwindet
        if(window.apQuotaUse) window.apQuotaUse();
        var pre=new Image();
        pre.crossOrigin='anonymous';
        pre.onload=function(){zeigResult(d.preview);doStop();};
        pre.onerror=function(){zeigResult(d.preview);doStop();};
        pre.src=d.preview;
      } else {
        /* 21.07.: Fehlschlag = KEIN Werk, KEINE Quota, ehrliche Meldung */
        doStop();
        if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null);
        /* MAILGATE (12.08.): Server sagt "Geraete-Kontingent aufgebraucht" ->
           E-Mail-Fenster oeffnen; toter lokaler Grant wird verworfen. */
        if(d && d.error==='limit' && d.grund==='mailgate'){
          try{ localStorage.removeItem('apMailGrant'); }catch(e){}
          if(window.apNlOpen){ window.apNlOpen('form'); return; }
        }
        var _grund = (d && (d.message || d.error)) ? String(d.message || d.error) : '';
        alert((AP_L==='en'?"We couldn't create your artwork this time":'Das Kunstwerk konnte diesmal nicht erstellt werden') + (_grund ? ':\n' + _grund : '.') + (AP_L==='en'?'\n\nNothing was charged. Please try again.':'\n\nEs wurde nichts angerechnet. Bitte versuche es noch einmal.'));
      }
    }, {stil:st.stil, stilName:st.stilName, format:(st.familyFormat&&st.familyMergedUrl)?st.familyFormat:(st.format||'hoch'), seite:'p'});
    function _apNetzfehler(){
      if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null);
      /* Netzfehler/Nicht-JSON (429-Challenge-HTML, Abbruch): NIE das Rohfoto
         als Werk ausgeben — genCount/artHistory blieben sonst dauerhaft
         verseucht und _artwork_url truege eine data:-URL (Fund 21.08.). */
      st.busy=false;
      btn.disabled=false;
      apLadeStop();
      document.getElementById('apSpin').style.display='none';
      apSyncGenBtn();
      var _en=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
      alert(_en?"We couldn't create your artwork this time.\n\nNothing was charged. Please try again.":'Das Kunstwerk konnte diesmal nicht erstellt werden.\n\nEs wurde nichts angerechnet. Bitte versuche es noch einmal.');
    }
  });
};

window.zeigResult=zeigResult;
function zeigResult(url){
  st.artUrl=url;
  st.genCount++;
  st.artHistory.push({url:url,stil:st.stilName,stilId:st.stil,price:st.price,format:st.format});
  apSaveWerke();
  var img=document.getElementById('apResultImg');
  img.crossOrigin='anonymous';
  img.onload=function(){
    st.artImg=img;
    _bgCache=null;_bgCacheKey='';
    _roomCache=null;_roomCacheKey='';
    renderCanvas();
    apDrawRoom();
    if(typeof apDrawMockup==='function')apDrawMockup();
    apRenderStilSlider();
    apRenderWerke();
    apUpdateGenCounter();
    if(apBundlePick().length>=2 && !window._apBundleGezeigt){
      window._apBundleGezeigt=true;
      /* 24.10.2026: 2er-Popup ausgeschaltet (Trichter 23.-24.10.: 58 gezeigt, 0 Kaeufe); Rabattbox unter dem Preis bleibt */ void 0;
    }
  };
  img.src=url;
  document.getElementById('apStilBadge').textContent=st.stilName;
  document.getElementById('apResultSection').style.display='block';
  document.getElementById('apStileSection').style.display='none';
  /* Stil-Galerie einklappen — Kunde landet mit geschlossenen Stilen auf der Bearbeitung */
  var _ww=document.getElementById('apWerkeWrap');
  var _wc=document.getElementById('apStileChevron');
  if(_ww)_ww.style.display='none';
  if(_wc)_wc.textContent='▾';
  /* Dein-Foto-Thumbnail garantiert aktualisieren */
  var _fsth=document.getElementById('apFsThumb');
  if(_fsth&&(st.fotoSmall||st.fotoDataUrl))_fsth.src=(st.fotoSmall||st.fotoDataUrl);
  var hero=document.querySelector('#ap .ap-hero');
  if(hero)hero.style.display='none';
  setTimeout(function(){
    document.getElementById('apResultSection').scrollIntoView({behavior:'smooth',block:'start'});
  },200);
  aktualisierePreis();
}

/* ── CANVAS RENDERING ── */
function renderCanvas(){
  var img=document.getElementById('apResultImg');
  if(!img||!img.src)return;

  var cv=document.getElementById('apWmCanvas');
  if(!cv)return;

  function doRender(){
    if(!img.naturalWidth){setTimeout(doRender,100);return;}
    var IW=img.naturalWidth;
    var IH=img.naturalHeight;
    /* Container-Breite: mehrere Quellen prüfen */
    var container=cv.parentElement;
    var pane=document.getElementById('paneVorschau');
    var wrap=document.getElementById('apResultSection');
    var containerW=(pane&&pane.offsetWidth>10)?pane.offsetWidth:
                   (container&&container.offsetWidth>10)?container.offsetWidth:
                   (wrap&&wrap.offsetWidth>10)?Math.floor(wrap.offsetWidth*0.5):
                   Math.min(window.innerWidth-40,600);
    /* AP-SCHARF-3110: DPR bis 3 (iPhone) statt 2, Deckel 1600 statt 1200. Vorher 390-px-Handy: 700 px Canvas fuer
       1050 Geraetepixel (x1,5 hochgezogen = pixelig). Jetzt volle Werkbreite 1024. Das Bild kommt ohnehin in
       voller Groesse (previewsafe_ mit Wasserzeichen) an -> kein Schutzverlust, keine Mehr-Bandbreite. */
    var dpr=Math.min(window.devicePixelRatio||1,3);
    var maxW=Math.min(Math.round(containerW*dpr),IW,1600);
    var scale=maxW/IW;
    var W=Math.round(IW*scale);
    var H=Math.round(IH*scale);

    cv.width=W;cv.height=H;
    var ctx=cv.getContext('2d');

    /* CACHE-KEY: nur wenn Bild oder Größe sich ändert, Hintergrund neu bauen */
    var key=img.src+'|'+W+'x'+H;
    if(_bgCacheKey!==key||!_bgCache){
      _bgCache=document.createElement('canvas');
      _bgCache.width=W;_bgCache.height=H;
      var bctx=_bgCache.getContext('2d');
      /* BILD */
      /* AP-SCHARF-3110: Glaettung 'high' + Halbierungsschritte ab Faktor 2 (Standard 'low' = Treppchen) */
      bctx.imageSmoothingEnabled=true; try{bctx.imageSmoothingQuality='high';}catch(_e){}
      (function(){var _s=img,_sw=IW,_sh=IH;while(_sw/2>=W&&_sh/2>=H){var _t=document.createElement('canvas');_t.width=Math.round(_sw/2);_t.height=Math.round(_sh/2);var _tc=_t.getContext('2d');_tc.imageSmoothingEnabled=true;try{_tc.imageSmoothingQuality='high';}catch(_e){}_tc.drawImage(_s,0,0,_t.width,_t.height);_s=_t;_sw=_t.width;_sh=_t.height;}bctx.drawImage(_s,0,0,W,H);})();
      /* WASSERZEICHEN (teuer – nur hier, im Cache) */
      bctx.save();
      bctx.font='bold '+Math.round(W*0.045)+'px Inter,sans-serif';
      bctx.fillStyle='rgba(255,255,255,0.38)';
      bctx.textAlign='center';
      bctx.translate(W/2,H/2);
      bctx.rotate(-0.5);
      var step=W*0.44;
      for(var yy=-H;yy<H*2;yy+=step*0.65){
        for(var xx=-W;xx<W*2;xx+=step){
          // Kein Wasserzeichen-Text — niedrige Auflösung ist der Schutz
        }
      }
      bctx.restore();
      _bgCacheKey=key;
    }

    /* Schneller Pfad: gecachten Hintergrund kopieren + nur Text drüber */
    ctx.clearRect(0,0,W,H);
    ctx.drawImage(_bgCache,0,0);
    drawText(ctx,W,H);
    drawMini();
    /* STAGE v7.1: Contain-Fit sofort + verzoegert nachrechnen — Erst-Klick rendert sonst mit dem Layout des VORHERIGEN Werks (Buehne noch nicht umgebaut) */
    function _stageFit(){
      try{
        if(window.innerWidth>768){
          var _availW=(pane&&pane.offsetWidth>10)?pane.offsetWidth:containerW;
          var _availH=Math.max(window.innerHeight-290,240);
          var _fs=Math.min(_availW/IW,_availH/IH);
          cv.style.setProperty('width',Math.round(IW*_fs)+'px','important');
          cv.style.setProperty('height',Math.round(IH*_fs)+'px','important');
        }else{cv.style.removeProperty('width');cv.style.removeProperty('height');}
      }catch(e){}
      try{if(window.apRahmenSync)window.apRahmenSync(true);}catch(e){} /* AP-RAHMEN-VORSCHAU-3110 */
    }
    _stageFit();
    try{requestAnimationFrame(_stageFit);setTimeout(_stageFit,250);setTimeout(_stageFit,600);}catch(e){}
    /* Canvas ist jetzt fertig → Material-Mockup neu zeichnen, falls sichtbar.
       Fix: erstes Kunstwerk erschien nicht im Rahmen (apDrawMockup lief vorher
       gegen einen noch leeren Canvas; nur Format-Toggle hat es repariert). */
    var _mp=document.getElementById('paneMaterial');
    if(_mp&&_mp.offsetParent!==null&&typeof window.apDrawMockup==='function')window.apDrawMockup();
  }

  if(img.complete&&img.naturalWidth){doRender();}
  else{img.onload=doRender;}
}
window.apRenderCanvas=renderCanvas; /* AP-RAHMEN-VORSCHAU-3110 */

/* Schneller Text-Only Re-Render (für Tippen) – nutzt Cache, kein Wasserzeichen */
function renderTextOnly(){
  var cv=document.getElementById('apWmCanvas');
  if(!cv||!_bgCache||_bgCache.width!==cv.width){renderCanvas();return;}
  var ctx=cv.getContext('2d');
  ctx.clearRect(0,0,cv.width,cv.height);
  ctx.drawImage(_bgCache,0,0);
  drawText(ctx,cv.width,cv.height);
  drawMini();
}



/* ── SCHRIFTFELDER v2 (25.10.2026) ──
   Name + Datum je Anlass. Feste Vorlage (3 Schriften je Anlass), Datum immer Cormorant-Versalien.
   Position (ruhigste Zone), Farbe (hell/dunkel) und Lasur entscheidet der Browser und schickt das
   Ergebnis in _text_meta mit -> der Render-Dienst fuehrt nur aus (Vorschau = Druck).
   Masszahlen identisch zu scripts/schriftfeld_2510.py. */
var AP_SF_SIZES=[0.042,0.052,0.064,0.080,0.098];
var AP_SF_FONTS={
  greatvibes:{css:'"Great Vibes",cursive',k:1.40,w:'400',it:false,name:{de:'Schwungvoll',en:'Flowing'}},
  cormorantI:{css:'"Cormorant Garamond",Georgia,serif',k:1.18,w:'500',it:true,name:{de:'Schlicht',en:'Simple'}},
  playfair:{css:'"Playfair Display",Georgia,serif',k:0.98,w:'400',it:false,name:{de:'Klassisch',en:'Classic'}},
  caveat:{css:'Caveat,cursive',k:1.38,w:'500',it:false,name:{de:'Handschrift',en:'Handwritten'}},
  playwrite:{css:'"Playwrite US Trad",cursive',k:0.95,w:'400',it:false,name:{de:'Kinderschrift',en:'Playful'}}
};
var AP_SF_VORLAGEN={
  paar:{fonts:['greatvibes','cormorantI','playfair'],size:4},
  gedenken:{fonts:['cormorantI','playfair','greatvibes'],size:3},
  haustier:{fonts:['caveat','cormorantI','playfair'],size:4},
  familie:{fonts:['playfair','cormorantI','greatvibes'],size:3},
  kind:{fonts:['playwrite','caveat','cormorantI'],size:4}
};
var AP_SF_DATE={css:'"Cormorant Garamond",Georgia,serif',w:'600',scale:0.5,sp:0.26};
var AP_SF={bottom:0.08,top:0.065,side:0.08,gap:0.14,maxw:0.84};
var AP_SF_L=(window.Shopify&&Shopify.locale?Shopify.locale.slice(0,2):'de');
function apSfVorlageKey(){
  try{
    var q=new URLSearchParams(location.search);
    var a=(q.get('anlass')||'').toLowerCase().trim(), t=(q.get('thema')||q.get('kategorie')||'').toLowerCase().trim();
    var s=(st&&st.stil)||'';
    if(/^(regenbogenbruecke|sternenhimmel|engel|gedenkkerze|sonnenstrahlen)$/.test(s)||t==='andenken'||a==='gedenken'||a==='tier-gedenken')return 'gedenken';
    if(/^(hochzeit|jahrestag|paar|valentinstag)$/.test(a))return 'paar';
    if(/^(tier|tiere|hund|katze|haustier|pferd)$/.test(a))return 'haustier';
    if(/^(baby|kind|geburt|taufe)$/.test(a))return 'kind';
  }catch(e){}
  return 'familie';
}
function apSfVorlage(){var vk=apSfVorlageKey();if(!AP_SF_VORLAGEN[vk])vk='familie';if(st.pers.vorlage!==vk){st.pers.vorlage=vk;var V=AP_SF_VORLAGEN[vk];if(V.fonts.indexOf(st.pers.font)<0)st.pers.font=V.fonts[0];}return vk;}
function apSfRenderFonts(){
  var row=document.getElementById('apSfFontRow');if(!row)return;
  var vk=apSfVorlage();var V=AP_SF_VORLAGEN[vk];
  if(row.dataset.vk===vk&&row.dataset.f===st.pers.font)return;
  row.dataset.vk=vk;row.dataset.f=st.pers.font;
  var h='';
  for(var i=0;i<V.fonts.length;i++){var f=V.fonts[i],F=AP_SF_FONTS[f];
    h+='<button type="button" class="ap-font-btn'+(f===st.pers.font?' on':'')+'" data-font="'+f+'" onclick="apFont(this)" style="font-family:'+F.css.replace(/"/g,'&quot;')+';'+(F.it?'font-style:italic;':'')+'">'+F.name[AP_SF_L==='en'?'en':'de']+'</button>';}
  row.innerHTML=h;
}
function apSfPosLabel(){var b=document.getElementById('apSfPosBtn');if(!b)return;
  var L=AP_SF_L==='en'?{auto:'Position: automatic',um:'Position: centre',ul:'Position: left',ur:'Position: right'}:{auto:'Position: automatisch',um:'Position: mittig',ul:'Position: links',ur:'Position: rechts'};
  b.textContent=L[st.pers.pos]||L.auto;}
function apSfFieldVis(){var r1=document.getElementById('apSfNameRow'),r2=document.getElementById('apSfDatumRow');
  if(r1)r1.style.display=st.pers.nameAn?'':'none';if(r2)r2.style.display=st.pers.datumAn?'':'none';}
function apSfZone(ctx,x0,y0,w,h){
  try{
    var d=ctx.getImageData(Math.max(0,Math.round(x0)),Math.max(0,Math.round(y0)),Math.max(1,Math.round(w)),Math.max(1,Math.round(h))).data;
    var n=0,s=0,s2=0;
    for(var i=0;i<d.length;i+=16){var l=0.299*d[i]+0.587*d[i+1]+0.114*d[i+2];s+=l;s2+=l*l;n++;}
    var m=s/n;return {lum:m,sd:Math.sqrt(Math.max(0,s2/n-m*m))};
  }catch(e){return {lum:180,sd:0};}
}
function apSfTexte(){
  var p=st.pers;
  return {l1:(p.nameAn?(p.line1||'').trim().slice(0,30):''),l2:(p.datumAn?(p.line2||'').trim().slice(0,24).toUpperCase():'')};
}
function drawText(ctx,W,H){
  var p=st.pers, T=apSfTexte(), l1=T.l1, l2=T.l2;
  if(!l1&&!l2){p.calc=null;return;}
  var vk=apSfVorlage(), V=AP_SF_VORLAGEN[vk], F=AP_SF_FONTS[p.font]||AP_SF_FONTS[V.fonts[0]];
  var lvl=V.size, base=W*AP_SF_SIZES[lvl-1];
  var namePx=base*F.k, datePx=Math.max(10,base*AP_SF_DATE.scale);
  function nf(px){return (F.it?'italic ':'')+F.w+' '+px+'px '+F.css;}
  function df(px){return AP_SF_DATE.w+' '+px+'px '+AP_SF_DATE.css;}
  ctx.save();ctx.textAlign='left';ctx.textBaseline='alphabetic';ctx.shadowBlur=0;
  var nameW=0,nameAsc=0,nameDesc=0,mm;
  if(l1){ctx.font=nf(namePx);mm=ctx.measureText(l1);var g=0;
    while(mm.width>W*AP_SF.maxw&&namePx>12&&g<60){namePx*=0.94;ctx.font=nf(namePx);mm=ctx.measureText(l1);g++;}
    nameW=mm.width;nameAsc=mm.fontBoundingBoxAscent||namePx*0.9;nameDesc=mm.fontBoundingBoxDescent||namePx*0.25;}
  var sp=datePx*AP_SF_DATE.sp, dateW=0, dateAsc=0;
  if(l2){ctx.font=df(datePx);var dm=ctx.measureText(l2);dateAsc=dm.fontBoundingBoxAscent||datePx*0.9;
    for(var i=0;i<l2.length;i++)dateW+=ctx.measureText(l2[i]).width;dateW+=sp*Math.max(0,l2.length-1);}
  var gap=namePx*AP_SF.gap;
  var blockW=Math.max(nameW,dateW);
  var blockH=(l1?nameAsc+nameDesc:0)+(l2&&l1?gap+dateAsc:(l2?dateAsc:0));
  function box(pp){var y0=(pp==='om')?H*AP_SF.top:H*(1-AP_SF.bottom)-blockH;var x0=(pp==='ur')?W*(1-AP_SF.side)-blockW:(pp==='ul')?W*AP_SF.side:(W-blockW)/2;return {x0:x0,y0:y0,x1:x0+blockW,y1:y0+blockH};}
  var pos=p.pos||'auto', z;
  if(pos==='auto'){var best=null,cands=['um','ul','ur'];
    for(var c=0;c<cands.length;c++){var pp=cands[c];if(blockW>W*(1-2*AP_SF.side)&&pp!=='um')continue;
      var b=box(pp);var zz=apSfZone(ctx,b.x0,b.y0,blockW,blockH);
      var score=zz.sd+0.15*Math.abs(zz.lum-(zz.lum<120?40:215));
      if(best===null||score<best.score)best={score:score,pp:pp,z:zz};}
    pos=best.pp;z=best.z;}
  else{var bb=box(pos);z=apSfZone(ctx,bb.x0,bb.y0,blockW,blockH);}
  var hell=(z.lum<120)||(z.sd>35&&z.lum<150);
  var col=hell?'#FAF7F1':'#1A1714';
  var lasur=(z.sd>40)?Math.round(Math.min(1,(z.sd-40)/40)*140+40):0;
  var B=box(pos);
  if(lasur>0){var pad=namePx*0.6;ctx.save();
    try{ctx.filter='blur('+(pad*0.9)+'px)';}catch(e){}
    ctx.fillStyle=hell?'rgba(20,18,16,'+(lasur*0.8/255).toFixed(3)+')':'rgba(252,250,246,'+(lasur/255).toFixed(3)+')';
    ctx.beginPath();
    if(ctx.roundRect)ctx.roundRect(B.x0-pad,B.y0-pad*0.7,blockW+2*pad,blockH+1.4*pad,pad);else ctx.rect(B.x0-pad,B.y0-pad*0.7,blockW+2*pad,blockH+1.4*pad);
    ctx.fill();ctx.restore();}
  function xpos(wd){return (pos==='ur')?W*(1-AP_SF.side)-wd:(pos==='ul')?W*AP_SF.side:(W-wd)/2;}
  ctx.fillStyle=col;
  var nameBase=null,dateBase=null;
  if(l1){nameBase=B.y0+nameAsc;ctx.font=nf(namePx);ctx.fillText(l1,xpos(nameW),nameBase);dateBase=l2?nameBase+nameDesc+gap+dateAsc:null;}
  else{dateBase=B.y0+dateAsc;}
  if(l2){ctx.font=df(datePx);var cx=xpos(dateW);for(var k=0;k<l2.length;k++){ctx.fillText(l2[k],cx,dateBase);cx+=ctx.measureText(l2[k]).width+sp;}}
  ctx.restore();
  p.calc={v:2,vorlage:vk,font:p.font,size:lvl,pos:pos,farbe:hell?'hell':'dunkel',lasur:lasur,
          d1x:(xpos(nameW)+nameW/2)/W,d1y:nameBase!==null?nameBase/H:null,d2x:(xpos(dateW)+dateW/2)/W,d2y:dateBase!==null?dateBase/H:null};
}

window.apTextKuerzen=function(){
  var e1=document.getElementById('apPersLine1'),e2=document.getElementById('apPersLine2');
  if(e1){st.pers.line1=e1.value.slice(0,30);if(e1.value.length>30)e1.value=st.pers.line1;}
  if(e2){st.pers.line2=e2.value.slice(0,24);if(e2.value.length>24)e2.value=st.pers.line2;}
  var c=document.getElementById('apSfCount');if(c)c.textContent=(st.pers.line1||'').length+'/30';
};

/* ── MINI CANVAS (Mobile Sticky) ── */
function drawMini(){
  var mini=document.getElementById('apMiniCanvas');
  if(!mini)return;
  /* Source: entweder st.artImg oder den Haupt-Canvas */
  var src=st.artImg;
  if(!src)return;
  var iw=src.naturalWidth||400;
  var ih=src.naturalHeight||560;
  /* Proportional 64px hoch */
  var H=64;
  var W=Math.round(iw/ih*H);
  var _md=Math.min(window.devicePixelRatio||1,3); /* AP-SCHARF-3110 */
  mini.width=Math.round(W*_md);mini.height=Math.round(H*_md);
  mini.style.width=W+'px';mini.style.height=H+'px';
  mini.style.borderRadius='8px';
  var ctx=mini.getContext('2d');
  ctx.setTransform(_md,0,0,_md,0,0); ctx.imageSmoothingEnabled=true; try{ctx.imageSmoothingQuality='high';}catch(_e){}
  ctx.clearRect(0,0,W,H);
  /* Hauptcanvas als Quelle nutzen (enthält bereits Bild + Wasserzeichen + Text) */
  var mainCv=document.getElementById('apWmCanvas');
  if(mainCv&&mainCv.width>0){
    ctx.drawImage(mainCv,0,0,W,H);
  } else {
    ctx.drawImage(src,0,0,W,H);
  }
}

/* ── PERSONALISIERUNG ── */
var AP_SAETZE_EN={
  tier:[["The boss of the house","e.g. Balu"],["Four paws, one heart","e.g. Luna"],["Best friend since 2019","e.g. Rocky"],["Welcome home","e.g. Emma \u00b7 since 2024"],["The real head of the house","e.g. Sam"],["My better half","e.g. Nala"]],
  'tier-gedenken':[["Until the Rainbow Bridge","e.g. Balu \u00b7 2012-2026"],["Forever my loyal friend","e.g. Luna \u00b7 2010-2025"],["Thank you for every minute","e.g. Rocky"],["Gone on soft paws","e.g. Mimi \u00b7 2011-2025"],["You were never just a pet","e.g. Bello"],["Until we meet again","e.g. Emma"]],
  gedenken:[["Forever in our hearts","e.g. Grandma Rose \u00b7 1941-2025"],["In loving memory","e.g. Karl \u00b7 1938-2024"],["We miss you every day","e.g. Mom"],["Until the Rainbow Bridge","e.g. Balu \u00b7 2012-2026"],["Thank you for everything","e.g. Grandpa Joe"],["Never forgotten","e.g. 1950-2025"]],
  weihnachten:[["Merry Christmas","e.g. The Miller family \u00b7 2026"],["The best gift is you","e.g. 2026"],["Christmas is wherever you are","e.g. The Weber family"],["Our first Christmas","e.g. 2026"],["Together is the best gift","e.g. The Smith family"]],
  hochzeit:[["Yes, forever","e.g. June 17, 2026"],["Our most beautiful day","e.g. Lena & Max \u00b7 June 17, 2026"],["The day it all began","e.g. June 17, 2026"],["Forever starts today","e.g. Anna & Jonas"],["Still in love","e.g. since 2016"],["Two hearts, one path","e.g. since June 17, 2016"]],
  geburtstag:[["Happy Birthday","e.g. Lisa \u00b7 30"],["Celebrate you","e.g. for your 40th"],["The best is yet to come","e.g. Tom \u00b7 50"],["Here's to you","e.g. for your 18th"],["Born to shine","e.g. Mia \u00b7 March 16"]],
  muttertag:[["World's best mom","e.g. your three"],["Thanks for everything, Mom","e.g. your kids"],["Once a mom, always a mom","e.g. 2026"],["Superhero without a cape","e.g. Mom"],["Home is you","e.g. with love, Sarah"]],
  vatertag:[["World's best dad","e.g. your two"],["Thank you, Dad","e.g. your kids"],["My first hero","e.g. Dad"],["The rock in the storm","e.g. 2026"],["Dad always knows a way","e.g. with love, Jan"]],
  valentinstag:[["I love you","e.g. Anna & Ben"],["You are my favorite person","e.g. since 2019"],["Always you","e.g. Julia"],["The two of us","e.g. since Feb 14, 2020"],["Every day is Valentine's with you","e.g. for Marie"]],
  eid:[["Eid Mubarak","e.g. The Yilmaz family"],["Bayram\u0131n\u0131z m\u00fcbarek olsun","e.g. 2026"],["\u0130yi bayramlar","e.g. The \u00d6zt\u00fcrk family"],["Blessed celebration","e.g. 2026"],["The feast of family","e.g. The Kaya family"]]
};
var AP_SAETZE={
  tier:[["Der Chef im Haus","z.B. Balu"],["Vier Pfoten, ein Herz","z.B. Luna"],["Bester Freund seit 2019","z.B. Rocky"],["Willkommen zuhause","z.B. Emma · seit 2024"],["Der wahre Hausherr","z.B. Sam"],["Meine bessere Hälfte","z.B. Nala"]],
  'tier-gedenken':[["Bis zur Regenbogenbrücke","z.B. Balu · 2012-2026"],["Für immer mein treuer Freund","z.B. Luna · 2010-2025"],["Danke für jede Minute","z.B. Rocky"],["Auf leisen Pfoten gegangen","z.B. Mimi · 2011-2025"],["Du warst nie nur ein Tier","z.B. Bello"],["Bis wir uns wiedersehen","z.B. Emma"]],
  gedenken:[["Für immer in unseren Herzen","z.B. Oma Helga · 1941-2025"],["In liebevoller Erinnerung","z.B. Karl · 1938-2024"],["Du fehlst uns jeden Tag","z.B. Mama"],["Bis zur Regenbogenbrücke","z.B. Balu · 2012-2026"],["Danke für alles","z.B. Opa Werner"],["Unvergessen","z.B. 1950-2025"]],
  weihnachten:[["Frohe Weihnachten","z.B. Familie Müller · 2026"],["Das schönste Geschenk seid ihr","z.B. 2026"],["Weihnachten ist, wo ihr seid","z.B. Familie Weber"],["Unser erstes Weihnachten","z.B. 2026"],["Zusammen ist das schönste Fest","z.B. Familie Schmidt"]],
  hochzeit:[["Ja, für immer","z.B. 17.06.2026"],["Unser schönster Tag","z.B. Lena & Max · 17.06.2026"],["Der Tag, an dem alles begann","z.B. 17.06.2026"],["Für immer beginnt heute","z.B. Anna & Jonas"],["Immer noch verliebt","z.B. seit 2016"],["Zwei Herzen, ein Weg","z.B. seit 17.06.2016"]],
  geburtstag:[["Happy Birthday","z.B. Lisa · 30"],["Feier dich, du hast es verdient","z.B. zum 40."],["Das Beste kommt noch","z.B. Tom · 50"],["Ein Hoch auf dich","z.B. zum 18."],["Geboren, um zu strahlen","z.B. Mia · 16.03."]],
  muttertag:[["Beste Mama der Welt","z.B. deine drei"],["Danke für alles, Mama","z.B. deine Kinder"],["Einmal Mama, immer Mama","z.B. 2026"],["Superheldin ohne Umhang","z.B. Mama"],["Zuhause bist du","z.B. in Liebe, Sarah"]],
  vatertag:[["Bester Papa der Welt","z.B. deine zwei"],["Danke, Papa","z.B. deine Kinder"],["Mein erster Held","z.B. Papa"],["Der Fels in unserer Brandung","z.B. 2026"],["Papa weiß immer einen Weg","z.B. in Liebe, Jan"]],
  valentinstag:[["Ich liebe dich","z.B. Anna & Ben"],["Du bist mein Lieblingsmensch","z.B. seit 2019"],["Immer wieder du","z.B. Julia"],["Wir zwei","z.B. seit 14.02.2020"],["Mit dir ist jeder Tag Valentinstag","z.B. für Marie"]],
  eid:[["Eid Mubarak","z.B. Familie Yilmaz"],["Bayramınız mübarek olsun","z.B. 2026"],["İyi bayramlar","z.B. Familie Öztürk"],["Gesegnetes Fest","z.B. 2026"],["Das Fest der Familie","z.B. Familie Kaya"]]
};
function apAnlassKey(){
  try{
    var qs=new URLSearchParams(window.location.search);
    var a=(qs.get('anlass')||'').toLowerCase().trim();
    if(a&&AP_SAETZE[a]){localStorage.setItem('arturell_anlass_v1',JSON.stringify({a:a,t:Date.now()}));return a;}
    var m=JSON.parse(localStorage.getItem('arturell_anlass_v1')||'null');
    if(m&&m.a&&AP_SAETZE[m.a]&&(Date.now()-m.t)<86400000)return m.a;
  }catch(e){}
  return '';
}
function apSatzChipsInit(){
  var box=document.getElementById('apSatzChips');if(!box)return;
  var key=apAnlassKey();
  if(!key){box.style.display='none';return;}
  var arr=(AP_L==='en'&&AP_SAETZE_EN[key])?AP_SAETZE_EN[key]:AP_SAETZE[key];
  var h='<div class="ap-satz-chips-label">'+(AP_L==='en'?'Caption ideas: tap and edit':'Satz-Ideen: antippen und anpassen')+'</div>';
  for(var i=0;i<arr.length;i++){
    h+='<button type="button" class="ap-satz-chip" data-l1="'+arr[i][0].replace(/"/g,'&quot;')+'" data-p2="'+(arr[i][1]||'').replace(/"/g,'&quot;')+'" onclick="apSatzChip(this)">'+arr[i][0]+'</button>';
  }
  box.innerHTML=h;box.style.display='block';
}
window.apSatzChip=function(btn){
  var i1=document.getElementById('apPersLine1'),i2=document.getElementById('apPersLine2');
  if(!i1)return;
  i1.value=btn.getAttribute('data-l1')||'';
  st.pers.nameAn=true;var _cb=document.getElementById('apSfNameCb');if(_cb)_cb.checked=true;apSfFieldVis();
  var p2=btn.getAttribute('data-p2');
  if(i2&&p2)i2.placeholder=p2;
  var alle=document.querySelectorAll('.ap-satz-chip');
  for(var j=0;j<alle.length;j++)alle[j].classList.remove('on');
  btn.classList.add('on');
  try{apEnsureVorschau();apShowMiniSticky(true);}catch(e){}
  apUpdateText();apUpdateMiniPreview();
  if(i2)i2.focus();
};
try{apSatzChipsInit();}catch(e){}

window.apUpdateText=function(){
  apTextKuerzen();
  /* Schneller Pfad: nur Text neu zeichnen, mit RAF-Throttle */
  if(st.artImg&&!_rafPending){
    _rafPending=true;
    requestAnimationFrame(function(){
      _rafPending=false;
      renderTextOnly();
      /* Wenn Raum-Tab aktiv: auch dort Text aktualisieren */
      var rp=document.getElementById('paneRaum');
      if(rp&&rp.offsetParent!==null)apDrawRoom();
      var mp=document.getElementById('paneMaterial');
      if(mp&&mp.offsetParent!==null&&typeof apDrawMockup==='function')apDrawMockup();
    });
  }
  /* Mobile sticky anzeigen wenn Bild nicht sichtbar */
  var sticky=document.getElementById('apMobileSticky');
  if(sticky&&window.innerWidth<=680&&st.artImg){
    sticky.classList.add('visible');
  }
};

window.apShowMiniSticky=function(show){
  var sticky=document.getElementById('apMobileSticky');
  if(!sticky)return;
  if(window.innerWidth>680){sticky.classList.remove('visible');return;}
  if(show&&st.artImg){
    sticky.classList.add('visible');
    drawMini();
  }
};

var _apSyncRaf=false;
function apSyncWandFromText(){
  if(_apSyncRaf)return; _apSyncRaf=true;
  requestAnimationFrame(function(){
    _apSyncRaf=false;
    var rp=document.getElementById('paneRaum');
    if(rp&&rp.offsetParent!==null&&typeof apDrawRoom==='function')apDrawRoom();
    var mp=document.getElementById('paneMaterial');
    if(mp&&mp.offsetParent!==null&&typeof apDrawMockup==='function')apDrawMockup();
  });
}
window.apFont=function(btn){
  document.querySelectorAll('#ap .ap-pers-font-row .ap-font-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.pers.font=btn.dataset.font;
  var row=document.getElementById('apSfFontRow');if(row)row.dataset.f=st.pers.font;
  if(st.artImg){renderCanvas();apUpdateMiniPreview();apSyncWandFromText();}
};
window.apSfNameAn=function(cb){st.pers.nameAn=!!cb.checked;apSfFieldVis();apSfRenderFonts();apUpdateText();
  if(st.pers.nameAn){var e=document.getElementById('apPersLine1');if(e&&!e.value)e.focus();}};
window.apSfDatumAn=function(cb){st.pers.datumAn=!!cb.checked;apSfFieldVis();apSfRenderFonts();apUpdateText();
  if(st.pers.datumAn){var e=document.getElementById('apPersLine2');if(e&&!e.value)e.focus();}};
window.apSfPosNext=function(){var o=['auto','um','ul','ur'];var i=o.indexOf(st.pers.pos);st.pers.pos=o[(i+1)%o.length];apSfPosLabel();
  if(st.artImg){renderCanvas();apUpdateMiniPreview();apSyncWandFromText();}};
try{apSfRenderFonts();apSfPosLabel();apSfFieldVis();}catch(e){}

/* Falls gerade "An der Wand" aktiv ist, auf Vorschau schalten
   (Text platzieren geht nur in der Vorschau) */
window.apEnsureVorschau=function(){
  var m=document.getElementById('paneMaterial');
  var r=document.getElementById('paneRaum');
  if(((m&&m.classList.contains('on'))||(r&&r.classList.contains('on')))&&typeof apTab==='function')apTab('vorschau');
};
window.apTogglePers=function(){
  st.persOpen=!st.persOpen;
  var f=document.getElementById('apPersFields');
  f.classList.toggle('open',st.persOpen);
  var _tb=document.getElementById('apPersToggleBox');if(_tb)_tb.textContent=st.persOpen?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'− Close':'− Schließen'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'＋ Add':'＋ Hinzufügen');
  if(st.persOpen)apEnsureVorschau();
};

/* ── BILD-SCHUTZ: kein Wegziehen / Rechtsklick-Speichern ── */
(function(){
  var ap=document.getElementById('ap');
  if(!ap)return;
  ap.addEventListener('dragstart',function(e){e.preventDefault();return false;});
  ap.addEventListener('contextmenu',function(e){var t=e.target&&e.target.tagName;if(t==='IMG'||t==='CANVAS')e.preventDefault();});
})();

/* ── DRAG TEXT: entfernt (v167) — Positionierung nur noch übers Positions-Pad ── */
/* ── ZOOM-LUPE auf dem Mockup ("An der Wand") — hochaufgeloester Server-Render ── */
(function(){
  var box=document.getElementById('apMockupBox');
  var pane=document.getElementById('paneMaterial');
  if(!box||!pane)return;
  if(getComputedStyle(pane).position==='static')pane.style.position='relative';
  var L=150, Z=2.4;
  var loupe=document.createElement('canvas');
  loupe.width=L; loupe.height=L; loupe.className='ap-loupe';
  loupe.style.cssText='position:absolute;width:'+L+'px;height:'+L+'px;border-radius:50%;border:3px solid rgba(255,255,255,.92);box-shadow:0 6px 26px rgba(0,0,0,.4);pointer-events:none;display:none;z-index:20;background:#f4f2ee';
  pane.appendChild(loupe);
  var lctx=loupe.getContext('2d');
  function curImg(){ var im=box.querySelector('img.ap-mock-img'); return (im&&im.complete&&im.naturalWidth)?im:null; }
  function ueberNav(x,y){
    var el=document.elementFromPoint(x,y);
    return !!(el&&el.closest&&el.closest('.ap-mock-nav'));
  }
  function draw(clientX,clientY,mobile){
    if(ueberNav(clientX,clientY)){loupe.style.display='none';return;}
    var im=curImg(); if(!im){loupe.style.display='none';return;}
    var r=box.getBoundingClientRect(), ri=im.getBoundingClientRect(); /* AP-WANDZOOM-3110: Bildrechteck statt Box */
    var bw=ri.width, bh=ri.height, iw=im.naturalWidth, ih=im.naturalHeight;
    var s=Math.min(bw/iw, bh/ih);          /* object-fit:contain */
    var dw=iw*s, dh=ih*s, ox=(bw-dw)/2, oy=(bh-dh)/2;
    var cx=clientX-ri.left, cy=clientY-ri.top;
    var pxx=cx-ox, pyy=cy-oy;
    if(pxx<0||pyy<0||pxx>dw||pyy>dh){loupe.style.display='none';return;}
    var sx=pxx/s, sy=pyy/s, reg=(L/Z)/s;   /* Quell-Ausschnitt in Natur-Pixeln */
    lctx.clearRect(0,0,L,L); lctx.imageSmoothingEnabled=true;
    try{ lctx.drawImage(im, sx-reg/2, sy-reg/2, reg, reg, 0,0,L,L); }catch(e){loupe.style.display='none';return;}
    var bx=clientX-r.left, by=clientY-r.top;
    var lx=bx-L/2, ly=mobile?(by-L-30):(by-L/2);
    lx=Math.max(0,Math.min(r.width-L,lx)); ly=Math.max(0,Math.min(r.height-L,ly));
    loupe.style.left=(box.offsetLeft+lx)+'px'; loupe.style.top=(box.offsetTop+ly)+'px'; loupe.style.display='block';
  }
  box.addEventListener('mousemove',function(e){draw(e.clientX,e.clientY,false);});
  box.addEventListener('mouseleave',function(){loupe.style.display='none';});
  var holdT=null, curT=null;
  box.addEventListener('touchstart',function(e){ var t=e.touches[0]; if(!t)return; if(ueberNav(t.clientX,t.clientY))return; curT=t; holdT=setTimeout(function(){draw(curT.clientX,curT.clientY,true);},170); },{passive:true});
  box.addEventListener('touchmove',function(e){ var t=e.touches[0]; if(!t)return; curT=t; if(loupe.style.display==='block'){e.preventDefault();draw(t.clientX,t.clientY,true);} },{passive:false});
  function endTouch(){clearTimeout(holdT);loupe.style.display='none';}
  box.addEventListener('touchend',endTouch);
  box.addEventListener('touchcancel',endTouch);
})();

/* ── ROOM MOCKUP: entfernt (v152) — Server-Renders uebernehmen. Stub fuer Alt-Aufrufer: ── */
window.apDrawRoom=function(){};
function getRoomData(){return null;}

window.apRoom=function(btn,ori){
  document.querySelectorAll('#ap .ap-room-canvas-wrap + div .ap-font-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.roomOrientation=ori;
  apDrawRoom();
};

/* ── MATERIAL-MOCKUPS (PSD-basiert, matrix3d) ── */
/* ── SERVER-MOCKUPS (Hetzner via Preview-Worker /mockup) ── */
var AP_SRV = {
  framed_canvas: { black:{hoch:['framed_canvas_schwarz_wall_hoch_03','framed_canvas_schwarz_free_hoch'],quer:['framed_canvas_schwarz_wall_quer_03','framed_canvas_schwarz_free_quer']},
                   white:{hoch:['framed_canvas_weiss_wall_hoch_03','framed_canvas_weiss_free_hoch'],quer:['framed_canvas_weiss_wall_quer_03','framed_canvas_weiss_free_quer']},
                   wood:{hoch:['framed_canvas_eiche_wall_hoch_03','framed_canvas_eiche_free_hoch'],quer:['framed_canvas_eiche_wall_quer_03','framed_canvas_eiche_free_quer']},
                   dark:{hoch:['framed_canvas_schwarz_wall_hoch_03','framed_canvas_schwarz_free_hoch'],quer:['framed_canvas_schwarz_wall_quer_03','framed_canvas_schwarz_free_quer']} },
  canvas:        { _all:{hoch:['canvas_hoch_18_lw1410j'],quer:['canvas_quer_21_lw1410h']} }
};
/* ── TURNSTILE 19.07. (v2): ALLES an window, weil die Datei aus mehreren
   abgeschlossenen IIFEs besteht und lokale Funktionen dort unsichtbar sind. ── */
window.AP_TS_SITEKEY='0x4AAAAAAD5KX_2BV20P_wpV';
window._apTsId=null;window._apTsCb=null;
window.apTsLoad=function(){
  return new Promise(function(res){
    if(window.turnstile&&window.turnstile.render){res(true);return;}
    if(!document.getElementById('apTsScript')){
      var sc=document.createElement('script');sc.id='apTsScript';
      sc.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      sc.async=true;sc.defer=true;document.head.appendChild(sc);
    }
    var t0=Date.now();
    var iv=setInterval(function(){
      if(window.turnstile&&window.turnstile.render){clearInterval(iv);res(true);}
      else if(Date.now()-t0>10000){clearInterval(iv);res(false);}
    },100);
  });
};
window.apTsToken=function(){
  try{
    return window.apTsLoad().then(function(ok){
      if(!ok){console.log('Turnstile: Script nicht geladen');return '';}
      return new Promise(function(res){
        var fertig=false;
        function liefere(t){ if(!fertig){fertig=true;window._apTsCb=null;res(t||'');} }
        window._apTsCb=liefere;
        try{
          if(window._apTsId===null){
            var box=document.getElementById('apTsBox');
            if(!box){box=document.createElement('div');box.id='apTsBox';
              box.style.cssText='position:fixed;bottom:10px;right:10px;z-index:99999';
              document.body.appendChild(box);}
            window._apTsId=window.turnstile.render(box,{
              sitekey:window.AP_TS_SITEKEY,appearance:'interaction-only',execution:'execute',
              callback:function(t){ if(window._apTsCb)window._apTsCb(t); },
              'error-callback':function(){ if(window._apTsCb)window._apTsCb(''); },
              'expired-callback':function(){ if(window._apTsCb)window._apTsCb(''); }
            });
          } else { window.turnstile.reset(window._apTsId); }
          window.turnstile.execute(window._apTsId);
        }catch(e){ console.log('Turnstile Fehler:',e.message); liefere(''); return; }
        setTimeout(function(){ liefere(''); },25000); /* AP-UPLOAD-STABIL-2910 */
      });
    });
  }catch(e){ console.log('Turnstile Aussenfehler:',e.message); return Promise.resolve(''); }
};
try{ window.apTsLoad(); }catch(e){}
var AP_SRV_URL='https://arturell-preview.arturell.workers.dev/mockup';
function apSrvGr(k){
  /* Groessendimension: nur Wand-Bundles haben Groessenvarianten. XL faellt auf L zurueck,
     solange merchOne keine 120x80-Vorlagen geliefert hat. */
  if(!k)return k;
  var gs={s:'s',m:'m',l:'l',xl:'l',xxl:'l'};
  var g=gs[st.size]||'m';
  return k.replace(/_wall_(hoch|quer)_03$/,'_wall_$1_'+g+'_03');
}
function apSrvKeys(){
  var m=AP_SRV[st.material]; if(!m)return [];
  var c=m._all||m[st.farbe]; if(!c)return [];
  var ks=c[st.format]||[];
  return ks.map(apSrvGr);
}
function apSrvKey(){
  var ks=apSrvKeys(); if(!ks.length)return null;
  if(typeof st.mockView!=='number')st.mockView=0;
  if(st.mockView>=ks.length)st.mockView=0;
  return ks[st.mockView];
}
function apSrvFname(){
  /* PIPE v2: das AKTUELL GEWAEHLTE Werk (st.artUrl) hat Vorrang — st.artImg.src
     zeigt beim Werk-Wechsel noch aufs Vorgaenger-Bild (async load). */
  var u=st.artUrl||(st.artImg&&st.artImg.src)||''; var f=u.split('/').pop().split('?')[0];
  return /^preview(safe)?_[0-9]+_[a-z0-9]+\.jpg$/i.test(f)?f:null;
}
window._apSrvSeq=0; window._apSrvWarm={};
function apSrvPrefetch(fname){
  /* MOCKUP-SMART-PREFETCH v1: nur 1 Mockup je Material (aktuelle Ausrichtung), sequenziell + gecacht */
  var fmt=st.format||'hoch';
  var wk=fname+'|'+fmt;
  if(window._apSrvWarm[wk])return; window._apSrvWarm[wk]=1;
  var jobs=[];
  Object.keys(AP_SRV).forEach(function(mat){
    var m=AP_SRV[mat];
    var c=m._all||m[st.farbe]||m[Object.keys(m)[0]];
    var ks=(c&&c[fmt])||[];
    ks.forEach(function(mk){jobs.push(apSrvGr(mk));});
  });
  window._apSrvCache=window._apSrvCache||{};
  (function next(){
    if(!jobs.length)return;
    var mk=jobs.shift(); var ck=mk+'|'+fname;
    if(window._apSrvCache[ck]){ setTimeout(next,150); return; }
    fetch(AP_SRV_URL+'?img='+encodeURIComponent(fname)+'&mockup='+mk+'&px=2000')
      .then(function(r){return r.json();})
      .then(function(d){ if(d&&d.ok){ window._apSrvCache[ck]=d.url; var pi=new Image(); pi.src=d.url; } setTimeout(next,300); })
      .catch(function(){ setTimeout(next,300); });
  })();
}
function apFitMockupBox(){
  var box=document.getElementById('apMockupBox'),pane=document.getElementById('paneMaterial');
  if(!box||!pane)return;
  /* FIX 11.07: Referenz ist die stabile Pane-BREITE + feste Viewport-Hoehe — NIE
     pane.clientHeight (das schrumpfte durch die eigene vorherige Verkleinerung ->
     Box wurde bei jedem An-der-Wand-Klick kleiner). Quadratische Box (1:1). */
  var pw=pane.clientWidth||box.clientWidth||0;
  if(!pw)return;
  var maxH=Math.max(window.innerHeight-250,240);   /* feste Obergrenze, unabhaengig von Box */
  var side=Math.min(pw,maxH);                        /* quadratisch, passt in Breite UND Hoehe */
  /* PIPE v1: Server-Mockups sind quadratische Szenen -> Box bleibt 1:1, aber im
     Quer-Modus nutzen wir die volle Pane-Breite bis zur Hoehen-Grenze (identisch),
     damit Vorschau- und Wand-Ansicht dieselbe Fussflaeche haben. */
  box.style.width=Math.round(side)+'px';
  box.style.height=Math.round(side)+'px';
  box.style.aspectRatio='auto';
}
window.addEventListener('resize',function(){apFitMockupBox();});
/* \u2500 MOCKUP-SWIPE v1: mehrere Ansichten (freistehend + Wand) \u2500 */
window.apMockGo=function(dir){
  var ks=apSrvKeys(); if(ks.length<2)return;
  if(typeof st.mockView!=='number')st.mockView=0;
  st.mockView=(st.mockView+dir+ks.length)%ks.length;
  window.apDrawMockup();
};
function apMockNav(box){
  var ks=apSrvKeys(); if(ks.length<2)return;
  var i=st.mockView||0;
  var nav=document.createElement('div');
  nav.className='ap-mock-nav';nav.style.cssText='position:absolute;inset:0;pointer-events:none;z-index:22';
  var dots='';
  for(var d=0;d<ks.length;d++){dots+='<span style="width:8px;height:8px;border-radius:50%;background:'+(d===i?'#3a2f2a':'rgba(58,47,42,.32)')+';display:inline-block;margin:0 3px"></span>';}
  nav.innerHTML=
    '<button type="button" onclick="apMockGo(-1)" ontouchstart="event.stopPropagation()" onmousedown="event.stopPropagation()" style="pointer-events:auto;position:absolute;left:8px;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;border:none;background:rgba(255,255,255,.85);box-shadow:0 1px 6px rgba(0,0,0,.18);font-size:16px;cursor:pointer">&#8249;</button>'+
    '<button type="button" onclick="apMockGo(1)" ontouchstart="event.stopPropagation()" onmousedown="event.stopPropagation()" style="pointer-events:auto;position:absolute;right:8px;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;border:none;background:rgba(255,255,255,.85);box-shadow:0 1px 6px rgba(0,0,0,.18);font-size:16px;cursor:pointer">&#8250;</button>'+
    '<div style="position:absolute;left:0;right:0;bottom:8px;text-align:center">'+dots+'</div>';
  box.appendChild(nav);
  if(!box._apSwipe){
    box._apSwipe=1;
    var sx=null;
    box.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
    box.addEventListener('touchend',function(e){
      if(sx===null)return;
      var dx=e.changedTouches[0].clientX-sx; sx=null;
      if(Math.abs(dx)>40)window.apMockGo(dx<0?1:-1);
    },{passive:true});
  }
}
window.apDrawMockup = function(){
  var box=document.getElementById('apMockupBox'), hint=document.getElementById('apMockupHint');
  if(!box)return;
  apFitMockupBox();
  /* PIPE v1: Werk-Token — jede Anzeige wird gegen das aktuell gewaehlte Werk geprueft */
  var myArt=st.artUrl||'';
  var fname=apSrvFname();
  if(!fname){ box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px;text-align:center;padding:20px">Lade zuerst dein Foto hoch und generiere ein Kunstwerk.</div>'; if(hint)hint.textContent=''; return; }
  var key=apSrvKey();
  if(!key){ box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px;text-align:center;padding:20px">Materialansicht für dieses Material folgt in Kürze.</div>'; if(hint)hint.textContent=''; return; }
  var ck=key+'|'+fname;
  window._apSrvCache=window._apSrvCache||{};
  function apShowSrv(u){
    if((st.artUrl||'')!==myArt)return; /* PIPE v1: inzwischen anderes Werk gewaehlt -> verwerfen */
    box.innerHTML='<img class="ap-mock-img" src="'+u+'" style="'+((window.apMockZoomStil&&window.apMockZoomStil(key))||'position:absolute;inset:0;width:100%;height:100%;object-fit:contain')+'">'; /* AP-WANDZOOM-3110 */
    apMockNav(box);
    if(hint)hint.textContent=(apSrvKeys().length>1?(AP_L==='en'?'View '+((st.mockView||0)+1)+' of '+apSrvKeys().length+' · swipe to browse':'Ansicht '+((st.mockView||0)+1)+' von '+apSrvKeys().length+' · wischen zum Bl\u00e4ttern'):(AP_L==='en'?'This is how your artwork looks on the wall':'So sieht dein Kunstwerk an der Wand aus'));
  }
  if(window._apSrvCache[ck]){ apShowSrv(window._apSrvCache[ck]); return; }
  if(!document.getElementById('ap-mock-shim-css')){var _s=document.createElement('style');_s.id='ap-mock-shim-css';_s.textContent='@keyframes apMockBeat{0%,100%{transform:scale(1);opacity:.72}50%{transform:scale(1.18);opacity:1}}#ap .ap-mock-load{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:5}#ap .ap-mock-load svg{width:54px;height:54px;filter:drop-shadow(0 3px 12px rgba(0,0,0,.4));animation:apMockBeat 1s ease-in-out infinite}';document.head.appendChild(_s);}
  var hasImg = box.firstChild && box.firstChild.tagName==='IMG';
  if(!hasImg){
    var _asrc=(st.artImg&&st.artImg.src)||'';
    box.innerHTML='<img src="'+_asrc+'" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;filter:blur(7px) brightness(.55);transform:scale(1.08)"><div class="ap-mock-load"><svg viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></div>';
  } else if(!box.querySelector('.ap-mock-reload')){
    /* Farbwechsel/Re-Render: aktuelles Mockup behalten, Herz drueberlegen -> nie "kaputt"-Gefuehl */
    var _ov=document.createElement('div');_ov.className='ap-mock-load ap-mock-reload';_ov.style.background='rgba(20,16,14,.34)';
    _ov.innerHTML='<svg viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
    box.appendChild(_ov);
  }
  var seq=++window._apSrvSeq;
  fetch(AP_SRV_URL+'?img='+encodeURIComponent(fname)+'&mockup='+key+'&px=2000')
    .then(function(r){return r.json();})
    .then(function(d){
      if(!d||!d.ok){ if(seq===window._apSrvSeq)box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px">'+(AP_L==='en'?'This view is currently unavailable.':'Ansicht derzeit nicht verfügbar.')+'</div>'; return; }
      var im=new Image();
      im.onload=function(){ window._apSrvCache[ck]=d.url; if(seq!==window._apSrvSeq)return; apShowSrv(d.url); };
      im.onerror=function(){ if(seq===window._apSrvSeq)box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px">'+(AP_L==='en'?'This view is currently unavailable.':'Ansicht derzeit nicht verfügbar.')+'</div>'; };
      im.src=d.url;
      apSrvPrefetch(fname);
    }).catch(function(){ if(seq===window._apSrvSeq)box.innerHTML='<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999;font-size:12px">'+(AP_L==='en'?'This view is currently unavailable.':'Ansicht derzeit nicht verfügbar.')+'</div>'; });
};

/* ── TABS ── */
window.apTab=function(tab){
  ['Vorschau','Raum','Material'].forEach(function(t){
    var tabEl=document.getElementById('tab'+t);
    var paneEl=document.getElementById('pane'+t);
    if(tabEl)tabEl.classList.remove('on');
    if(paneEl)paneEl.classList.remove('on');
  });
  document.getElementById('tab'+tab.charAt(0).toUpperCase()+tab.slice(1)).classList.add('on');
  document.getElementById('pane'+tab.charAt(0).toUpperCase()+tab.slice(1)).classList.add('on');
  if(tab==='raum')apDrawRoom();
  if(tab==='material')apDrawMockup();
};

/* "An der Wand" zeigt je nach Material PSD-Mockup ODER Raumansicht */
/* Resize-Observer entfernt (v152): Server-Bild skaliert per CSS */

window.apWand=function(){
  /* Stil-Fenster schließen beim Wechsel in die Wand-Ansicht */
  var _ww=document.getElementById('apWerkeWrap');
  var _wc=document.getElementById('apStileChevron');
  if(_ww)_ww.style.display='none';
  if(_wc)_wc.textContent='▾';
  ['Vorschau','Raum','Material'].forEach(function(t){
    var te=document.getElementById('tab'+t), pe=document.getElementById('pane'+t);
    if(te)te.classList.remove('on'); if(pe)pe.classList.remove('on');
  });
  var tm=document.getElementById('tabMaterial'); if(tm)tm.classList.add('on');
  var hasPSD=true; /* v152: alle Materialien -> Server-Mockup-Pane */
  if(st.artImg && hasPSD){
    var pm=document.getElementById('paneMaterial'); if(pm)pm.classList.add('on');
    if(typeof apDrawMockup==='function')apDrawMockup();
  } else {
    var pr=document.getElementById('paneRaum'); if(pr)pr.classList.add('on');
    if(typeof apDrawRoom==='function')apDrawRoom();
  }
};

/* ── MOBILE STICKY ── */
(function(){
  if(!window.IntersectionObserver)return;
  /* Canvas beobachten statt verstecktes Bild */
  var target=document.getElementById('apWmCanvas')||document.getElementById('apResultSection');
  if(!target)return;
  var obs=new IntersectionObserver(function(entries){
    if(window.innerWidth>680)return;
    var sticky=document.getElementById('apMobileSticky');
    if(!sticky)return;
    if(!entries[0].isIntersecting&&st.artImg&&st.persOpen){
      sticky.classList.add('visible');
      drawMini();
    } else{
      sticky.classList.remove('visible');
    }
  },{threshold:0.1});
  obs.observe(target);
})();

/* ── GRÖSSE ── */
window.apSize=function(btn){
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.size=btn.dataset.size;
  st.price=parseFloat(btn.dataset.price);
  aktualisierePreis();
  /* Groessenwechsel muss das Wand-Mockup neu zeichnen — aber nur wenn es sichtbar ist */
  var _pm=document.getElementById('paneMaterial');
  if(st.artImg&&_pm&&_pm.classList.contains('on')&&typeof apDrawMockup==='function')apDrawMockup();
};

function apSzName(s){
  var isQuer=st.format==='quer';
  /* USA (11.08.): Zoll statt Zentimeter */
  if (typeof apIsUS==='function' && apIsUS()) {
    var namesUS={
      s: isQuer?'12\u00d78"':'8\u00d712"',
      m: isQuer?'24\u00d716"':'16\u00d724"',
      l: isQuer?'30\u00d720"':'20\u00d730"',
      xl: isQuer?'36\u00d724"':'24\u00d736"',
      xxl: isQuer?'48\u00d736"':'36\u00d748"'
    };
    return namesUS[s]||s;
  }
  var names={
    s: isQuer?'30×20 cm':'20×30 cm',
    m: isQuer?'60×40 cm':'40×60 cm',
    l: isQuer?'90×60 cm':'60×90 cm',
    xl: isQuer?'120×80 cm':'80×120 cm',
    xxl: isQuer?'150×100 cm':'100×150 cm'
  };
  return names[s]||s;
}

function aktualisierePreis(){
  var pNow=document.getElementById('apPriceNow');if(pNow)pNow.textContent=fmt(st.price);
  var pBuy=document.getElementById('apBuyP');if(pBuy)pBuy.textContent=fmt(st.price);
  var pWas=document.getElementById('apPriceWas');if(pWas)pWas.style.display='none';
  var pSave=document.getElementById('apPriceSave');if(pSave)pSave.style.display='none';
}
function fmt(p){return apIsUS() ? ('$'+p.toFixed(2)) : ((AP_L==='en') ? ('€'+p.toFixed(2)) : (p.toFixed(2).replace('.',',')+' €'));}   /* 19.10.: /en = Euro */

function apFormatName(){
  return st.format==='quer'?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Landscape':'Querformat'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Portrait':'Hochformat');
}

/* ── POSITIONS-PAD ── */
/* ── RETRY ── */
window.apRetry=function(){
  /* NEUES Foto im AKTUELLEN Stil: nach Foto-Wahl direkt generieren (Ladebildschirm), kein Zurueckwerfen.
     Ein bereits generiertes Bild kommt nie zurueck in den Kreislauf (immer echte Datei). */
  st.pendingStil = st.stil || 'aquarell';
  var fi=document.getElementById('apFileInput');
  if(fi){ fi.value=''; fi.click(); }
};
/* apChangeStil entfernt — Stil-Slider im Bearbeitungsmodus ersetzt es */

window.apCartBarOpen=function(){
  var b=document.getElementById('apCartBar'); if(!b)return;
  b.classList.add('on');
  try{ b.scrollIntoView({behavior:'smooth',block:'nearest'}); }catch(e){}
};
window.apCartBarClose=function(){
  var b=document.getElementById('apCartBar'); if(b) b.classList.remove('on');
};

/* 25.10.: Schriftfelder v2 — Text-Properties fuer Leinwand UND Download (apBuy + apBuyDL) */
function apSfProps(props){
  var _sfT=apSfTexte(), _sfC=st.pers.calc;
  if(_sfT.l1)props['Text Zeile 1']=_sfT.l1;
  if(_sfT.l2)props['Text Zeile 2']=_sfT.l2;
  if((_sfT.l1||_sfT.l2)&&_sfC)props['_text_meta']=JSON.stringify({
    v:2,vorlage:_sfC.vorlage,font:_sfC.font,l1:_sfT.l1,l2:_sfT.l2,size:_sfC.size,
    pos:_sfC.pos,farbe:_sfC.farbe,lasur:_sfC.lasur,
    color:(_sfC.farbe==='hell'?'#FAF7F1':'#1A1714'),weight:3,
    d1x:_sfC.d1x,d1y:_sfC.d1y,d2x:_sfC.d2x,d2y:_sfC.d2y
  });
  return props;
}
/* ── KAUFEN ── */
window.apBuy=function(_stay){
  /* Doppelklick-Guard: zwei Taps auf langsamer Verbindung = identische
     /cart/add.js-POSTs, Shopify merged sie zu Menge 2 im Checkout (Fund
     21.08.). apGen guarded laengst — der Kauf-Knopf war ungeschuetzt. */
  if(st.kaufLaeuft) return;
  st.kaufLaeuft=true;
  var vid=apVid(st.size);
  var props={};props[AP_L==='en'?'Art style':'Kunststil']=st.stilName;props[AP_L==='en'?'Size':'Größe']=apSzName(st.size);
  apSfProps(props);
  if(st.artUrl)props['_artwork_url']=st.artUrl;
  /* AP-KORB-DOPPELT-2910: gleiches Bild schon im Warenkorb -> nicht nochmal hinzufuegen (sonst Menge 2) */
  fetch('/cart.js').then(function(r){return r.json();}).catch(function(){return {items:[]};})
    .then(function(c){
      var drin=!!st.artUrl&&(c.items||[]).some(function(it){var p=it.properties||{};return String(it.variant_id)===String(vid)&&p._artwork_url===st.artUrl&&(p['Text Zeile 1']||'')===(props['Text Zeile 1']||'')&&(p['Text Zeile 2']||'')===(props['Text Zeile 2']||'');});
      if(drin) return {_schonDrin:true};
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:vid,quantity:1,properties:props})}).then(function(r){return r.json();});
    })
    .then(function(d){
      if(d.status===422||d.description){st.kaufLaeuft=false;alert('Cart Fehler: '+d.description);return;}
      if(_stay){ st.kaufLaeuft=false; if(window.apCartBarOpen) window.apCartBarOpen(); return; }
      window.location.href='/cart'; /* AP-ZURUECK-WARENKORB-3010: Kunde sieht sein Kunstwerk vor der Kasse */
    })
    .catch(function(e){st.kaufLaeuft=false;alert('Fehler: '+e);});
};
window.apBuyDL=function(){
  if(st.kaufLaeuft) return;   /* gemeinsamer Guard mit apBuy — blockt auch Kreuz-Doppelkauf */
  st.kaufLaeuft=true;
  var props={};props[AP_L==='en'?'Art style':'Kunststil']=st.stilName;
  if(st.artUrl)props['_artwork_url']=st.artUrl;
  apSfProps(props);
  /* Warenkorb erst leeren → nur der digitale Download landet drin (keine Leinwand-Reste, keine Mengen-Summierung) */
  fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
    .then(function(){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:apDLVid(),quantity:1,properties:props})});
    })
    .then(function(r){return r.json();})
    .then(function(d){
      if(d.status===422||d.description){st.kaufLaeuft=false;alert('Konnte nicht in den Warenkorb gelegt werden: '+(d.description||'Unbekannter Fehler'));return;}
      window.location.href='/checkout';
    })
    .catch(function(e){st.kaufLaeuft=false;alert('Fehler: '+e);});
};

/* ── VARIANTEN IDs — alle 3 Materialien ── */
var AP_VIDS = {
  canvas: {
    hoch: {s:'53374626038026',m:'53374626070794',l:'53374626103562',xl:'53374626136330'},
    quer: {s:'53374626038026',m:'53374626070794',l:'53374626103562',xl:'53374626136330'}
  },
  framed: {
    hoch: {
      white: {s:'53261835141386',m:'53261835272458',l:'53261835403530',xl:'53261835534602',xxl:'53261835665674'},
      wood: {s:'53261835174154',m:'53261835305226',l:'53261835436298',xl:'53261835567370',xxl:'53261835698442'},
      dark: {s:'53261835206922',m:'53261835337994',l:'53261835469066',xl:'53261835600138',xxl:'53261835731210'},
      black: {s:'53261835239690',m:'53261835370762',l:'53261835501834',xl:'53261835632906',xxl:'53261835763978'}
    },
    quer: {
      white: {s:'53261835796746',m:'53261835927818',l:'53261836058890',xl:'53261836189962',xxl:'53261836321034'},
      wood: {s:'53261835829514',m:'53261835960586',l:'53261836091658',xl:'53261836222730',xxl:'53261836353802'},
      dark: {s:'53261835862282',m:'53261835993354',l:'53261836124426',xl:'53261836255498',xxl:'53261836386570'},
      black: {s:'53261835895050',m:'53261836026122',l:'53261836157194',xl:'53261836288266',xxl:'53261836419338'}
    }
  },
  acrylic: {
    hoch: {s:'53261702693130',m:'53261702725898',l:'53261702758666',xl:'53261702791434',xxl:'53261702824202'},
    quer: {s:'53261702856970',m:'53261702889738',l:'53261702922506',xl:'53261702955274',xxl:'53261702988042'}
  },
  framed_canvas: {
    hoch: {
      wood:  {s:'53375138562314',m:'53375138660618',l:'53375138758922',xl:'53375138857226'},
      white: {s:'53375138529546',m:'53375138627850',l:'53375138726154',xl:'53375138824458'},
      black: {s:'53375138496778',m:'53375138595082',l:'53375138693386',xl:'53375138791690'}
    },
    quer: {
      wood:  {s:'53375138562314',m:'53375138660618',l:'53375138758922',xl:'53375138857226'},
      white: {s:'53375138529546',m:'53375138627850',l:'53375138726154',xl:'53375138824458'},
      black: {s:'53375138496778',m:'53375138595082',l:'53375138693386',xl:'53375138791690'}
    }
  }
};

/* USA (11.08.): Groessen in Zoll */
var AP_ZOLL = {
  s:   {hoch:'8 \u00d7 12"',  quer:'12 \u00d7 8"'},
  m:   {hoch:'16 \u00d7 24"', quer:'24 \u00d7 16"'},
  l:   {hoch:'20 \u00d7 30"', quer:'30 \u00d7 20"'},
  xl:  {hoch:'24 \u00d7 36"', quer:'36 \u00d7 24"'},
  xxl: {hoch:'36 \u00d7 48"', quer:'48 \u00d7 36"'}
};

/* Preise pro Material */
var AP_PREISE = {
  canvas:        {s:'49,90',  m:'79,90',  l:'119,90', xl:'159,90', xxl:null},
  framed:        {s:'89,95',  m:'114,95', l:'149,95', xl:'189,95', xxl:'234,95'},
  acrylic:       {s:'84,95',  m:'109,95', l:'139,95', xl:'174,95', xxl:'214,95'},
  framed_canvas: {s:'79,90',  m:'119,90', l:null,     xl:'279,90', xxl:null}
};

/* USA (11.08.): Preise in USD, netto - Sales Tax kommt beim Checkout dazu */
var AP_PREISE_US = {
  canvas:        {s:'69.90', m:'119.90', l:'169.90', xl:'219.90', xxl:null},
  framed:        {s:'129', m:'209', l:'269', xl:'329', xxl:null},
  acrylic:       {s:'139', m:'199', l:'259', xl:'319', xxl:null},
  framed_canvas: {s:'109.90', m:'199.90', l:'259.90', xl:'319.90', xxl:null}
};
/* ── VARIANTEN IDs USA (13.08.) — eigene Produkte, USD-Festpreise ── */
var AP_VIDS_US = {
  canvas: {
    hoch: {s:'53513233826058',m:'53513233858826',l:'53513233891594',xl:'53513233924362'},
    quer: {s:'53513233826058',m:'53513233858826',l:'53513233891594',xl:'53513233924362'}
  },
  framed_canvas: {
    hoch: {
      black: {s:'53513234022666',m:'53513234120970',l:'53513234219274',xl:'53513234317578'},
      white: {s:'53513234055434',m:'53513234153738',l:'53513234252042',xl:'53513234350346'},
      wood:  {s:'53513234088202',m:'53513234186506',l:'53513234284810',xl:'53513234383114'}
    },
    quer: {
      black: {s:'53513234022666',m:'53513234120970',l:'53513234219274',xl:'53513234317578'},
      white: {s:'53513234055434',m:'53513234153738',l:'53513234252042',xl:'53513234350346'},
      wood:  {s:'53513234088202',m:'53513234186506',l:'53513234284810',xl:'53513234383114'}
    }
  }
};

function apIsUS(){
  /* Markt = DOMAIN, nicht Sprache. us.arturell.com ist an den US-Katalog
     gebunden; Sprache und Geolokation sind dafuer kein verlaessliches Signal.
     Im Zweifel DACH — lieber ein Amerikaner mit Euro-Preis, der abbricht,
     als eine DACH-Bestellung, die in Ohio gedruckt wird. */
  try { return /^us\./i.test(location.hostname); } catch(e){ return false; }
}
function apPreisTab(){
  var t = apIsUS() ? AP_PREISE_US : AP_PREISE;
  return t[st.material] || t.canvas;
}
function apPreisFmt(v){
  if (v === null || v === undefined || v === '') return '';
  return apIsUS() ? ('$' + String(v)) : (String(v).replace('.',',') + ' €');
}

/* Benefit-Texte */
var AP_BENEFITS = {
  canvas:        ['Premium Thick Canvas','4cm Keilrahmen','Aufhängefertig'],
  framed:        ['Schattenfugenrahmen','100 % recycelter Kunststoff · 3 Farben','Aufhängefertig'],
  acrylic:       ['Crystal-Clear Acrylglas','Hochglanz · Tiefenwirkung','Aufhängefertig'],
  framed_canvas: ['Leinwand + schwebender Rahmen','3 Rahmenfarben','Galerie-Look']
};

function apVid(sz) {
  var m = st.material || 'canvas';
  var f = st.format  || 'hoch';
  var TAB = (typeof apIsUS === 'function' && apIsUS()) ? AP_VIDS_US : AP_VIDS;
  if (m === 'framed' || m === 'framed_canvas') {
    var c = st.farbe || 'black';
    return (TAB[m] && TAB[m][f] && TAB[m][f][c] && TAB[m][f][c][sz]) || '0';
  }
  return (TAB[m] && TAB[m][f] && TAB[m][f][sz]) || '0';
}
function apDLVid(){return '53282865250570';}

/* Material wechseln */
window.apMaterial = function(btn) {
  document.querySelectorAll('#ap .ap-mat-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.material = btn.dataset.mat;
  // Größen-Label je Material
  var sizeLabels=(AP_L==='en'?{canvas:'Canvas size',framed:'Print size',acrylic:'Acrylic size',framed_canvas:'Canvas size'}:{canvas:'Leinwandgröße',framed:'Bildgröße',acrylic:'Acrylglas-Größe',framed_canvas:'Leinwandgröße'});
  var slEl=document.getElementById('apSizeLabel');
  if(slEl)slEl.textContent=sizeLabels[st.material]||(AP_L==='en'?'Size':'Größe');
  // Rahmenfarbe ein/ausblenden
  var fEl = document.getElementById('apFarbe');
  var showFarbe = st.material === 'framed' || st.material === 'framed_canvas';
  if (fEl) fEl.style.display = showFarbe ? '' : 'none';
  // CSS-Klasse für White-Button Sichtbarkeit
  var apEl = document.getElementById('ap');
  if (apEl) {
    apEl.classList.remove('mat-framed-canvas');apEl.classList.remove('mat-framed');
    if (st.material === 'framed_canvas') apEl.classList.add('mat-framed-canvas');
    if (st.material === 'framed') apEl.classList.add('mat-framed');
    if (st.material === 'framed' && (st.farbe==='dark'||!st.farbe)) { st.farbe='black'; document.querySelectorAll('#ap .ap-farbe-btn').forEach(function(b){b.classList.toggle('on', b.dataset.farbe==='black');}); }
    /* framed_canvas: 'dark' existiert nicht mehr -> Schwarz */
    if (st.material === 'framed_canvas' && (st.farbe==='dark'||!st.farbe)) { st.farbe='black'; document.querySelectorAll('#ap .ap-farbe-btn').forEach(function(b){b.classList.toggle('on', b.dataset.farbe==='black');}); }
  }
  // XXL ein/ausblenden
  /* USA: weder 'framed' noch 'acrylic' existieren als US-Produkt -> XXL nie zeigen */
  var hasXXL = (typeof apIsUS==='function' && apIsUS()) ? false
             : (st.material === 'framed' || st.material === 'acrylic');
  var xxlEl = document.getElementById('apSzXXL');
  if (xxlEl) xxlEl.style.display = hasXXL ? '' : 'none';
  if (!hasXXL && st.size === 'xxl') {
    var xlBtn = document.querySelector('#ap .ap-size-btn[data-size="xl"]');
    if (xlBtn) apSize(xlBtn);
  }
  // L ausblenden: merchOne fuehrt 90x60 NICHT als Framed Canvas (bestaetigt 23.07.)
  /* L: merchOne EU fuehrt 90x60 NICHT als Framed Canvas (bestaetigt 23.07.).
     In den USA existiert L gerahmt (20x30") -> dort immer zeigen. */
  var hasL = (typeof apIsUS==='function' && apIsUS()) ? true
           : (st.material !== 'framed_canvas');
  var lEl = document.querySelector('#ap .ap-size-btn[data-size="l"]');
  if (lEl) lEl.style.display = hasL ? '' : 'none';
  if (!hasL && st.size === 'l') {
    var mBtn = document.querySelector('#ap .ap-size-btn[data-size="m"]');
    if (mBtn) apSize(mBtn);
  }
  // Preise direkt inline aktualisieren (robust)
  var p = apPreisTab();
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(sb) {
    var sz = sb.dataset.size;
    if (!sz || !p[sz]) return;
    var prEl = sb.querySelector('.sz-price');
    if (prEl) prEl.textContent = apPreisFmt(p[sz]);
    sb.dataset.price = String(p[sz]).replace(',','.');
  });
  var xxlPr = document.getElementById('apPr_xxl');
  if (xxlPr) xxlPr.textContent = apPreisFmt(p.xxl);
  // apUpdateBenefits
  if (typeof apUpdateBenefits === 'function') apUpdateBenefits();
  // Preis-Anzeige aktualisieren
  if (typeof apUpdateCurrentPrice === 'function') apUpdateCurrentPrice();
  // Material durchklicken -> immer in "An der Wand" springen (flüssig)
  if(st.artImg && typeof apWand==='function') apWand();
};

/* Rahmenfarbe wechseln */
window.apFarbe = function(btn) {
  document.querySelectorAll('#ap .ap-farbe-btn').forEach(function(b){b.classList.remove('on')});
  btn.classList.add('on');
  st.farbe = btn.dataset.farbe;
  if(window.apDrawMockup && st.artImg)apDrawMockup();
};

/* ── "↑ Vorschau"-Hinweis (nur mobile, wenn Vorschau aus dem Bild gescrollt) ── */
var _apHintT=null;
function apShowUpHint(){
  if(window.innerWidth>680||!st.artImg)return;
  var cv=document.getElementById('apWmCanvas');
  var h=document.getElementById('apUpHint');
  if(!cv||!h)return;
  if(cv.getBoundingClientRect().bottom>90)return; /* Vorschau sichtbar → kein Hinweis */
  if(h.parentNode!==document.body)document.body.appendChild(h); /* raus aus Transform-Containern (fixed-Falle) */
  h.style.display='block';
  clearTimeout(_apHintT);
  _apHintT=setTimeout(function(){h.style.display='none';},3000);
}
/* apScrollPreview entfernt (v172) — Pille ist jetzt nativer Anker-Link auf #apResultSection */
(function(){
  var _m=window.apMaterial,_f=window.apFarbe;
  window.apMaterial=function(b){_m(b);apShowUpHint();};
  window.apFarbe=function(b){_f(b);apShowUpHint();};
})();

/* In-Card-Swatch: wählt Material + Farbe über die bestehende Logik */
window.apPickFarbe = function(swEl, matVal, farbe){
  var card=document.querySelector('#ap .ap-mat-btn[data-mat="'+matVal+'"]');
  if(card && typeof apMaterial==='function')apMaterial(card);
  var fb=document.querySelector('#ap .ap-farbe-btn[data-farbe="'+farbe+'"]');
  if(fb && typeof apFarbe==='function')apFarbe(fb);
  if(card){
    card.querySelectorAll('.ap-mat-sw').forEach(function(s){s.classList.remove('on');});
    if(swEl)swEl.classList.add('on');
  }
};

/* Preise der Größen-Buttons aktualisieren */
window.apUpdatePrices = function() {
  var p = apPreisTab();
  // Alle Größen-Buttons aktualisieren
  document.querySelectorAll('#ap .ap-size-btn').forEach(function(btn) {
    var sz = btn.dataset.size;
    if (!sz) return;
    var priceEl = btn.querySelector('.sz-price');
    if (priceEl && p[sz]) priceEl.textContent = apPreisFmt(p[sz]);
    if (p[sz]) btn.dataset.price = String(p[sz]).replace(',','.');
  });
  // XXL separat (hat ID)
  var xxlPr = document.getElementById('apPr_xxl');
  if (xxlPr) xxlPr.textContent = apPreisFmt(p.xxl);
  /* 23.10. US-Startpreis: apSize(S) beim Laden hat den EURO-Wert 49.90 aus dem HTML (data-price) als $49.90 in
     Preis oben und Kaufknopf geschrieben. Den aktiven Knopf hier mit dem US-Preis nachziehen. Nur us.; DE und /en unveraendert. */
  try {
    if (typeof apIsUS === 'function' && apIsUS()) {
      var _onB = document.querySelector('#ap .ap-size-btn.on');
      var _pv = _onB && p[_onB.dataset.size];
      if (_pv) {
        ['apPriceNow', 'apBuyP'].forEach(function(_id){ var _el = document.getElementById(_id); if (_el) _el.textContent = apPreisFmt(_pv); });
        try { st.price = parseFloat(String(_pv).replace(',', '.')); } catch(e2) {}
      }
    }
  } catch(e) {}
  apUpdateCurrentPrice();
};

/* Benefit-Chips aktualisieren */
window.apUpdateBenefits = function() {
  var el = document.getElementById('apBenefits');
  if (!el) return;
  var chips = AP_BENEFITS[st.material] || AP_BENEFITS.canvas;
  el.innerHTML = chips.map(function(t){
    return '<span class="ap-benefit-chip">'+t+'</span>';
  }).join('');
};

/* Aktuellen Preis aktualisieren */
window.apUpdateCurrentPrice = function() {
  var p = apPreisTab();
  var sz = st.size || 'm';
  var preis = p[sz] || p.m;
  if (!preis) return;
  var el = document.getElementById('apCurrentPrice');
  if (el) el.textContent = apPreisFmt(preis);
};

/* ── INIT ── */
var defM=document.querySelector('#ap .ap-size-btn[data-size="s"]');
if(defM)apSize(defM);
var defFmt=document.querySelector('#ap .ap-fmt-btn[data-fmt="hoch"]');
if(defFmt)apFmt(defFmt);

/* UMBAU: Stil-Slider initial rendern */
apRenderStilSlider();
var AP_KAR_EXTRA={}; /* 19.10.: aus – brachte Golden + schwarze Katze doppelt in die Leiste */
/* 18.10. Anlass-Leiste: ?anlass=hochzeit|tier zeigt nur passende Motive (Leiste + Stil-Karten) */
var AP_ANLASS_KAR={"hochzeit": {"lineart": "https://cdn.arturell.com/galerie/v28/common/test-hochzeit--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/ads-hochzeit-blond--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/kachel-k3-1810--aquarell-splash-rand--hochzeit--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-hz3-strand--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/clip-inf3-hochzeit--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-hz3-schleier--rustic-rand--hochzeit--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/ads-hochzeit-seite--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-hz3-jahrestag--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-hz-paar-kirche--impressionismus--hochzeit--{L}.webp", "oel-golden": "https://cdn.arturell.com/galerie/v28/common/m-hz2-regen--oel-golden.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-hz2-brautstrauss--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-hz-paar-kuss--klimt--hochzeit--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-hz-paar-konfetti--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-hz-paar-tanz--emerald.webp"}, "valentin": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-vl3-paar-kaffee--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/m-vl-lachen--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/ads-paar-strand--aquarell-splash-rand--valentin--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/ads-paar-lachend--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-vl-fruehstueck--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-vl-spaziergang--rustic-rand--hochzeit--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/ads-paar-kuss--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-vl2-balkon--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/clip-07-paar--impressionismus--hochzeit--{L}.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-vl-rosen--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-vl2-sofa--klimt--valentin--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-vl2-kochen--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/ads-paar-blond-kuss--emerald.webp"}, "hund": {"lineart": "https://cdn.arturell.com/galerie/v28/common/clip-hund-corgi--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/web-kind-hund--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-hund-border--aquarell-splash-rand--hund--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-hund--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-hund-aussie--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/clip-inf-paar-hund--rustic-rand--hund--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/ads-familie-3-hund--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/dreier--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/clip-29-labrador-schnee--impressionismus--hund--{L}.webp", "oel-golden": "https://cdn.arturell.com/galerie/v28/common/clip-16-golden--oel-golden.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-hund-dalmatiner--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-hund-collie--klimt--familie--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-hund-chihuahua--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-hund-dackel--emerald.webp", "royal": "https://cdn.arturell.com/galerie/v28/{L}/clip-hund-mops--royal--hund--{L}.webp", "ritter": "https://cdn.arturell.com/galerie/v28/common/clip-25-frenchie--ritter.webp"}, "katze": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-katze-siam--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/clip-katze-ragdoll--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-katze-britisch--aquarell-splash-rand--katze--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-katze--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-katze-birma--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/common/clip-13-paar-kater--rustic-rand.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-katze-grau--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-katze-langhaar--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-katze-norweger--impressionismus--katze--{L}.webp", "oel-golden": "https://cdn.arturell.com/galerie/v28/common/clip-inf3-drei-katzen--oel-golden.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-katze-schwarz--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/clip-katze-bengal--klimt--hund--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-katze-rot--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-katze-schildpatt--emerald.webp", "royal": "https://cdn.arturell.com/galerie/v28/{L}/m-katze-maincoon--royal--katze--{L}.webp", "koenigin": "https://cdn.arturell.com/galerie/v28/common/m-katze-dreifarbig--koenigin.webp", "ritter": "https://cdn.arturell.com/galerie/v28/common/m-katze-weiss--ritter.webp"}, "pferd": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-pferd-weide--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/clip-pferd-weide--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/pferd2--aquarell-splash-rand--pferd--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-pferd--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-pferd-araber--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-pferd-haflinger--rustic-rand--pferd--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-pferd-islaender--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/clip-18-pferd--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-pferd-pony--impressionismus--pferd--{L}.webp", "oel-golden": "https://cdn.arturell.com/galerie/v28/common/m-pferd-braun--oel-golden.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-pferd-tinker--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-pferd-schimmel--klimt--pferd--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-pferd-rappe--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-pferd-tigerschecke--emerald.webp"}, "tier": {"lineart": "https://cdn.arturell.com/galerie/v28/common/clip-14-zwei-hunde-katze--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/tiere3--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/clip-inf3-hund-katze--aquarell-splash-rand--hund--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/ads-mischling-ruhig--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-katze-birma--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/mix4--rustic-rand--hund--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/t-hasehund--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-katze-langhaar--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/t-drei--impressionismus--hund--{L}.webp", "oel-golden": "https://cdn.arturell.com/galerie/v28/common/t-vogelkatze--oel-golden.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/pferd2--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/clip-katze-bengal--klimt--hund--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-hund-chihuahua--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/dreier--emerald.webp", "royal": "https://cdn.arturell.com/galerie/v28/{L}/m-katze-maincoon--royal--katze--{L}.webp", "koenigin": "https://cdn.arturell.com/galerie/v28/common/m-katze-dreifarbig--koenigin.webp", "ritter": "https://cdn.arturell.com/galerie/v28/common/clip-hund-corgi--ritter.webp"}, "mama": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-mt-baby--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/ads-mama-allein--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-mt-sohn--aquarell-splash-rand--mama--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/ads-mama-tochter--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-mt2-zwillinge--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-mt-tochter--rustic-rand--familie--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-mt-zwei-kinder--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-mt2-drei-kinder--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-mt2-kleinkind--impressionismus--mama--{L}.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-mt3-mutter-tochter--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-mt2-teenager--klimt--mama--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-mt2-sohn-gross--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/clip-mutter--emerald.webp"}, "papa": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-vt3-vater-sohn--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/m-vt4-angeln2--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-vt-schultern--aquarell-splash-rand--familie--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-vater--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-vt-baby--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-vt-sohn-gross--rustic-rand--familie--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-vt-tochter--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-vt-zwei-kinder--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-vt2-drei-kinder--impressionismus--papa--{L}.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-vt2-teenager--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-vt2-kleinkind--klimt--papa--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/clip-02-vater-sohn--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-vt2-maedchen-schultern--emerald.webp"}, "geburtstag": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-gb4-torte--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/m-gb4-geschenk--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-gb4-freundinnen--aquarell-splash-rand--geburtstag--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-gb-frau-30--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-gb-kind-torte--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-gb4-ballonpaar--rustic-rand--geburtstag--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-gb-teen-ballons--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-gb4-blumen--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-gb4-garten--impressionismus--geburtstag--{L}.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-gb4-grill--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-gb4-geschwister--klimt--geburtstag--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-gb4-konfetti--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-gb4-picknick--emerald.webp"}, "weihnachten": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-wn3-kind-geschenk--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/m-wn4-markt--aquarell-hell-rand.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-wn4-kamin--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-wn4-tisch--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-wn4-schnee-hund--rustic-rand--weihnachten--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-wn2-plaetzchen--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-wn4-katze-fenster--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-wn4-kakao--impressionismus--weihnachten--{L}.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-wn4-schneemann2--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-wn4-muetze--klimt--weihnachten--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-wn4-schlitten2--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-wn4-sterne--emerald.webp"}, "eid": {"lineart": "https://cdn.arturell.com/galerie/v28/common/m-eid2-festlich--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/m-eid2-kopftuch--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-eid2-freundinnen--aquarell-splash-rand--eid--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/m-eid-familie-01--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/m-eid-familie-moschee--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/m-eid2-festtisch--rustic-rand--eid--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/m-eid2-laterne--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/m-eid-mutter-tochter--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/m-eid2-festgewand--impressionismus--eid--{L}.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/m-eid2-geschenkfrau--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/m-eid-vater-kinder--klimt--eid--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-eid2-geschenkmann--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/m-eid2-familientisch2--emerald.webp"}, "famg": {"lineart": "https://cdn.arturell.com/galerie/v28/common/clip-inf3-eltern-baby--lineart.webp", "aquarell-hell-rand": "https://cdn.arturell.com/galerie/v28/common/clip-08-familie-vier--aquarell-hell-rand.webp", "aquarell-splash-rand": "https://cdn.arturell.com/galerie/v28/{L}/clip-12-bruder-schwester--aquarell-splash-rand--familie--{L}.webp", "aquarell": "https://cdn.arturell.com/galerie/v28/common/kachel-fg-zweikatzen--aquarell.webp", "aquarell-splash": "https://cdn.arturell.com/galerie/v28/common/clip-v2-drei-hunde--aquarell-splash.webp", "rustic-rand": "https://cdn.arturell.com/galerie/v28/{L}/t-pferdhund--rustic-rand--familie--{L}.webp", "gouache": "https://cdn.arturell.com/galerie/v28/common/test-fam-n08--gouache.webp", "oel-hell": "https://cdn.arturell.com/galerie/v28/common/ads-familie-4--oel-hell.webp", "impressionismus": "https://cdn.arturell.com/galerie/v28/{L}/t-vogelkatze--impressionismus--familie--{L}.webp", "oel-golden": "https://cdn.arturell.com/galerie/v28/common/clip-inf3-geschwister--oel-golden.webp", "chromaflare": "https://cdn.arturell.com/galerie/v28/common/tiere3--chromaflare.webp", "klimt": "https://cdn.arturell.com/galerie/v28/{L}/t-hasehund--klimt--familie--{L}.webp", "van-gogh": "https://cdn.arturell.com/galerie/v28/common/m-mt2-sohn-gross--van-gogh.webp", "emerald": "https://cdn.arturell.com/galerie/v28/common/clip-09-zwei-schwestern--emerald.webp"}, "gedenken": {"regenbogenbruecke": "https://cdn.arturell.com/galerie/v28/common/ads-golden-gedenk-2--regenbogenbruecke.webp", "engel": "https://cdn.arturell.com/galerie/v28/common/ads-golden-gedenk-1--engel.webp", "sonnenstrahlen": "https://cdn.arturell.com/galerie/v28/{L}/clip-hund-berner--sonnenstrahlen--gedenken--{L}.webp", "sternenhimmel": "https://cdn.arturell.com/galerie/v28/common/m-gedenk-frau--sternenhimmel.webp", "gedenkkerze": "https://cdn.arturell.com/galerie/v28/common/clip-inf3-hund-katze--gedenkkerze.webp"}};   /* 19.10. 16:45: menschen/pferd neu, keine Gedenk-Stile in tier */
var AP_ANLASS_REIHE={"hochzeit": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald"], "jahrestag": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald"], "valentinstag": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "paar": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald"], "tier": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald", "royal", "koenigin", "ritter"], "hund": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald", "royal", "ritter"], "katze": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald", "royal", "koenigin", "ritter"], "pferd": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald"], "muttertag": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "vatertag": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "geburtstag": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "weihnachten": ["lineart", "aquarell-hell-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "eid": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "bayram": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "chromaflare", "klimt", "van-gogh", "emerald"], "familie": ["lineart", "aquarell-hell-rand", "aquarell-splash-rand", "aquarell", "aquarell-splash", "rustic-rand", "gouache", "oel-hell", "impressionismus", "oel-golden", "chromaflare", "klimt", "van-gogh", "emerald"], "gedenken": ["regenbogenbruecke", "engel", "sonnenstrahlen", "sternenhimmel", "gedenkkerze"], "andenken": ["regenbogenbruecke", "engel", "sonnenstrahlen", "sternenhimmel", "gedenkkerze"]};
var AP_ANLASS_GRUPPEN={"hochzeit": ["kunst"], "valentin": ["kunst"], "hund": ["kunst", "royal"], "katze": ["kunst", "royal"], "pferd": ["kunst"], "tier": ["kunst", "royal"], "mama": ["kunst"], "papa": ["kunst"], "geburtstag": ["kunst"], "weihnachten": ["kunst"], "eid": ["kunst"], "famg": ["kunst"], "gedenken": ["andenken"]};
/* 19.10. 18:35 Niklas: Hochzeit zeigt ALLE Kunst-Stile – Paar-Bilder bleiben, fehlende Stile mit Menschen-Bildern */
(function(){try{var h=AP_ANLASS_KAR.hochzeit,m=AP_ANLASS_KAR.menschen,k;if(h&&m){for(k in m){if(!h[k])h[k]=m[k];}}}catch(e){}})();
function apKarU(u){try{var l=((window.Shopify&&Shopify.locale)||'de').slice(0,2),g='de';if(l==='en')g=(location.host.indexOf('us.')>-1)?'us':'en';return String(u).replace(/\{L\}/g,g);}catch(e){return String(u).replace(/\{L\}/g,'de');}}   /* 27.10.: v27-Text-Bilder je Sprache (de/en/us) */
function apKarRes(m){var o={};for(var k in m){if(Object.prototype.hasOwnProperty.call(m,k))o[k]=apKarU(m[k]);}return o;}   /* 27.10.: {L} -> de/en/us fuer ALLE Leser der Karte */
function apKarAnlassMap(){try{var q=new URLSearchParams(window.location.search);var a=(q.get('anlass')||q.get('thema')||'').toLowerCase().trim();var M={'hochzeit':'hochzeit','jahrestag':'hochzeit','valentinstag':'valentin','paar':'hochzeit','tier':'tier','tiere':'tier','haustier':'tier','hund':'hund','katze':'katze','pferd':'pferd','muttertag':'mama','vatertag':'papa','geburtstag':'geburtstag','weihnachten':'weihnachten','eid':'eid','bayram':'eid','familie':'famg','gedenken':'gedenken','andenken':'gedenken'};var k=M[a]||'';/* 19.10. 17:50: Tierseiten bewusst gemischt (Niklas) */window.apAnlassKey=k;window.apAnlassName=a;window.apAnlassErlaubt=(k&&AP_ANLASS_GRUPPEN[k])?AP_ANLASS_GRUPPEN[k]:null;return (k&&AP_ANLASS_KAR[k])?apKarRes(AP_ANLASS_KAR[k]):null;}catch(e){return null;}}   /* 19.10. 16:45 */
function apKarAnlassKarten(m){try{Object.keys(m).forEach(function(id){document.querySelectorAll('#ap .ap-stil-btn[data-stil="'+id+'"]').forEach(function(k){var i=k.querySelector('img.ap-stil-card-img');if(i){i.src=apKarU(m[id]);i.removeAttribute('srcset');}var o=k.querySelector('.ap-stil-orig img'),w=k.querySelector('.ap-stil-orig');if(o&&m[id].indexOf('/galerie/v19/')>-1){o.src=m[id].replace('.jpg?','-foto.jpg?');o.removeAttribute('srcset');o.dataset.std=o.src;if(w)w.style.display='';}else if(w){w.style.display='none';}});});}catch(e){}} /* 19.10.: Abzug = Originalfoto, nie das Kunstwerk */
window.apAnlassGruppen=function(){try{var m=apKarAnlassMap();var e=window.apAnlassErlaubt;if(!e)return;var first=true;document.querySelectorAll('#ap .ap-stil-cat-head').forEach(function(h){var cg=h.getAttribute('data-cg');var g=h.nextElementSibling;var show=e.indexOf(cg)>-1;h.style.display=show?'':'none';if(g&&g.classList.contains('ap-stile-grid'))g.style.display=show?'':'none';if(show&&first){h.style.marginTop='0';first=false;}});document.querySelectorAll('#ap .ap-cat-chip').forEach(function(c){var d=c.getAttribute('data-cat');if(d!=='alle'&&e.indexOf(d)<0)c.style.display='none';});if(m){apKarAnlassKarten(m);document.querySelectorAll('#ap .ap-stil-btn').forEach(function(b){if(!m[b.getAttribute('data-stil')])b.style.display='none';});}
if(m&&window.apAnlassKey==='hochzeit'&&typeof AP_ANLASS_REIHE!=='undefined'){var R=AP_ANLASS_REIHE[window.apAnlassName]||AP_ANLASS_REIHE.hochzeit||[];var P=[];document.querySelectorAll('#ap .ap-stil-btn').forEach(function(b){if(P.indexOf(b.parentNode)<0)P.push(b.parentNode);});P.forEach(function(p){[].slice.call(p.children).filter(function(b){return b.classList.contains('ap-stil-btn');}).map(function(b,i){var r=R.indexOf(b.getAttribute('data-stil'));return {b:b,k:(r<0?999:r)*100+i};}).sort(function(x,y){return x.k-y.k;}).forEach(function(o){p.appendChild(o.b);});});}   /* 19.10. 18:50: Hochzeit Schritt 2 Paare zuerst */
}catch(x){}};   /* 19.10. 17:20: auch Stile ohne Anlass-Bild aus */
function apRenderHeroKar(){
  var t=document.getElementById('apHeroKarTrack');
  if(!t||typeof AP_STILE==='undefined')return;
  /* Kategorie je Stil aus den data-cg-Koepfen lesen, dann nach ?thema= filtern */
  var kat={};
  try{
    document.querySelectorAll('#ap .ap-stil-cat-head').forEach(function(h){
      var cg=h.getAttribute('data-cg');var g=h.nextElementSibling;
      if(g)g.querySelectorAll('[data-stil]').forEach(function(b){kat[b.getAttribute('data-stil')]=cg;});
    });
  }catch(e){}
  var target='';var useV=false;var useH=false;
  try{
    var qs=new URLSearchParams(window.location.search);
    var p=(qs.get('thema')||qs.get('kategorie')||'').toLowerCase().trim();
    var AL={'fahrzeuge':'kunst','fahrzeug':'kunst','auto':'kunst','autos':'kunst','royal':'royal','koeniglich':'royal','koenig':'royal','adel':'royal','kunst':'kunst','kuenstlerisch':'kunst','malerei':'kunst','gemaelde':'kunst','aquarell':'kunst','oel':'kunst','andenken':'andenken','gedenken':'andenken','memorial':'andenken'};
    if(p)target=AL.hasOwnProperty(p)?AL[p]:p;
    useV=(p==='fahrzeuge'||p==='fahrzeug'||p==='auto'||p==='autos');
    useH=(p==='haeuser'||p==='haus'||p==='hauser'||p==='homes');
  }catch(e){}
  var liste=useH ? AP_STILE.filter(function(s){ return AP_HAUS_STILE.indexOf(s.id)>=0; })
      : AP_STILE.filter(function(s){ return !target||!Object.keys(kat).length||kat[s.id]===target; });
  if(useV&&typeof AP_FAHRZEUG_STILE!=='undefined')liste=AP_STILE.filter(function(s){ return AP_FAHRZEUG_STILE.indexOf(s.id)>=0; });   /* 19.10.: wie Schritt 2 */
  var ORD={'kunst':0,'andenken':1,'royal':2};
  if(Object.keys(kat).length)liste=liste.slice().sort(function(a,b){var x=ORD[kat[a.id]],y=ORD[kat[b.id]];return (x===undefined?3:x)-(y===undefined?3:y);});
  if(!liste.length)liste=AP_STILE;
  var _am=apKarAnlassMap();
  if(_am){ liste=AP_STILE.filter(function(s){return !!_am[s.id];}); var _r=(window.apAnlassName&&AP_ANLASS_REIHE[window.apAnlassName])||null; if(_r){liste=liste.slice().sort(function(a,b){var x=_r.indexOf(a.id),y=_r.indexOf(b.id);return (x<0?99:x)-(y<0?99:y);});} apKarAnlassKarten(_am); }
  var lbl=document.querySelector('#ap .ap-hero-kar-label');
  var _anzStile=liste.length;
  if(lbl)lbl.textContent=T.soWirdA+_anzStile+T.soWirdB;
  /* Zusatzvarianten einmischen, damit sich kurze Listen nicht wiederholen */
  try{
    if(typeof AP_KAR_EXTRA!=='undefined'&&!_am){
      /* Reihum mischen: erst je ein Bild pro Stil, dann die naechste Runde */
      var spalten=liste.map(function(s){
        var arr=[s];
        (AP_KAR_EXTRA[s.id]||[]).forEach(function(u){
          arr.push({id:s.id,name:s.name,cimg:u,img:u});
        });
        return arr;
      });
      var tief=0; spalten.forEach(function(a){ if(a.length>tief)tief=a.length; });
      var erw=[];
      for(var r=0;r<tief;r++){
        spalten.forEach(function(a){ if(a[r])erw.push(a[r]); });
      }
      if(erw.length>liste.length) liste=erw;
    }
  }catch(e){}
  var html=liste.map(function(s){
    var motiv=(_am&&_am[s.id])?_am[s.id]:(useH&&AP_HAUS_IMG[s.id])?AP_HAUS_IMG[s.id]
      :((useV)?(s.vimg?s.vimg.replace('width=360','width=480'):('https://cdn.shopify.com/s/files/1/0949/3073/1274/files/fahrzeug2-'+s.id+'.png?width=360')):(s.cimg||s.img));
    return '<div class="ap-hero-kar-card"><img src="'+motiv+'" alt="'+apStilName(s)+'" loading="lazy"><div class="kn">'+apStilName(s)+'</div></div>';
  }).join('');
  var wdh=Math.max(2,Math.ceil(16/Math.max(1,liste.length)));var out='';for(var ri=0;ri<wdh;ri++)out+=html;
  t.innerHTML=out;
}
try{ window._apHandoffPending = !!localStorage.getItem('arturell_handoff_v1'); }catch(e){}
apLoadWerke();

/* APP-WECHSEL-FIX 25.10.: lief beim Neuladen noch eine Generierung? -> Ergebnis abholen */
setTimeout(function(){
  try{
    var j=window.apJobGemerkt&&window.apJobGemerkt(); if(!j||j.art!=='gen'||j.seite!=='p'||st.busy) return;
    st.busy=true; window.__apOhneStart=true; apLadeStart(); window.__apOhneStart=false;
    if(window.apLadeHinweis2) window.apLadeHinweis2();
    window.apJobWarten(j.job, function(d){
      st.busy=false; apLadeStop();
      try{ document.getElementById('apSpin').style.display='none'; var b=document.getElementById('apGenBtn'); if(b) b.disabled=false; apSyncGenBtn(); }catch(e){}
      if(d&&d.ok&&d.preview){
        st.stil=j.stil||st.stil; st.stilName=j.stilName||st.stilName; if(j.format) st.format=j.format;
        if(window.apQuotaUse) window.apQuotaUse();
        zeigResult(d.preview);
      } else if(d){ if(window.apZaehl) window.apZaehl('fehler', (typeof d!=='undefined')?d:null); }
    }, {ersteMs:400, maxUnbekannt:3, rueckkehr:true});
  }catch(e){ console.warn('[Job-Wiederaufnahme]', e); }
}, 900);
/* ── HANDOFF von der Startseite: Foto direkt in den echten Upload-Flow speisen ── */
setTimeout(function(){
  try{
    var HKEY='arturell_handoff_v1';
    var raw=localStorage.getItem(HKEY);
    if(!raw)return;
    localStorage.removeItem(HKEY);
    var d=JSON.parse(raw);
    if(!d||!d.foto||(Date.now()-(d.ts||0)>10*60*1000))return; /* nur frisch (10 Min) */
    var fi=document.getElementById('apFileInput');
    if(!fi||typeof apDataUrlToFile!=='function')return;
    /* Crop-Hintergrund soll Schritt 2 sein: Upload-Kopf SOFORT ausblenden + Schritt 2 zeigen (vor dem Crop). */
    var hero=document.querySelector('#ap .ap-hero');
    var ss=document.getElementById('apStileSection');
    if(hero)hero.style.display='none';
    if(ss){ ss.style.display='block'; if(window.apFilterStep2ByThema)apFilterStep2ByThema(); }
    /* Crop-Abbruch (✕): zurueck zum Upload-Kopf, damit keine Sackgasse entsteht. */
    var btnX=document.getElementById('apCropClose');
    var restore=function(){ if(hero)hero.style.display=''; if(ss)ss.style.display='none'; };
    if(btnX)btnX.addEventListener('click',restore,{once:true});
    var btnOk=document.getElementById('apCropConfirm');
    if(btnOk)btnOk.addEventListener('click',function(){ if(btnX)btnX.removeEventListener('click',restore); setTimeout(function(){ try{ ss.scrollIntoView({behavior:'auto',block:'start'}); }catch(e){} },80); },{once:true});
    var file=apDataUrlToFile(d.foto,'foto.jpg'); if(!file)return;
    var dt=new DataTransfer(); dt.items.add(file); fi.files=dt.files;
    fi.dispatchEvent(new Event('change',{bubbles:true}));
  }catch(e){}
},80);
apRenderHeroKar();
apFilterStep2ByThema();

/* ═══ V180: SCHRITT-AKKORDEON ═══ */
window.apAccOpen=function(n,force){
  var cur=document.getElementById('apAccStep'+n);
  var wasOpen=cur&&cur.classList.contains('open');
  for(var i=1;i<=7;i++){var s=document.getElementById('apAccStep'+i);if(s)s.classList.remove('open');}
  if(cur&&(force||!wasOpen)){
    cur.classList.add('open');cur.classList.remove('is-future');
    if(n===1){var w=document.getElementById('apWerkeWrap');if(w)w.style.display='block';}
    /* Text-Schritt: Felder direkt zeigen (kein "Hinzufuegen"-Button mehr) */
    if(n===5){ st.persOpen=true; var _pf=document.getElementById('apPersFields'); if(_pf)_pf.classList.add('open'); if(typeof apEnsureVorschau==='function')apEnsureVorschau(); }
  }
};
function apAccDone(n,txt,next){
  var s=document.getElementById('apAccStep'+n);if(!s)return;
  var redo=s.classList.contains('done');
  s.classList.add('done');s.classList.remove('is-future');
  var e=document.getElementById('apAccSum'+n);if(e)e.textContent=txt||'';
  /* Umentscheiden: nur zuklappen, nichts aufreißen */
  if(redo){s.classList.remove('open');return;}
  if(next){
    var nx=document.getElementById('apAccStep'+next);
    if(nx&&nx.classList.contains('done')){s.classList.remove('open');return;}
    window.apAccOpen(next,true);}
  else{s.classList.remove('open');}
}
function apAccStep1Done(open2){
  if(st&&st.stilName)apAccDone(1,st.stilName,open2?2:null);
}
function apAccSyncFarbeStep(){
  var f=document.getElementById('apFarbe');
  var show=(f&&f.style.display!=='none');
  var s6=document.getElementById('apAccStep6');
  if(s6)s6.style.display=show?'':'none';
  function num(id,t){var s=document.getElementById(id);if(s){var n=s.querySelector('.ap-acc-num');if(n)n.textContent=t;}}
  /* Format-Schritt ausgeblendet -> Nummern ohne Format durchzaehlen */
  var s7x=document.getElementById('apAccStep7'); if(s7x)s7x.style.display='none';
  num('apAccStep6','3');
  num('apAccStep3',show?'4':'3');
  num('apAccStep5',show?'5':'4');
}
/* ── FORTSCHRITT: zaehlt die tatsaechlich sichtbaren Schritte (4 oder 5) ── */
function apUpdateProgress(){
  var acc=document.getElementById('apAcc'); if(!acc)return;
  var steps=[].slice.call(acc.querySelectorAll('.ap-acc-step')).filter(function(s){return s.style.display!=='none' && !s.querySelector('.ap-acc-opt');});
  var N=steps.length; if(!N)return;
  var done=0; for(var i=0;i<steps.length;i++){if(steps[i].classList.contains('done'))done++;}
  var X=Math.min(done+1,N);
  var lbl=document.getElementById('apAccProgLbl'); var t=(AP_L==='en'?'Step '+X+' of '+N:'Schritt '+X+' von '+N);
  if(lbl&&lbl.textContent!==t)lbl.textContent=t;
  var bar=document.getElementById('apAccProgBar'); var w=Math.round(X/N*100)+'%';
  if(bar&&bar.style.width!==w)bar.style.width=w;
  apCelebrateCheck();
}
/* ── ERFOLGS-MOMENT: Banner + Konfetti + Button-Puls, wenn alle Pflichtschritte erledigt (Text optional zaehlt nicht) ── */
var _apDoneCelebrated=false;
function apCelebrateCheck(){
  var acc=document.getElementById('apAcc'); if(!acc)return;
  var steps=[].slice.call(acc.querySelectorAll('.ap-acc-step')).filter(function(s){return s.style.display!=='none';});
  var req=steps.filter(function(s){return !s.querySelector('.ap-acc-opt');});
  if(!req.length)return;
  var allDone=req.every(function(s){return s.classList.contains('done');});
  var banner=document.getElementById('apDoneBanner');
  if(allDone){
    if(banner)banner.classList.add('on');
    if(!_apDoneCelebrated){ _apDoneCelebrated=true;
      var b=document.querySelector('#ap .ap-buy-btn');
      if(b){ b.classList.remove('ap-buy-pulse'); void b.offsetWidth; b.classList.add('ap-buy-pulse'); }
      apConfetti();
    }
  } else { if(banner)banner.classList.remove('on'); }
}
function apConfetti(){
  try{
    var cols=['#D4847A','#7A9B85','#C49A5E','#36C25E','#E8B7B0'];
    var wrap=document.createElement('div'); wrap.className='ap-confetti';
    for(var i=0;i<42;i++){
      var p=document.createElement('i');
      p.style.left=(Math.random()*100)+'%';
      p.style.background=cols[i%cols.length];
      p.style.animationDuration=(1.1+Math.random()*1.1)+'s';
      p.style.animationDelay=(Math.random()*0.25)+'s';
      p.style.transform='rotate('+(Math.random()*360)+'deg)';
      wrap.appendChild(p);
    }
    document.body.appendChild(wrap);
    setTimeout(function(){ if(wrap.parentNode)wrap.parentNode.removeChild(wrap); },2800);
  }catch(e){}
}
(function(){
  var acc=document.getElementById('apAcc'); if(!acc)return;
  var raf=null;
  var obs=new MutationObserver(function(){ if(raf)return; raf=requestAnimationFrame(function(){raf=null;apUpdateProgress();}); });
  obs.observe(acc,{subtree:true,attributes:true,attributeFilter:['class','style']});
  apUpdateProgress();
})();
function apMatName(){var b=document.querySelector('#ap .ap-mat-btn.on .ap-mat-name');return b?b.textContent:'';}
function apFarbName(){var b=document.querySelector('#ap .ap-farbe-btn.on');return b?b.textContent.trim():'';}
window.apV180NeuesFoto=function(){
  /* FLOW v12: Neues Foto -> Stil-Liste oeffnen (kein Datei-Dialog). User waehlt Stil -> apNeuesFotoStil oeffnet Foto -> Cropper -> generiert. */
  st.pendingStil = null;
  if(typeof apOpenStile==='function') apOpenStile();
};
/* apOpenStile: Ziel repariert — Toggle-Button existiert nicht mehr */
window.apOpenStile=function(){
  window.apAccOpen(1,true);
  var a=document.getElementById('apAcc');
  if(a&&a.scrollIntoView)a.scrollIntoView({behavior:'smooth',block:'start'});
};
(function(){
  var _sw=window.apSelectWerk;window.apSelectWerk=function(u,sid,fmt){_sw(u,sid,fmt);apAccStep1Done(true);};
  var _st=window.apStil;window.apStil=function(b){_st(b);apAccStep1Done(false);};
  var _sc=window.apStilSliderClick;window.apStilSliderClick=function(sid){_sc(sid);apAccStep1Done(false);};
  var _nf=window.apNeuesFotoStil;window.apNeuesFotoStil=function(sid){_nf(sid);apAccStep1Done(false);};
  var _m3=window.apMaterial;window.apMaterial=function(b){_m3(b);
    /* Preis-Bar syncen: aktiver Größen-Button hat frische dataset.price vom Materialwechsel */
    var ab=document.querySelector('#ap .ap-size-btn.on');
    if(ab){st.price=parseFloat(ab.dataset.price);aktualisierePreis();
      var cm=ab.querySelector('.sz-cm');var e3=document.getElementById('apAccSum3');
      if(e3&&e3.textContent&&cm)e3.textContent=cm.textContent;}
    apAccSyncFarbeStep();
    var s2=document.getElementById('apAccStep2');var e2=document.getElementById('apAccSum2');
    var farbeAn=(function(){var fl=document.getElementById('apFarbe');return fl&&fl.style.display!=='none';})();
    if(s2){s2.classList.add('done');s2.classList.remove('is-future');s2.classList.remove('open');}
    if(e2)e2.textContent=apMatName();
    var s7=document.getElementById('apAccStep7');
    /* Format wird vom Foto bestimmt -> Schritt ueberspringen: als done markieren, Anzeige aus */
    if(s7){ s7.classList.add('done'); s7.classList.remove('is-future','open'); s7.style.display='none'; }
    if(false){window.apAccOpen(7,true);}
    else if(farbeAn){
      var s6=document.getElementById('apAccStep6');var e6=document.getElementById('apAccSum6');
      if(e6&&apFarbName())e6.textContent=apFarbName();
      if(s6&&!s6.classList.contains('done'))window.apAccOpen(6,true);
      else{var s3a=document.getElementById('apAccStep3');
        if(s3a&&!s3a.classList.contains('done'))window.apAccOpen(3,true);}}
    else{var s3=document.getElementById('apAccStep3');
      if(s3&&!s3.classList.contains('done'))window.apAccOpen(3,true);}};
  var _sz2=window.apSize;window.apSize=function(b){_sz2(b);
    var cm=b&&b.querySelector('.sz-cm');apAccDone(3,cm?cm.textContent:'',null);};
  var _fb2=window.apFarbe;window.apFarbe=function(b){_fb2(b);
    apAccDone(6,apFarbName(),3);};
  var _fm2=window.apFmt;window.apFmt=function(b){_fm2(b);
    var ab=document.querySelector('#ap .ap-size-btn.on');var e3=document.getElementById('apAccSum3');
    if(ab&&e3&&e3.textContent){var cm=ab.querySelector('.sz-cm');if(cm)e3.textContent=cm.textContent;}
    /* Format = Schritt 3: nur weiterspringen, wenn der Schritt gerade offen ist (nicht bei Auto-Erkennung) */
    var s7=document.getElementById('apAccStep7');
    if(s7&&s7.classList.contains('open')){
      var fmtName=(b&&b.dataset&&b.dataset.fmt==='quer')?((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Landscape':'Querformat'):((window.Shopify&&Shopify.locale||'de').slice(0,2)==='en'?'Portrait':'Hochformat');
      var farbeAn=(function(){var fl=document.getElementById('apFarbe');return fl&&fl.style.display!=='none';})();
      apAccDone(7,fmtName,farbeAn?6:3);
    }};
  var _ut2=window.apUpdateText;window.apUpdateText=function(){_ut2();
    var l1=document.getElementById('apPersLine1'),l2=document.getElementById('apPersLine2');
    var t1=(l1&&l1.value)||'',t2=(l2&&l2.value)||'';
    var t=t1+((t1&&t2)?' · ':'')+t2;
    var s5=document.getElementById('apAccStep5');var e=document.getElementById('apAccSum5');
    if(t){if(s5){s5.classList.add('done');s5.classList.remove('is-future');}
      if(e)e.textContent='\u201E'+(t.length>22?t.slice(0,22)+'\u2026':t)+'\u201C';}
    else{if(s5)s5.classList.remove('done');if(e)e.textContent='';}};
  /* Init */
  apAccSyncFarbeStep();
  if(st&&st.artUrl&&st.stilName){apAccDone(1,st.stilName,null);}
  else{window.apAccOpen(1,true);}
})();

})();
  // Preise initialisieren
  if (typeof apUpdatePrices === 'function') apUpdatePrices();

/* ══════════ CROP-TOOL: Kunde positioniert Foto im Ziel-Format ══════════ */
(function(){
  var modal=document.getElementById('apCropModal');
  var stage=document.getElementById('apCropStage');
  var cv=document.getElementById('apCropCanvas');
  var zoom=document.getElementById('apCropZoom');
  var btnOk=document.getElementById('apCropConfirm');
  var btnX=document.getElementById('apCropClose');
  if(!modal||!cv) return;
  /* Modal an body verschieben -> immer sichtbar, auch wenn Hero-Section display:none ist */
  try { if(modal.parentElement !== document.body) document.body.appendChild(modal); } catch(e){}
  var ctx=cv.getContext('2d');
  var img=new Image();
  var S={imgW:0,imgH:0,cw:0,ch:0,scale:1,minScale:1,ox:0,oy:0,drag:false,lx:0,ly:0,cb:null,ratio:1};

  function fitCanvas(ratio){
    var maxW=stage.clientWidth||480;
    var cw=maxW, ch=Math.round(maxW/ratio);
    var maxH=Math.round((window.innerHeight||700)*0.52);
    if(ch>maxH){ ch=maxH; cw=Math.round(maxH*ratio); }
    var dpr=Math.min(window.devicePixelRatio||1,2);
    cv.width=Math.round(cw*dpr); cv.height=Math.round(ch*dpr);
    cv.style.width=cw+'px'; cv.style.height=ch+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    S.cw=cw; S.ch=ch; S.ratio=ratio;
  }
  function computeMin(){ S.minScale=Math.max(S.cw/S.imgW, S.ch/S.imgH); }
  function clamp(){
    var w=S.imgW*S.scale, h=S.imgH*S.scale;
    if(S.ox>0)S.ox=0; if(S.oy>0)S.oy=0;
    if(S.ox<S.cw-w)S.ox=S.cw-w; if(S.oy<S.ch-h)S.oy=S.ch-h;
  }
  function draw(){ ctx.clearRect(0,0,S.cw,S.ch); ctx.drawImage(img,S.ox,S.oy,S.imgW*S.scale,S.imgH*S.scale); }
  function open(dataUrl,format,cb){
    S.cb=cb;
    var ratio=(format==='quer')?(3/2):(2/3);
    img.onload=function(){
      S.imgW=img.naturalWidth; S.imgH=img.naturalHeight;
      fitCanvas(ratio); computeMin();
      S.scale=S.minScale;
      S.ox=(S.cw-S.imgW*S.scale)/2; S.oy=(S.ch-S.imgH*S.scale)/2;
      clamp(); draw();
      zoom.value=100;
      modal.style.display='flex';
    };
    img.src=dataUrl;
  }
  window.apOpenCrop=open;

  zoom.addEventListener('input',function(){
    var f=parseInt(zoom.value,10)/100;
    var cx=S.cw/2, cy=S.ch/2;
    var wx=(cx-S.ox)/S.scale, wy=(cy-S.oy)/S.scale;
    S.scale=S.minScale*f;
    S.ox=cx-wx*S.scale; S.oy=cy-wy*S.scale;
    clamp(); draw();
  });

  function pt(e){ var r=cv.getBoundingClientRect(); var t=e.touches?e.touches[0]:e; return {x:(t.clientX-r.left)*(S.cw/r.width), y:(t.clientY-r.top)*(S.ch/r.height)}; }
  function down(e){ S.drag=true; var q=pt(e); S.lx=q.x; S.ly=q.y; e.preventDefault(); }
  function move(e){ if(!S.drag)return; var q=pt(e); S.ox+=q.x-S.lx; S.oy+=q.y-S.ly; S.lx=q.x; S.ly=q.y; clamp(); draw(); e.preventDefault(); }
  function up(){ S.drag=false; }
  cv.addEventListener('mousedown',down); window.addEventListener('mousemove',move); window.addEventListener('mouseup',up);
  cv.addEventListener('touchstart',down,{passive:false}); cv.addEventListener('touchmove',move,{passive:false}); cv.addEventListener('touchend',up);

  function finish(dataUrl){ modal.style.display='none'; if(S.cb){ var f=S.cb; S.cb=null; f(dataUrl); } }
  btnOk.addEventListener('click',function(){
    var outW,outH;
    /* 15.10.: native Aufloesung des Ausschnitts behalten (max. 3000 px), statt fix 1400 px */
    var natW=S.cw/S.scale, natH=S.ch/S.scale, natK=Math.min(1, 3000/Math.max(natW,natH));
    outW=Math.round(natW*natK); outH=Math.round(natH*natK);
    var oc=document.createElement('canvas'); oc.width=outW; oc.height=outH;
    var octx=oc.getContext('2d');
    var sc=outW/S.cw;
    octx.drawImage(img, S.ox*sc, S.oy*sc, S.imgW*S.scale*sc, S.imgH*S.scale*sc);
    finish(oc.toDataURL('image/jpeg',0.9));
  });
  btnX.addEventListener('click',function(){
    modal.style.display='none';
    S.cb=null;
    try { var _fi=document.getElementById('apFileInput'); if(_fi) _fi.value=''; } catch(e){}
  });
})();

/* ---- Newsletter-Overlay (war zweiter Script-Block) ---- */
window.apNlOpen=function(view){
  var ov=document.getElementById('apNlOverlay'); if(!ov) return;
  var r=document.getElementById('apNlReturn');
  if(r){ try{ r.value=location.pathname+'?nl=1'; }catch(e){} }
  var f=document.getElementById('apNlViewForm'), e=document.getElementById('apNlViewEnd');
  if(f) f.style.display=(view==='form')?'block':'none';
  if(e) e.style.display=(view==='end')?'block':'none';
  ov.classList.add('open');
};
window.apNlClose=function(){
  var ov=document.getElementById('apNlOverlay'); if(ov) ov.classList.remove('open');
};
(function(){
  function apNlToast(msg){
    var t=document.createElement('div');
    t.textContent=msg;
    t.style.cssText='position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);background:#1A1714;color:#fff;padding:20px 30px;border-radius:16px;font-size:15px;font-weight:600;z-index:99999;box-shadow:0 16px 56px rgba(0,0,0,.4);max-width:86vw;text-align:center';
    document.body.appendChild(t);
    setTimeout(function(){ try{t.remove();}catch(e){} }, 3800);
  }
  /* ── MAILGATE (12.08.): Code-Bestaetigung VOR dem Shopify-Submit ──
     E-Mail eintippen -> Worker schickt 6-stelligen Code (Resend) -> Code hier im
     Overlay eingeben -> Worker gibt signierten Grant -> localStorage -> DANN erst
     das normale Shopify-Newsletter-Formular abschicken (Redirect mit nl=1).
     Ist der Worker nicht erreichbar, faellt alles auf das ALTE Verhalten zurueck
     (direkt zu Shopify) — das Overlay blockiert nie. */
  var AP_MG_URL='https://arturell-preview.arturell.workers.dev/mailgate';
  /* Anfangszustand des Mailgate-Knopfs (14.08.): der Liquid-t-Key greift nicht
     zuverlaessig, weil Shopify Locale-Schluessel erst indexieren muss. Hier
     direkt setzen — unabhaengig vom Locale-System. */
  try{ document.querySelectorAll('.apnl-cta').forEach(function(b){
    if(b.type==='submit') b.textContent = _mgEN ? 'Subscribe & unlock' : 'Newsletter abonnieren & freischalten';
  }); }catch(e){}
  var _mgEN=(window.Shopify&&Shopify.locale||'de').slice(0,2)==='en';
  /* AP-MAILCODE-EN 29.10.2026 */ var _mgENT={abgelaufen:'The code has expired or there were too many attempts. Please request a new code.',bot:'Security check failed. Please reload the page.',config:'Confirmation is not available right now. Please try again later.',cooldown:'The code was just sent. Please check your inbox (and spam folder).',eingabe:'Please enter your email address and the 6-digit code.',email:'Please enter a valid email address.',limit:'It is very busy right now. Please try again a little later.',server:'Something went wrong. Please try again.',versand:'The code could not be sent. Please try again in a moment.'};function _mgMsg(d){if(!d)return '';return _mgEN?(_mgENT[d.error]||''):(d.message||'');}
  function apMgFallback(form){ try{ form.dataset.mgDone='1'; }catch(e){} try{ form.submit(); }catch(e){} }
  function apMgStart(form){
    var inp=form.querySelector('input[name="contact[email]"]');
    var mail=inp?String(inp.value||'').trim():'';
    if(!mail){ return; }
    var btn=form.querySelector('button[type="submit"]');
    if(btn){ btn.disabled=true; btn.textContent=_mgEN?'Sending code…':'Code wird gesendet…'; }
    (window.apTsToken?window.apTsToken():Promise.resolve('')).then(function(tk){
      return fetch(AP_MG_URL+'/start',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:mail,tsToken:tk,lang:(_mgEN?'en':'de')})});
    }).then(function(r){ return r.json(); }).then(function(d){
      if(d&&(d.ok||d.error==='cooldown')){ apMgZeigeCode(form,mail); } /* cooldown = Code ist schon unterwegs */
      else if(d&&(d.error==='email'||d.error==='limit'||d.error==='bot'||d.error==='versand')){
        /* echte Server-Antwort mit Grund -> anzeigen und NICHT zu Shopify durchreichen
           (sonst abonniert der Kunde, bekommt aber keinen Bonus -> Gate-Schleife) */
        /* _mgEN statt AP_L: der Minifier des Live-Builds hat AP_L zu AP_L2
           umbenannt und genau diese zwei Referenzen uebersehen — live warf das
           einen ReferenceError, der JEDEN Mailgate-Fehler (limit/email/bot/
           versand) in den blinden Shopify-Submit ohne Grant kippte (Fund
           21.08., auf der Live-Seite reproduziert). */
        if(btn){ btn.disabled=false; btn.textContent=_mgEN?'Subscribe & unlock':'Newsletter abonnieren & freischalten'; }
        apNlToast(_mgMsg(d)||(_mgEN?'That did not work. Please try again.':'Das hat nicht geklappt. Bitte versuche es erneut.'));
      }
      else { apMgFallback(form); } /* config/unbekannt = Worker noch nicht bereit -> altes Verhalten */
    }).catch(function(){ apMgFallback(form); });
  }
  function apMgZeigeCode(form,mail){
    var box=document.getElementById('apNlViewForm'); if(!box){ apMgFallback(form); return; }
    /* Immer NEU bauen: die alte Box haelt Adresse+Handler der ERSTEN Mail im
       Closure — nach einem Adresswechsel wuerde sonst gegen die alte verifiziert. */
    var alt=document.getElementById('apMgCodeBox');
    if(alt){ try{ alt.remove(); }catch(e){ alt.parentNode.removeChild(alt); } }
    form.style.display='none';
    var w=document.createElement('div'); w.id='apMgCodeBox';
    w.innerHTML='<p style="margin:0 0 12px;font-size:14px;color:#4A453E">'+(_mgEN?'We sent a 6-digit code to ':'Wir haben einen 6-stelligen Code an ')+'<b>'+mail.replace(/</g,'&lt;').replace(/>/g,'&gt;')+'</b>'+(_mgEN?'.':' geschickt.')+'</p>'
      +'<input id="apMgCode" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000" class="apnl-input" style="text-align:center;letter-spacing:8px;font-size:22px">'
      +'<button type="button" id="apMgOk" class="apnl-cta">'+(_mgEN?'Confirm':'Bestätigen')+'</button>'
      +'<p id="apMgErr" style="display:none;margin:10px 0 0;font-size:13px;color:#B4231F"></p>'
      +'<p style="margin:12px 0 0;font-size:12px;color:#8A857E">'+(_mgEN?'No email? Check spam or ':'Keine E-Mail? Schau im Spam nach oder ')+'<a href="#" id="apMgNeu" style="color:#8A857E;text-decoration:underline">'+(_mgEN?'request a new code':'fordere einen neuen Code an')+'</a></p>';
    box.appendChild(w);
    var ci=w.querySelector('#apMgCode'); if(ci){ ci.focus(); ci.addEventListener('keydown',function(ev){ if(ev.key==='Enter'){ ev.preventDefault(); apMgVerify(form,mail,w); } }); }
    w.querySelector('#apMgOk').addEventListener('click',function(){ apMgVerify(form,mail,w); });
    w.querySelector('#apMgNeu').addEventListener('click',function(ev){
      ev.preventDefault(); w.style.display='none'; form.style.display='block';
      var b=form.querySelector('button[type="submit"]'); if(b){ b.disabled=false; b.textContent=_mgEN?'Subscribe & unlock':'Newsletter abonnieren & freischalten'; }
    });
  }
  function apMgVerify(form,mail,w){
    /* Reentrancy-Guard: Enter+Klick oder Doppel-Enter feuern sonst parallel und
       verbrennen Verify-Versuche (Server erlaubt nur 15/Tag je Adresse). */
    var ok=w.querySelector('#apMgOk'); if(ok&&ok.disabled)return;
    var code=String((w.querySelector('#apMgCode')||{}).value||'').trim();
    var err=w.querySelector('#apMgErr');
    if(!/^[0-9]{6}$/.test(code)){ if(err){ err.textContent=_mgEN?'Please enter the 6-digit code.':'Bitte gib den 6-stelligen Code ein.'; err.style.display='block'; } return; }
    if(ok)ok.disabled=true;
    fetch(AP_MG_URL+'/verify',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:mail,code:code})})
      .then(function(r){ return r.json(); }).then(function(d){
        if(d&&d.ok&&d.grant){
          try{ localStorage.setItem('apMailGrant',d.grant); localStorage.setItem('apfEmailBonus','1'); }catch(e){}
          try{ if(typeof apUpdateGenCounter==='function')apUpdateGenCounter(); }catch(e){}
          apMgFallback(form); /* jetzt regulaer zu Shopify (Newsletter-Einwilligung) + Redirect zurueck */
        } else {
          if(ok)ok.disabled=false;
          if(err){ err.textContent=_mgMsg(d)?_mgMsg(d):(_mgEN?'That did not work. Please try again.':'Das hat nicht geklappt. Bitte versuche es erneut.'); err.style.display='block'; }
        }
      }).catch(function(){ if(ok)ok.disabled=false; if(err){ err.textContent=_mgEN?'Connection error. Please try again.':'Verbindungsfehler. Bitte versuche es erneut.'; err.style.display='block'; } });
  }
  function apNlInit(){
    var form=document.getElementById('apNlForm');
    if(form){ form.addEventListener('submit', function(ev){
      /* MAILGATE: erst Code bestaetigen, dann regulaer zu Shopify. form.submit()
         (der Fallback) loest dieses submit-Event NICHT erneut aus — keine Schleife. */
      try{
        if(form.dataset.mgDone==='1'){ return; }
        ev.preventDefault();
        apMgStart(form);
      }catch(e){ try{ form.dataset.mgDone='1'; form.submit(); }catch(_e){} }
    }); }
    var ov=document.getElementById('apNlOverlay');
    if(ov){ ov.addEventListener('click', function(ev){ if(ev.target===ov) apNlClose(); }); }
    try{
      var q=location.search;
      if(q.indexOf('nl=1')!==-1 || q.indexOf('customer_posted=true')!==-1){
        /* Freischaltung nur behaupten, wenn wirklich ein Grant da ist — im
           Fallback-Pfad (Worker down) kam der Kunde ohne Grant hierher. */
        apNlToast(window.apHatBonus&&window.apHatBonus()
          ? (_mgEN?'Done! Your 5 additional artworks are unlocked.':'Geschafft! Deine 5 weiteren Kunstwerke sind freigeschaltet.')
          : (_mgEN?'Thanks for subscribing!':'Danke für deine Anmeldung!'));
        history.replaceState(null,'',location.pathname);
      }
    }catch(e){}
  }
  if(document.readyState!=='loading') apNlInit();
  else document.addEventListener('DOMContentLoaded', apNlInit);
})();
/* build-1785177570 */
/* build-1785178013 */
/* build-1785178331 */

/* == AP-KAUFKASTEN-3110 (31.10.2026): Kaufkasten direkt unter der Vorschau ==
   Baut keinen neuen Kaufweg. Spiegelt Material, Groesse, Rahmenfarbe und Preis aus den
   vorhandenen Knoepfen (#ap .ap-mat-btn, .ap-size-btn, .ap-farbe-btn, #apPriceNow; Preise
   kommen dort aus AP_PREISE / FAM_PREISE) und loest beim Klick dieselben Wege aus:
   window.apMaterial, window.apSize, window.apFarbe, window.apBuy (wie "Jetzt bestellen":
   in den Warenkorb, dann /cart). Aktion (AP-AKTION-33-3010, AP-TIEFST-3010) und Lieferdatum
   (AP-LIEFERDATUM-3010) werden nur gespiegelt; die Datums-Freischaltung bleibt im Original.
   Steht bewusst NACH allen Wrappern und ausserhalb der Haupt-Closure: nutzt nur window.* */
(function(){
  if (window.__apKk) return; window.__apKk = true;
  function init(){
    var kk = document.getElementById('apKk'); if (!kk) return;
    var apEl = document.getElementById('ap');
    function q(s, r){ return (r || document).querySelector(s); }
    function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }
    function an(el){ return !!el && el.style.display !== 'none'; }
    function zaehl(e){ try { if (window.apZaehl) window.apZaehl(e); } catch(_){} }
    var t = 0, sig = '';
    function bald(){ if (t) return; t = setTimeout(function(){ t = 0; try { sync(); } catch(e){ try { console.warn('[Kaufkasten]', e); } catch(_){} } }, 40); }
    var sel = q('#apKkSize', kk), dots = q('#apKkDots', kk);
    var LKW = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
    /* Rahmenfarben einmal aus den vorhandenen Knoepfen bauen (Name + Punktfarbe) */
    if (dots) qa('#apFarbe .ap-farbe-btn').forEach(function(o){
      var b = document.createElement('button'); b.type = 'button'; b.className = 'ap-kk-farbe';
      b.setAttribute('data-farbe', o.getAttribute('data-farbe') || '');
      var nm = (o.textContent || '').trim(); b.setAttribute('aria-label', nm); b.title = nm;
      var d = o.querySelector('.ap-farbe-dot'); if (d) b.style.background = d.style.background;
      dots.appendChild(b);
    });
    function sync(){
      var st = window.st || {};
      var ri = q('#apResultImg');
      var zeigen = !!st.artUrl || !!(ri && /^https?:/.test(ri.getAttribute('src') || ''));
      kk.classList.toggle('on', zeigen);
      if (apEl) apEl.classList.toggle('ap-kk-an', zeigen);
      /* Material */
      var mo = q('#ap .ap-mat-btn.on'), m = mo ? mo.getAttribute('data-mat') : 'canvas';
      qa('.ap-kk-mat', kk).forEach(function(b){ var on = b.getAttribute('data-mat') === m; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      /* Rahmenfarbe nur, wenn die vorhandene Farbwahl sichtbar ist (gerahmt) */
      var fz = q('#apKkFarben', kk); if (fz) fz.style.display = an(q('#apFarbe')) ? '' : 'none';
      var fon = q('#apFarbe .ap-farbe-btn.on'), fn = q('#apKkFname', kk);
      qa('.ap-kk-farbe', kk).forEach(function(b){ b.classList.toggle('on', !!fon && b.getAttribute('data-farbe') === fon.getAttribute('data-farbe')); });
      if (fn) fn.textContent = fon ? (fon.textContent || '').trim() : '';
      /* Groessen: nur sichtbare Knoepfe mit Preis (L gerahmt EU und XXL sind ausgeblendet) */
      var opts = [], cur = '';
      qa('#ap .ap-size-grid .ap-size-btn').forEach(function(b){
        if (!an(b)) return;
        var pr = q('.sz-price', b), lb = q('.sz-label', b), cm = q('.sz-cm', b);
        var p = pr ? pr.textContent.trim() : ''; if (!p) return;
        var sz = b.getAttribute('data-size') || '';
        opts.push([sz, [lb ? lb.textContent.trim() : sz.toUpperCase(), cm ? cm.textContent.trim() : '', p].filter(Boolean).join(' · ')]);
        if (b.classList.contains('on')) cur = sz;
      });
      var s2 = JSON.stringify(opts);
      if (sel && s2 !== sig){
        sig = s2; while (sel.firstChild) sel.removeChild(sel.firstChild);
        opts.forEach(function(o){ var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; sel.appendChild(op); });
      }
      if (sel && cur) sel.value = cur;
      /* Preis: derselbe Wert wie im Preisblock und auf "Jetzt bestellen" */
      var pn = q('#apPriceNow'), kp = q('#apKkPreis', kk);
      if (pn && kp) kp.textContent = (pn.textContent || '').trim();
      /* Aktion spiegeln, nur wenn das Original freigeschaltet ist */
      var ab = q('#apAktionBox'), ka = q('#apKkAktion', kk);
      if (ka){
        var akt = !!ab && ab.style.display === 'block';
        if (akt && !ka.firstChild){ var c = ab.cloneNode(true); c.removeAttribute('id'); c.style.display = 'block'; ka.appendChild(c); }
        ka.style.display = akt ? '' : 'none';
      }
      var tz = q('#apTiefst'), kt = q('#apKkTiefst', kk);
      if (kt){ var tan = !!tz && tz.style.display === 'block' && !!tz.innerHTML; kt.innerHTML = tan ? tz.innerHTML : ''; kt.style.display = tan ? 'block' : 'none'; }
      /* Lieferdatum spiegeln */
      var ld = q('#apLieferDatum'), kl = q('#apKkLiefer', kk);
      if (kl){
        var lan = !!ld && ld.style.display === 'block' && !!(ld.textContent || '').trim();
        kl.innerHTML = ''; if (lan){ kl.innerHTML = LKW; var sp = document.createElement('span'); sp.textContent = ld.textContent.trim(); kl.appendChild(sp); }
        kl.style.display = lan ? '' : 'none';
      }
    }
    kk.addEventListener('click', function(ev){
      var x = ev.target; if (!x || !x.closest) return;
      var mb = x.closest('.ap-kk-mat');
      if (mb){
        var o = q('#ap .ap-mat-btns .ap-mat-btn[data-mat="' + mb.getAttribute('data-mat') + '"]');
        if (o && !o.classList.contains('on') && typeof window.apMaterial === 'function'){ window.apMaterial(o); zaehl('material'); }
        bald(); return;
      }
      var fb = x.closest('.ap-kk-farbe');
      if (fb){
        var of = q('#apFarbe .ap-farbe-btn[data-farbe="' + fb.getAttribute('data-farbe') + '"]');
        if (of && typeof window.apFarbe === 'function') window.apFarbe(of);
        bald(); return;
      }
      if (x.closest('#apKkBuy')){ if (typeof window.apBuy === 'function') window.apBuy(); return; }
      if (x.closest('#apKkMehr')){
        if (typeof window.apAccOpen === 'function') window.apAccOpen(5, true);
        var s5 = q('#apAccStep5') || q('#apAcc'); if (s5 && s5.scrollIntoView) s5.scrollIntoView({behavior: 'smooth', block: 'start'});
        return;
      }
    });
    if (sel) sel.addEventListener('change', function(){
      var o = q('#ap .ap-size-grid .ap-size-btn[data-size="' + sel.value + '"]');
      if (o && typeof window.apSize === 'function'){ window.apSize(o); zaehl('groesse'); }
      bald();
    });
    if (window.MutationObserver){
      var mob = new MutationObserver(bald), A = {attributes: true, subtree: true, childList: true, characterData: true};
      [['#apPriceNow', A], ['#ap .ap-mat-btns', A], ['#ap .ap-size-grid', A], ['#apFarbe', A], ['#apTiefst', A],
       ['#apAktionBox', {attributes: true}], ['#apLieferDatum', A], ['#apResultImg', {attributes: true}], ['#apResultSection', {attributes: true}]
      ].forEach(function(z){ var el = q(z[0]); if (el) mob.observe(el, z[1]); });
    }
    var img = q('#apResultImg'); if (img) img.addEventListener('load', bald);
    window.apKkSync = function(){ try { sync(); } catch(e){} };
    sync();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  /* Zurueck aus dem Warenkorb (bfcache): Kauf-Sperre loesen, sonst bleibt jeder Kaufknopf stumm */
  window.addEventListener('pageshow', function(e){
    try { if (e && e.persisted && window.st) window.st.kaufLaeuft = false; } catch(_){}
    if (window.apKkSync) window.apKkSync();
  });
})();

/* ── ZAEHLSTELLEN 23.10.2026: anonyme Tageszaehler Kaufweg (kein Cookie, kein Speicher, keine Kennung) ── */
(function(){
  if (window.__apZaehler) return; window.__apZaehler = true;
  var SEITE = 'p';
  var ZIEL = 'https://arturell-preview.arturell.workers.dev/z';
  var markt = (function(){
    try {
      if (navigator.webdriver || (window.Shopify && Shopify.theme && String(Shopify.theme.id) === '192464027914')) return 'dev';
      if (location.hostname.indexOf('us.') === 0) return 'us';
      if (location.pathname === '/en' || location.pathname.indexOf('/en/') === 0) return 'en';
    } catch(e) {}
    return 'de';
  })();
  var schon = {};
  function apFehlerKat(d){ if(!d) return 'netz'; var e=String(d.error||''); if(e==='limit') return d.grund==='mailgate'?'mailgate':'limit'; if(e==='watermark') return 'server'; if(['bot','safety','quality','server','zeit'].indexOf(e)>=0) return e; return 'sonst'; }
  function z(e, d){
    if (e === 'fehler') { try { var _k = 'f_' + apFehlerKat(d); if (_k !== e) z(_k); } catch(_) {} }
    if (schon[e]) return; schon[e] = true;
    var u = ZIEL + '?e=' + e + '&s=' + SEITE + '&m=' + markt;
    try { if (navigator.sendBeacon && navigator.sendBeacon(u)) return; } catch(_) {}
    try { fetch(u, { method: 'POST', mode: 'no-cors', keepalive: true }); } catch(_) {}
  }
  window.apZaehl = z;
  window.apZaehlStand = function(){ return { seite: SEITE, markt: markt, gezaehlt: Object.keys(schon) }; };
  document.addEventListener('click', function(ev){
    var t = ev.target; if (!t || !t.closest) return;
    if (t.closest('.ap-size-btn')) z('groesse');
    else if (t.closest('.ap-mat-btn')) z('material');
    else if (t.closest('.ap-buy-btn')) z('kaufen');
    else if (t.closest('.ap-cart-btn')) z('warenkorb');
    else if (t.closest('.ap-dl-btn')) z('download');
    else if (t.closest('.ap-bundle-btn')) z('popup_kauf');
    else if (t.closest('.ap-bundle-close') || t.closest('.ap-bundle-skip')) z('popup_zu');
  }, true);
  function beobachte(){
    var img = document.getElementById('apResultImg');
    if (img) img.addEventListener('load', function(){ if (img.src && img.src.indexOf('http') === 0) z('vorschau'); });
    var pop = document.getElementById('apBundlePopup');
    if (pop && window.MutationObserver) new MutationObserver(function(){ if (pop.classList.contains('on')) z('popup'); }).observe(pop, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState !== 'loading') beobachte(); else document.addEventListener('DOMContentLoaded', beobachte);
})();

/* ── DEV-TESTKNOPF 24.10.2026: nur DEV-Theme 192464027914 (Rolle nicht main), nie LIVE. Galerie bleibt unveraendert. ── */
(function(){
  try {
    if (!(window.Shopify && Shopify.theme && String(Shopify.theme.id) === '192464027914' && Shopify.theme.role !== 'main')) return;
  } catch(e) { return; }
  var KEY = 'arturell_werke_v1';
  var BILD = 'https://cdn.shopify.com/s/files/1/0949/3073/1274/files/demo-aquarell.jpg';
  window.apDevTest = function(){
    var zr = (typeof zeigResult === 'function') ? zeigResult : window.zeigResult;
    var _st = (typeof st === 'object' && st) ? st : window.st;   /* 25.10.: Shopify kapselt die Datei, window.st fehlt */
    if (!_st || !zr) { console.log('[DEV-Test] st oder zeigResult fehlt'); return; }
    if (!window.st) window.st = _st;
    /* AP-DEVKNOPF-LEEREN-2910 */ try { localStorage.removeItem(KEY); } catch(e) {} if (st.artHistory) st.artHistory = [];
    var g = st.genCount;
    try {
      var cv = document.createElement('canvas'); cv.width = 800; cv.height = 1000;
      var cx = cv.getContext('2d'); cx.fillStyle = '#9AAE8C'; cx.fillRect(0, 0, 800, 1000);
      cx.fillStyle = '#3E4A38'; cx.font = 'bold 64px sans-serif'; cx.textAlign = 'center'; cx.fillText('TEST-FOTO', 400, 520);
      st.fotoDataUrl = cv.toDataURL('image/jpeg', 0.85); st.fotoSmall = st.fotoDataUrl; st.fotoRatio = 0.8;
      cv.toBlob(function(b){ if (b) st.foto = new File([b], 'test.jpg', {type: 'image/jpeg'}); }, 'image/jpeg', 0.85);
    } catch(e) { console.warn('[DEV-Test] Test-Foto fehlgeschlagen', e); }
    zr(BILD);
    st.genCount = g;
    try { if (typeof apRenderDeineWerke === 'function') apRenderDeineWerke(); } catch(e) {}
    console.log('[DEV-Test] Galerie ' + KEY + ' geleert, Bearbeitungsmodus offen');
  };
  function knopf(){
    if (document.getElementById('apDevTestBtn')) return;
    var b = document.createElement('button');
    b.id = 'apDevTestBtn'; b.type = 'button';
    b.textContent = '\uD83E\uDDEA Bearbeiten testen (DEV)';
    b.setAttribute('style', 'position:fixed;bottom:90px;right:16px;z-index:99999;background:#E8662A;color:#fff;border:none;border-radius:24px;padding:12px 18px;font:700 13px/1.2 sans-serif;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,.25)');
    b.onclick = function(){ window.apDevTest(); };
    document.body.appendChild(b);
  }
  if (document.readyState !== 'loading') knopf(); else document.addEventListener('DOMContentLoaded', knopf);
})();

/* ── AP-RAHMEN-VORSCHAU-3110 + AP-WANDZOOM-3110 (31.10.2026) ──
   1) Gerahmt: die Vorschau zeigt das Werk im Schattenfugenrahmen (schwarz / weiss / eiche), rein per CSS um den
      Canvas -> gestochen scharf, sofort da, kein Server. Proportion aus der gewaehlten Groesse:
      sichtbare Rahmenleiste RAHMEN_CM, Schattenfuge FUGE_CM (ANNAHME bis zum merchOne-Datenblatt).
   2) "An der Wand": Wand-Mockups (Werk nur 22-28 % der Bildbreite) werden um ZOOM aufs Werk herangezoomt.
      Mittelpunkte aus den Bundles ~/Arturell/bundles-neu (quad-Mitte). Unbekannter Schluessel -> kein Zoom.
   Steht am Dateiende, damit es nach allen Wrappern laeuft; haengt sich nicht in apMaterial/apFarbe ein,
   sondern beobachtet Klassen (MutationObserver) -> unabhaengig von der Wrapper-Kette. */
(function(){
  var RAHMEN_CM=0.8, FUGE_CM=0.5, PAD_X=36, PAD_Y=46;
  var CSS=
    '#ap.ap-rahmen-an #paneVorschau>div{overflow:hidden!important;border-radius:12px!important;padding:18px 18px 28px!important;background:radial-gradient(120% 90% at 50% 30%,#FCFAF7 0%,#F3EEE7 70%,#ECE5DB 100%)!important}'+
    '#ap.ap-rahmen-an #apWmCanvas{border-radius:0!important;box-sizing:content-box!important;padding:var(--apr-g)!important;border:var(--apr-f) solid transparent!important;border-image:var(--apr-bild) 1!important;background:var(--apr-fuge)!important;margin-left:auto!important;margin-right:auto!important;'+
      'box-shadow:inset 0 0 0 1px rgba(0,0,0,.20),inset 0 calc(var(--apr-g)*.5) var(--apr-g) rgba(0,0,0,.45),0 0 0 1px rgba(0,0,0,.08),0 24px 40px -20px rgba(45,32,22,.55),0 8px 16px -8px rgba(45,32,22,.25)!important}'+
    '@media(max-width:768px){#ap.ap-rahmen-an #apWmCanvas{width:calc(100% - 2*var(--apr-t))!important;max-width:none!important;height:auto!important}'+
      '#ap.ap-rahmen-an #paneVorschau>div>div:first-of-type{transform:translate(calc(var(--apr-t) + 8px),calc(var(--apr-t) + 8px))}'+
      '#ap.ap-rahmen-an .ap-wm-badge{transform:translate(calc(-1*var(--apr-t) - 8px),calc(-1*var(--apr-t) - 18px))}}'+
    '#ap.ap-rahmen-black{--apr-bild:linear-gradient(135deg,#46413C 0%,#24211E 38%,#161412 100%);--apr-fuge:linear-gradient(180deg,#0B0A09,#1C1916)}'+
    '#ap.ap-rahmen-white{--apr-bild:linear-gradient(135deg,#FFFFFF 0%,#F6F3EE 45%,#E4DED4 100%);--apr-fuge:linear-gradient(180deg,#B3AA9C,#D3CBBF)}'+
    '#ap.ap-rahmen-wood{--apr-bild:linear-gradient(135deg,#E2C197 0%,#CBA06C 42%,#A97E4D 100%);--apr-fuge:linear-gradient(180deg,#4A3624,#6E543A)}';
  function css(){
    if(document.getElementById('apRahmenCss'))return;
    var s=document.createElement('style'); s.id='apRahmenCss'; s.textContent=CSS; document.head.appendChild(s);
  }
  function kurzCm(){
    try{
      var e=document.querySelector('#ap .ap-size-btn.on .sz-cm'); var t=e?e.textContent:'';
      var m=t.match(/(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/); if(!m)return 40;
      var k=Math.min(parseFloat(m[1].replace(',','.')),parseFloat(m[2].replace(',','.')));
      if(/["″]|in\b/.test(t))k*=2.54;
      return (k>5&&k<300)?k:40;
    }catch(e){return 40;}
  }
  function gerahmt(){ try{ return st && st.material==='framed_canvas'; }catch(e){ return false; } }
  var _sig='';
  window.apRahmenSync=function(nachFit){
    try{
      var ap=document.getElementById('ap'), cv=document.getElementById('apWmCanvas'), pane=document.getElementById('paneVorschau');
      if(!ap||!cv||!pane)return;
      var an=gerahmt()&&cv.width>0;
      var farbe=(st&&(st.farbe==='white'||st.farbe==='wood'))?st.farbe:'black';
      var desk=window.innerWidth>768, sichtbar=pane.offsetWidth>10;
      var sig=[an,farbe,kurzCm(),desk,sichtbar,window.innerWidth,window.innerHeight,cv.width,cv.height].join('|');
      if(!nachFit && sig===_sig)return;
      _sig=sig;
      css();
      ap.classList.toggle('ap-rahmen-an',an);
      ['black','white','wood'].forEach(function(f){ ap.classList.toggle('ap-rahmen-'+f, an&&f===farbe); });
      if(!sichtbar)return;
      var IW=cv.width, IH=cv.height, q=Math.min(1,IH/IW), kc=kurzCm();
      var kF=an?RAHMEN_CM/kc:0, kG=an?FUGE_CM/kc:0, kk=kF+kG, s;
      if(desk){
        /* wie _stageFit, aber Rahmen + Polster mitgerechnet */
        var aw=pane.offsetWidth-(an?PAD_X:0), ah=Math.max(window.innerHeight-290,240)-(an?PAD_Y:0);
        var kurz=Math.min(IW,IH);
        var fs=Math.min(aw/(IW+2*kk*kurz), ah/(IH+2*kk*kurz));
        cv.style.setProperty('width',Math.round(IW*fs)+'px','important');
        cv.style.setProperty('height',Math.round(IH*fs)+'px','important');
        s=Math.min(IW,IH)*fs;
      }else{
        var ww=(cv.parentElement?cv.parentElement.clientWidth:pane.offsetWidth)-(an?PAD_X:0);
        s=(ww/(1+2*kk*q))*q;
      }
      if(!an)return;
      var f=Math.max(5,Math.round(kF*s)), g=Math.max(3,Math.round(kG*s));
      ap.style.setProperty('--apr-f',f+'px'); ap.style.setProperty('--apr-g',g+'px'); ap.style.setProperty('--apr-t',(f+g)+'px');
    }catch(e){}
  };
  var _raf=0;
  function bald(){ if(_raf)return; _raf=requestAnimationFrame(function(){ _raf=0; window.apRahmenSync(false); setTimeout(function(){ window.apRahmenSync(true); },150); }); }
  function start(){
    var ap=document.getElementById('ap'); if(!ap)return;
    try{ new MutationObserver(bald).observe(ap,{subtree:true,attributes:true,attributeFilter:['class']}); }catch(e){}
    window.addEventListener('resize',bald);
    bald();
  }
  if(document.readyState!=='loading')start(); else document.addEventListener('DOMContentLoaded',start);

  /* Wand-Zoom: Mittelpunkt (x,y als Anteil der Bildbreite) je Bundle */
  var ZOOM=1.7, TIEFER=0.06;
  var FOKUS={"framed_canvas_schwarz_wall_hoch_s_03":[0.497,0.245],"framed_canvas_schwarz_wall_hoch_m_03":[0.499,0.293],"framed_canvas_schwarz_wall_hoch_l_03":[0.5,0.3],"framed_canvas_schwarz_wall_quer_s_03":[0.5,0.275],"framed_canvas_schwarz_wall_quer_m_03":[0.501,0.267],"framed_canvas_schwarz_wall_quer_l_03":[0.501,0.271],"framed_canvas_weiss_wall_hoch_s_03":[0.498,0.246],"framed_canvas_weiss_wall_hoch_m_03":[0.658,0.328],"framed_canvas_weiss_wall_hoch_l_03":[0.502,0.337],"framed_canvas_weiss_wall_quer_s_03":[0.5,0.274],"framed_canvas_weiss_wall_quer_m_03":[0.622,0.296],"framed_canvas_weiss_wall_quer_l_03":[0.5,0.274],"framed_canvas_eiche_wall_hoch_s_03":[0.497,0.246],"framed_canvas_eiche_wall_hoch_m_03":[0.501,0.32],"framed_canvas_eiche_wall_hoch_l_03":[0.5,0.272],"framed_canvas_eiche_wall_quer_s_03":[0.5,0.275],"framed_canvas_eiche_wall_quer_m_03":[0.501,0.317],"framed_canvas_eiche_wall_quer_l_03":[0.5,0.282]};
  window.apMockZoomStil=function(key){
    var f=FOKUS[key]; if(!f)return '';
    var v=1/ZOOM, cx=f[0], cy=f[1]+TIEFER;
    var x0=Math.min(Math.max(cx-v/2,0),1-v), y0=Math.min(Math.max(cy-v/2,0),1-v);
    return 'position:absolute;left:'+(-x0*ZOOM*100).toFixed(2)+'%;top:'+(-y0*ZOOM*100).toFixed(2)+'%;width:'+(ZOOM*100).toFixed(0)+'%;height:'+(ZOOM*100).toFixed(0)+'%;max-width:none!important;max-height:none!important;object-fit:contain';
  };
})();
